// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/boxed-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-boxed html, .layout-boxed body {
  height: 100%;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.wrapper {
  min-height: 100%;
  position: relative;
  overflow: hidden;
}

.wrapper:before, .wrapper:after {
  content: " ";
  display: table;
}

.wrapper:after {
  clear: both;
}

.layout-boxed .wrapper {
  max-width: 1250px;
  min-height: 100%;
  margin: 0 auto;
  position: relative;
  box-shadow: 0 0 8px #00000080;
}

.layout-boxed {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) fixed;
}

.content-wrapper, .right-side, .main-footer {
  z-index: 820;
  margin-left: 230px;
  transition: transform .3s ease-in-out, margin .3s ease-in-out;
}

.layout-top-nav .content-wrapper, .layout-top-nav .right-side, .layout-top-nav .main-footer {
  margin-left: 0;
}

@media (width <= 767px) {
  .content-wrapper, .right-side, .main-footer {
    margin-left: 0;
  }
}

@media (width >= 768px) {
  .sidebar-collapse .content-wrapper, .sidebar-collapse .right-side, .sidebar-collapse .main-footer {
    margin-left: 0;
  }
}

@media (width <= 767px) {
  .sidebar-open .content-wrapper, .sidebar-open .right-side, .sidebar-open .main-footer {
    transform: translate(230px);
  }
}

.content-wrapper, .right-side {
  z-index: 800;
  background-color: #ecf0f5;
  min-height: 100%;
}

.main-footer {
  color: #444;
  background: #fff;
  border-top: 1px solid #d2d6de;
  padding: 15px;
}

.fixed .main-header, .fixed .main-sidebar, .fixed .left-side {
  position: fixed;
}

.fixed .main-header {
  top: 0;
  left: 0;
  right: 0;
}

.fixed .content-wrapper, .fixed .right-side {
  padding-top: 50px;
}

@media (width <= 767px) {
  .fixed .content-wrapper, .fixed .right-side {
    padding-top: 100px;
  }
}

.fixed.layout-boxed .wrapper {
  max-width: 100%;
}

body.hold-transition .content-wrapper, body.hold-transition .right-side, body.hold-transition .main-footer, body.hold-transition .main-sidebar, body.hold-transition .left-side, body.hold-transition .main-header > .navbar, body.hold-transition .main-header .logo {
  transition: none;
}

.content {
  min-height: 250px;
  margin-left: auto;
  margin-right: auto;
  padding: 15px;
}

a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
}

.page-header {
  margin: 10px 0 20px;
  font-size: 22px;
}

.page-header > small {
  color: #666;
  margin-top: 5px;
  display: block;
}

.main-header {
  z-index: 1030;
  max-height: 100px;
  position: relative;
}

.main-header > .navbar {
  border: none;
  border-radius: 0;
  min-height: 50px;
  margin-bottom: 0;
  margin-left: 230px;
  transition: margin-left .3s ease-in-out;
}

.layout-top-nav .main-header > .navbar {
  margin-left: 0;
}

.main-header #navbar-search-input.form-control {
  background: #fff3;
  border-color: #fff0;
}

.main-header #navbar-search-input.form-control:focus, .main-header #navbar-search-input.form-control:active {
  background: #ffffffe6;
  border-color: #0000001a;
}

.main-header #navbar-search-input.form-control::-moz-placeholder {
  color: #ccc;
  opacity: 1;
}

.main-header #navbar-search-input.form-control:-ms-placeholder-shown {
  color: #ccc;
}

.main-header #navbar-search-input.form-control::-webkit-input-placeholder {
  color: #ccc;
}

.main-header .navbar-custom-menu, .main-header .navbar-right {
  float: right;
}

@media (width <= 991px) {
  .main-header .navbar-custom-menu a, .main-header .navbar-right a {
    color: inherit;
    background: #fff0;
  }
}

.main-header .navbar .nav > li.user > a > .fa, .main-header .navbar .nav > li.user > a > .glyphicon, .main-header .navbar .nav > li.user > a > .ion {
  margin-right: 5px;
}

.main-header .navbar .nav > li > a > .label {
  text-align: center;
  padding: 2px 3px;
  font-size: 9px;
  line-height: .9;
  position: absolute;
  top: 9px;
  right: 7px;
}

.main-header .logo {
  float: left;
  text-align: center;
  width: 230px;
  height: 50px;
  padding: 0 15px;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: 300;
  line-height: 50px;
  transition: width .3s ease-in-out;
  display: block;
  overflow: hidden;
}

.main-header .logo .logo-lg {
  display: block;
}

.main-header .logo .logo-mini {
  display: none;
}

.main-header .navbar-brand {
  color: #fff;
}

.content-header {
  padding: 15px 15px 0;
  position: relative;
}

.content-header > h1 {
  margin: 0;
  font-size: 24px;
}

.content-header > h1 > small {
  padding-left: 4px;
  font-size: 15px;
  font-weight: 300;
  display: inline-block;
}

.content-header > .breadcrumb {
  float: right;
  background: #fff0;
  border-radius: 2px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 7px 5px;
  font-size: 12px;
  position: absolute;
  top: 15px;
  right: 10px;
}

.content-header > .breadcrumb > li > a {
  color: #444;
  text-decoration: none;
  display: inline-block;
}

.content-header > .breadcrumb > li > a > .fa, .content-header > .breadcrumb > li > a > .glyphicon, .content-header > .breadcrumb > li > a > .ion {
  margin-right: 5px;
}

.content-header > .breadcrumb > li + li:before {
  content: "> ";
}

@media (width <= 991px) {
  .content-header > .breadcrumb {
    float: none;
    background: #d2d6de;
    margin-top: 5px;
    padding-left: 10px;
    position: relative;
    top: 0;
    right: 0;
  }

  .content-header > .breadcrumb li:before {
    color: #97a0b3;
  }
}

.navbar-toggle {
  color: #fff;
  border: 0;
  margin: 0;
  padding: 15px;
}

@media (width <= 991px) {
  .navbar-custom-menu .navbar-nav > li {
    float: left;
  }

  .navbar-custom-menu .navbar-nav {
    float: left;
    margin: 0;
  }

  .navbar-custom-menu .navbar-nav > li > a {
    padding-top: 15px;
    padding-bottom: 15px;
    line-height: 20px;
  }

  .navbar-collapse.pull-left {
    float: none !important;
  }

  .navbar-collapse.pull-left + .navbar-custom-menu {
    display: block;
    position: absolute;
    top: 0;
    right: 40px;
  }
}

.main-sidebar, .left-side {
  z-index: 810;
  width: 230px;
  min-height: 100%;
  padding-top: 50px;
  transition: transform .3s ease-in-out, width .3s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
}

@media (width <= 767px) {
  .main-sidebar, .left-side {
    padding-top: 100px;
    transform: translate(-230px);
  }
}

@media (width >= 768px) {
  .sidebar-collapse .main-sidebar, .sidebar-collapse .left-side {
    transform: translate(-230px);
  }
}

@media (width <= 767px) {
  .sidebar-open .main-sidebar, .sidebar-open .left-side {
    transform: translate(0);
  }
}

.sidebar {
  padding-bottom: 10px;
}

.sidebar-form input:focus {
  border-color: #fff0;
}

.user-panel {
  width: 100%;
  padding: 10px;
  position: relative;
  overflow: hidden;
}

.user-panel:before, .user-panel:after {
  content: " ";
  display: table;
}

.user-panel:after {
  clear: both;
}

.user-panel > .image > img {
  width: 100%;
  max-width: 45px;
  height: auto;
}

.user-panel > .info {
  padding: 5px 5px 5px 15px;
  line-height: 1;
  position: absolute;
  left: 55px;
}

.user-panel > .info > p {
  margin-bottom: 9px;
  font-weight: 600;
}

.user-panel > .info > a {
  margin-top: 3px;
  padding-right: 5px;
  font-size: 11px;
  text-decoration: none;
}

.user-panel > .info > a > .fa, .user-panel > .info > a > .ion, .user-panel > .info > a > .glyphicon {
  margin-right: 3px;
}

.sidebar-menu {
  margin: 0;
  padding: 0;
  list-style: none;
}

.sidebar-menu > li {
  margin: 0;
  padding: 0;
  position: relative;
}

.sidebar-menu > li > a {
  padding: 12px 5px 12px 15px;
  display: block;
}

.sidebar-menu > li > a > .fa, .sidebar-menu > li > a > .glyphicon, .sidebar-menu > li > a > .ion {
  width: 20px;
}

.sidebar-menu > li .label, .sidebar-menu > li .badge {
  margin-top: 3px;
  margin-right: 5px;
}

.sidebar-menu li.header {
  padding: 10px 25px 10px 15px;
  font-size: 12px;
}

.sidebar-menu li > a > .fa-angle-left {
  width: auto;
  height: auto;
  margin-top: 3px;
  margin-right: 10px;
  padding: 0;
}

.sidebar-menu li.active > a > .fa-angle-left {
  transform: rotate(-90deg);
}

.sidebar-menu li.active > .treeview-menu {
  display: block;
}

.sidebar-menu .treeview-menu {
  margin: 0;
  padding: 0 0 0 5px;
  list-style: none;
  display: none;
}

.sidebar-menu .treeview-menu .treeview-menu {
  padding-left: 20px;
}

.sidebar-menu .treeview-menu > li {
  margin: 0;
}

.sidebar-menu .treeview-menu > li > a {
  padding: 5px 5px 5px 15px;
  font-size: 14px;
  display: block;
}

.sidebar-menu .treeview-menu > li > a > .fa, .sidebar-menu .treeview-menu > li > a > .glyphicon, .sidebar-menu .treeview-menu > li > a > .ion {
  width: 20px;
}

.sidebar-menu .treeview-menu > li > a > .fa-angle-left, .sidebar-menu .treeview-menu > li > a > .fa-angle-down {
  width: auto;
}

@media (width >= 768px) {
  .sidebar-mini.sidebar-collapse .content-wrapper, .sidebar-mini.sidebar-collapse .right-side, .sidebar-mini.sidebar-collapse .main-footer {
    z-index: 840;
    margin-left: 50px !important;
  }

  .sidebar-mini.sidebar-collapse .main-sidebar {
    z-index: 850;
    transform: translate(0);
    width: 50px !important;
  }

  .sidebar-mini.sidebar-collapse .sidebar-menu > li {
    position: relative;
  }

  .sidebar-mini.sidebar-collapse .sidebar-menu > li > a {
    margin-right: 0;
  }

  .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > span {
    border-top-right-radius: 4px;
  }

  .sidebar-mini.sidebar-collapse .sidebar-menu > li:not(.treeview) > a > span {
    border-bottom-right-radius: 4px;
  }

  .sidebar-mini.sidebar-collapse .sidebar-menu > li > .treeview-menu {
    border-bottom-right-radius: 4px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > a > span:not(.pull-right), .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {
    width: 180px;
    position: absolute;
    left: 50px;
    display: block !important;
  }

  .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > a > span {
    background-color: inherit;
    margin-left: -3px;
    padding: 12px 5px 12px 20px;
    top: 0;
  }

  .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {
    margin-left: 0;
    top: 44px;
  }

  .sidebar-mini.sidebar-collapse .main-sidebar .user-panel > .info, .sidebar-mini.sidebar-collapse .sidebar-form, .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > span, .sidebar-mini.sidebar-collapse .sidebar-menu > li > .treeview-menu, .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > .pull-right, .sidebar-mini.sidebar-collapse .sidebar-menu li.header {
    -webkit-transform: translateZ(0);
    display: none !important;
  }

  .sidebar-mini.sidebar-collapse .main-header .logo {
    width: 50px;
  }

  .sidebar-mini.sidebar-collapse .main-header .logo > .logo-mini {
    margin-left: -15px;
    margin-right: -15px;
    font-size: 18px;
    display: block;
  }

  .sidebar-mini.sidebar-collapse .main-header .logo > .logo-lg {
    display: none;
  }

  .sidebar-mini.sidebar-collapse .main-header .navbar {
    margin-left: 50px;
  }
}

.sidebar-menu, .main-sidebar .user-panel, .sidebar-menu > li.header {
  white-space: nowrap;
  overflow: hidden;
}

.sidebar-menu:hover {
  overflow: visible;
}

.sidebar-form, .sidebar-menu > li.header {
  text-overflow: clip;
  overflow: hidden;
}

.sidebar-menu li > a {
  position: relative;
}

.sidebar-menu li > a > .pull-right {
  margin-top: -7px;
  position: absolute;
  top: 50%;
  right: 10px;
}

.control-sidebar-bg {
  z-index: 1000;
  position: fixed;
  bottom: 0;
}

.control-sidebar-bg, .control-sidebar {
  width: 230px;
  transition: right .3s ease-in-out;
  top: 0;
  right: -230px;
}

.control-sidebar {
  z-index: 1010;
  padding-top: 50px;
  position: absolute;
}

@media (width <= 768px) {
  .control-sidebar {
    padding-top: 100px;
  }
}

.control-sidebar > .tab-content {
  padding: 10px 15px;
}

.control-sidebar.control-sidebar-open, .control-sidebar.control-sidebar-open + .control-sidebar-bg, .control-sidebar-open .control-sidebar-bg, .control-sidebar-open .control-sidebar {
  right: 0;
}

@media (width >= 768px) {
  .control-sidebar-open .content-wrapper, .control-sidebar-open .right-side, .control-sidebar-open .main-footer {
    margin-right: 230px;
  }
}

.nav-tabs.control-sidebar-tabs > li:first-of-type > a, .nav-tabs.control-sidebar-tabs > li:first-of-type > a:hover, .nav-tabs.control-sidebar-tabs > li:first-of-type > a:focus {
  border-left-width: 0;
}

.nav-tabs.control-sidebar-tabs > li > a {
  border-radius: 0;
}

.nav-tabs.control-sidebar-tabs > li > a, .nav-tabs.control-sidebar-tabs > li > a:hover {
  border-top: none;
  border-bottom: 1px solid #fff0;
  border-left: 1px solid #fff0;
  border-right: none;
}

.nav-tabs.control-sidebar-tabs > li > a .icon {
  font-size: 16px;
}

.nav-tabs.control-sidebar-tabs > li.active > a, .nav-tabs.control-sidebar-tabs > li.active > a:hover, .nav-tabs.control-sidebar-tabs > li.active > a:focus, .nav-tabs.control-sidebar-tabs > li.active > a:active {
  border-top: none;
  border-bottom: none;
  border-right: none;
}

@media (width <= 768px) {
  .nav-tabs.control-sidebar-tabs {
    display: table;
  }

  .nav-tabs.control-sidebar-tabs > li {
    display: table-cell;
  }
}

.control-sidebar-heading {
  margin-bottom: 10px;
  padding: 10px 0;
  font-size: 16px;
  font-weight: 400;
}

.control-sidebar-subheading {
  font-size: 14px;
  font-weight: 400;
  display: block;
}

.control-sidebar-menu {
  margin: 0 -15px;
  padding: 0;
  list-style: none;
}

.control-sidebar-menu > li > a {
  padding: 10px 15px;
  display: block;
}

.control-sidebar-menu > li > a:before, .control-sidebar-menu > li > a:after {
  content: " ";
  display: table;
}

.control-sidebar-menu > li > a:after {
  clear: both;
}

.control-sidebar-menu > li > a > .control-sidebar-subheading {
  margin-top: 0;
}

.control-sidebar-menu .menu-icon {
  float: left;
  text-align: center;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  line-height: 35px;
}

.control-sidebar-menu .menu-info {
  margin-top: 3px;
  margin-left: 45px;
}

.control-sidebar-menu .menu-info > .control-sidebar-subheading {
  margin: 0;
}

.control-sidebar-menu .menu-info > p {
  margin: 0;
  font-size: 11px;
}

.control-sidebar-menu .progress {
  margin: 0;
}

.control-sidebar-dark {
  color: #b8c7ce;
}

.control-sidebar-dark, .control-sidebar-dark + .control-sidebar-bg {
  background: #222d32;
}

.control-sidebar-dark .nav-tabs.control-sidebar-tabs {
  border-bottom: #1c2529;
}

.control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a {
  color: #b8c7ce;
  background: #181f23;
}

.control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:focus {
  border-bottom-color: #141a1d;
  border-left-color: #141a1d;
}

.control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:focus, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:active {
  background: #1c2529;
}

.control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover {
  color: #fff;
}

.control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:hover, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:focus, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:active {
  color: #fff;
  background: #222d32;
}

.control-sidebar-dark .control-sidebar-heading, .control-sidebar-dark .control-sidebar-subheading {
  color: #fff;
}

.control-sidebar-dark .control-sidebar-menu > li > a:hover {
  background: #1e282c;
}

.control-sidebar-dark .control-sidebar-menu > li > a .menu-info > p {
  color: #b8c7ce;
}

.control-sidebar-light {
  color: #5e5e5e;
}

.control-sidebar-light, .control-sidebar-light + .control-sidebar-bg {
  background: #f9fafc;
  border-left: 1px solid #d2d6de;
}

.control-sidebar-light .nav-tabs.control-sidebar-tabs {
  border-bottom: #d2d6de;
}

.control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a {
  color: #444;
  background: #e8ecf4;
}

.control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:hover, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:focus {
  border-bottom-color: #d2d6de;
  border-left-color: #d2d6de;
}

.control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:hover, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:focus, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:active {
  background: #eff1f7;
}

.control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:hover, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:focus, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:active {
  color: #111;
  background: #f9fafc;
}

.control-sidebar-light .control-sidebar-heading, .control-sidebar-light .control-sidebar-subheading {
  color: #111;
}

.control-sidebar-light .control-sidebar-menu {
  margin-left: -14px;
}

.control-sidebar-light .control-sidebar-menu > li > a:hover {
  background: #f4f4f5;
}

.control-sidebar-light .control-sidebar-menu > li > a .menu-info > p {
  color: #5e5e5e;
}

.dropdown-menu {
  box-shadow: none;
  border-color: #eee;
}

.dropdown-menu > li > a {
  color: #777;
}

.dropdown-menu > li > a > .glyphicon, .dropdown-menu > li > a > .fa, .dropdown-menu > li > a > .ion {
  margin-right: 10px;
}

.dropdown-menu > li > a:hover {
  color: #333;
  background-color: #e1e3e9;
}

.dropdown-menu > .divider {
  background-color: #eee;
}

.navbar-nav > .notifications-menu > .dropdown-menu, .navbar-nav > .messages-menu > .dropdown-menu, .navbar-nav > .tasks-menu > .dropdown-menu {
  width: 280px;
  margin: 0;
  padding: 0;
  top: 100%;
}

.navbar-nav > .notifications-menu > .dropdown-menu > li, .navbar-nav > .messages-menu > .dropdown-menu > li, .navbar-nav > .tasks-menu > .dropdown-menu > li {
  position: relative;
}

.navbar-nav > .notifications-menu > .dropdown-menu > li.header, .navbar-nav > .messages-menu > .dropdown-menu > li.header, .navbar-nav > .tasks-menu > .dropdown-menu > li.header {
  color: #444;
  background-color: #fff;
  border-bottom: 1px solid #f4f4f4;
  border-radius: 4px 4px 0 0;
  padding: 7px 10px;
  font-size: 14px;
}

.navbar-nav > .notifications-menu > .dropdown-menu > li.footer > a, .navbar-nav > .messages-menu > .dropdown-menu > li.footer > a, .navbar-nav > .tasks-menu > .dropdown-menu > li.footer > a {
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  border-radius: 0 0 4px 4px;
  padding: 7px 10px;
  font-size: 12px;
  color: #444 !important;
}

.navbar-nav > .notifications-menu > .dropdown-menu > li.footer > a:hover, .navbar-nav > .messages-menu > .dropdown-menu > li.footer > a:hover, .navbar-nav > .tasks-menu > .dropdown-menu > li.footer > a:hover {
  font-weight: 400;
  text-decoration: none;
}

.navbar-nav > .notifications-menu > .dropdown-menu > li .menu, .navbar-nav > .messages-menu > .dropdown-menu > li .menu, .navbar-nav > .tasks-menu > .dropdown-menu > li .menu {
  max-height: 200px;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-x: hidden;
}

.navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a, .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a, .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a {
  white-space: nowrap;
  border-bottom: 1px solid #f4f4f4;
  display: block;
}

.navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a:hover, .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:hover, .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a:hover {
  background: #f4f4f4;
  text-decoration: none;
}

.navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a {
  color: #444;
  text-overflow: ellipsis;
  padding: 10px;
  overflow: hidden;
}

.navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .glyphicon, .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .fa, .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .ion {
  width: 20px;
}

.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a {
  margin: 0;
  padding: 10px;
}

.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > div > img {
  width: 40px;
  height: 40px;
  margin: auto 10px auto auto;
}

.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > h4 {
  color: #444;
  margin: 0 0 0 45px;
  padding: 0;
  font-size: 15px;
  position: relative;
}

.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > h4 > small {
  color: #999;
  font-size: 10px;
  position: absolute;
  top: 0;
  right: 0;
}

.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > p {
  color: #888;
  margin: 0 0 0 45px;
  font-size: 12px;
}

.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:before, .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:after {
  content: " ";
  display: table;
}

.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:after {
  clear: both;
}

.navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a {
  padding: 10px;
}

.navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a > h3 {
  color: #666;
  margin: 0 0 10px;
  padding: 0;
  font-size: 14px;
}

.navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a > .progress {
  margin: 0;
  padding: 0;
}

.navbar-nav > .user-menu > .dropdown-menu {
  border-top-width: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  width: 280px;
  padding: 1px 0 0;
}

.navbar-nav > .user-menu > .dropdown-menu, .navbar-nav > .user-menu > .dropdown-menu > .user-body {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.navbar-nav > .user-menu > .dropdown-menu > li.user-header {
  text-align: center;
  height: 175px;
  padding: 10px;
}

.navbar-nav > .user-menu > .dropdown-menu > li.user-header > img {
  z-index: 5;
  border: 3px solid #fff3;
  width: 90px;
  height: 90px;
}

.navbar-nav > .user-menu > .dropdown-menu > li.user-header > p {
  z-index: 5;
  color: #fffc;
  margin-top: 10px;
  font-size: 17px;
}

.navbar-nav > .user-menu > .dropdown-menu > li.user-header > p > small {
  font-size: 12px;
  display: block;
}

.navbar-nav > .user-menu > .dropdown-menu > .user-body {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #f4f4f4;
  padding: 15px;
}

.navbar-nav > .user-menu > .dropdown-menu > .user-body:before, .navbar-nav > .user-menu > .dropdown-menu > .user-body:after {
  content: " ";
  display: table;
}

.navbar-nav > .user-menu > .dropdown-menu > .user-body:after {
  clear: both;
}

.navbar-nav > .user-menu > .dropdown-menu > .user-body a {
  color: #444 !important;
}

@media (width <= 991px) {
  .navbar-nav > .user-menu > .dropdown-menu > .user-body a {
    color: #444 !important;
    background: #fff !important;
  }
}

.navbar-nav > .user-menu > .dropdown-menu > .user-footer {
  background-color: #f9f9f9;
  padding: 10px;
}

.navbar-nav > .user-menu > .dropdown-menu > .user-footer:before, .navbar-nav > .user-menu > .dropdown-menu > .user-footer:after {
  content: " ";
  display: table;
}

.navbar-nav > .user-menu > .dropdown-menu > .user-footer:after {
  clear: both;
}

.navbar-nav > .user-menu > .dropdown-menu > .user-footer .btn-default {
  color: #666;
}

.navbar-nav > .user-menu .user-image {
  float: left;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  margin-top: -2px;
  margin-right: 10px;
}

.open:not(.dropup) > .animated-dropdown-menu {
  animation: .7s both flipInX;
  backface-visibility: visible !important;
}

@keyframes flipInX {
  0% {
    opacity: 0;
    transition-timing-function: ease-in;
    transform: perspective(400px)rotate3d(1, 0, 0, 90deg);
  }

  40% {
    transition-timing-function: ease-in;
    transform: perspective(400px)rotate3d(1, 0, 0, -20deg);
  }

  60% {
    opacity: 1;
    transform: perspective(400px)rotate3d(1, 0, 0, 10deg);
  }

  80% {
    transform: perspective(400px)rotate3d(1, 0, 0, -5deg);
  }

  100% {
    transform: perspective(400px);
  }
}

.navbar-custom-menu > .navbar-nav > li {
  position: relative;
}

.navbar-custom-menu > .navbar-nav > li > .dropdown-menu {
  position: absolute;
  left: auto;
  right: 0;
}

.form-control {
  box-shadow: none;
  border-color: #d2d6de;
  border-radius: 0;
}

.form-control:focus {
  box-shadow: none;
  border-color: #3c8dbc;
}

.form-control::-moz-placeholder, .form-control:-ms-placeholder-shown, .form-control::-webkit-input-placeholder {
  color: #bbb;
  opacity: 1;
}

.form-control:not(select) {
  appearance: none;
}

.form-group.has-success label {
  color: #00a65a;
}

.form-group.has-success .form-control {
  box-shadow: none;
  border-color: #00a65a;
}

.form-group.has-success .help-block {
  color: #00a65a;
}

.form-group.has-warning label {
  color: #f39c12;
}

.form-group.has-warning .form-control {
  box-shadow: none;
  border-color: #f39c12;
}

.form-group.has-warning .help-block {
  color: #f39c12;
}

.form-group.has-error label {
  color: #dd4b39;
}

.form-group.has-error .form-control {
  box-shadow: none;
  border-color: #dd4b39;
}

.form-group.has-error .help-block {
  color: #dd4b39;
}

.input-group .input-group-addon {
  background-color: #fff;
  border-color: #d2d6de;
  border-radius: 0;
}

.btn-group-vertical .btn.btn-flat:first-of-type, .btn-group-vertical .btn.btn-flat:last-of-type {
  border-radius: 0;
}

.icheck > label {
  padding-left: 0;
}

.form-control-feedback.fa {
  line-height: 34px;
}

.input-lg + .form-control-feedback.fa, .input-group-lg + .form-control-feedback.fa, .form-group-lg .form-control + .form-control-feedback.fa {
  line-height: 46px;
}

.input-sm + .form-control-feedback.fa, .input-group-sm + .form-control-feedback.fa, .form-group-sm .form-control + .form-control-feedback.fa {
  line-height: 30px;
}

.progress, .progress > .progress-bar {
  box-shadow: none;
}

.progress, .progress > .progress-bar, .progress .progress-bar, .progress > .progress-bar .progress-bar {
  border-radius: 1px;
}

.progress.sm, .progress-sm {
  height: 10px;
}

.progress.sm, .progress-sm, .progress.sm .progress-bar, .progress-sm .progress-bar {
  border-radius: 1px;
}

.progress.xs, .progress-xs {
  height: 7px;
}

.progress.xs, .progress-xs, .progress.xs .progress-bar, .progress-xs .progress-bar {
  border-radius: 1px;
}

.progress.xxs, .progress-xxs {
  height: 3px;
}

.progress.xxs, .progress-xxs, .progress.xxs .progress-bar, .progress-xxs .progress-bar {
  border-radius: 1px;
}

.progress.vertical {
  width: 30px;
  height: 200px;
  margin-right: 10px;
  display: inline-block;
  position: relative;
}

.progress.vertical > .progress-bar {
  width: 100%;
  position: absolute;
  bottom: 0;
}

.progress.vertical.sm, .progress.vertical.progress-sm {
  width: 20px;
}

.progress.vertical.xs, .progress.vertical.progress-xs {
  width: 10px;
}

.progress.vertical.xxs, .progress.vertical.progress-xxs {
  width: 3px;
}

.progress-group .progress-text {
  font-weight: 600;
}

.progress-group .progress-number {
  float: right;
}

.table tr > td .progress {
  margin: 0;
}

.progress-bar-light-blue, .progress-bar-primary {
  background-color: #3c8dbc;
}

.progress-striped .progress-bar-light-blue, .progress-striped .progress-bar-primary {
  background-image: linear-gradient(45deg, #ffffff26 25%, #0000 25% 50%, #ffffff26 50% 75%, #0000 75%, #0000);
}

.progress-bar-green, .progress-bar-success {
  background-color: #00a65a;
}

.progress-striped .progress-bar-green, .progress-striped .progress-bar-success {
  background-image: linear-gradient(45deg, #ffffff26 25%, #0000 25% 50%, #ffffff26 50% 75%, #0000 75%, #0000);
}

.progress-bar-aqua, .progress-bar-info {
  background-color: #00c0ef;
}

.progress-striped .progress-bar-aqua, .progress-striped .progress-bar-info {
  background-image: linear-gradient(45deg, #ffffff26 25%, #0000 25% 50%, #ffffff26 50% 75%, #0000 75%, #0000);
}

.progress-bar-yellow, .progress-bar-warning {
  background-color: #f39c12;
}

.progress-striped .progress-bar-yellow, .progress-striped .progress-bar-warning {
  background-image: linear-gradient(45deg, #ffffff26 25%, #0000 25% 50%, #ffffff26 50% 75%, #0000 75%, #0000);
}

.progress-bar-red, .progress-bar-danger {
  background-color: #dd4b39;
}

.progress-striped .progress-bar-red, .progress-striped .progress-bar-danger {
  background-image: linear-gradient(45deg, #ffffff26 25%, #0000 25% 50%, #ffffff26 50% 75%, #0000 75%, #0000);
}

.small-box {
  border-radius: 2px;
  margin-bottom: 20px;
  display: block;
  position: relative;
  box-shadow: 0 1px 1px #0000001a;
}

.small-box > .inner {
  padding: 10px;
}

.small-box > .small-box-footer {
  text-align: center;
  color: #fffc;
  z-index: 10;
  background: #0000001a;
  padding: 3px 0;
  text-decoration: none;
  display: block;
  position: relative;
}

.small-box > .small-box-footer:hover {
  color: #fff;
  background: #00000026;
}

.small-box h3 {
  white-space: nowrap;
  margin: 0 0 10px;
  padding: 0;
  font-size: 38px;
  font-weight: 700;
}

.small-box p {
  font-size: 15px;
}

.small-box p > small {
  color: #f9f9f9;
  margin-top: 5px;
  font-size: 13px;
  display: block;
}

.small-box h3, .small-box p {
  z-index: 5;
}

.small-box .icon {
  z-index: 0;
  color: #00000026;
  font-size: 90px;
  transition: all .3s linear;
  position: absolute;
  top: -10px;
  right: 10px;
}

.small-box:hover {
  color: #f9f9f9;
  text-decoration: none;
}

.small-box:hover .icon {
  font-size: 95px;
}

@media (width <= 767px) {
  .small-box {
    text-align: center;
  }

  .small-box .icon {
    display: none;
  }

  .small-box p {
    font-size: 12px;
  }
}

.box {
  background: #fff;
  border-top: 3px solid #d2d6de;
  border-radius: 3px;
  width: 100%;
  margin-bottom: 20px;
  position: relative;
  box-shadow: 0 1px 1px #0000001a;
}

.box.box-primary {
  border-top-color: #3c8dbc;
}

.box.box-info {
  border-top-color: #00c0ef;
}

.box.box-danger {
  border-top-color: #dd4b39;
}

.box.box-warning {
  border-top-color: #f39c12;
}

.box.box-success {
  border-top-color: #00a65a;
}

.box.box-default {
  border-top-color: #d2d6de;
}

.box.collapsed-box .box-body, .box.collapsed-box .box-footer {
  display: none;
}

.box .nav-stacked > li {
  border-bottom: 1px solid #f4f4f4;
  margin: 0;
}

.box .nav-stacked > li:last-of-type {
  border-bottom: none;
}

.box.height-control .box-body {
  max-height: 300px;
  overflow: auto;
}

.box .border-right {
  border-right: 1px solid #f4f4f4;
}

.box .border-left {
  border-left: 1px solid #f4f4f4;
}

.box.box-solid {
  border-top: 0;
}

.box.box-solid > .box-header .btn.btn-default {
  background: #fff0;
}

.box.box-solid > .box-header .btn:hover, .box.box-solid > .box-header a:hover {
  background: #0000001a;
}

.box.box-solid.box-default {
  border: 1px solid #d2d6de;
}

.box.box-solid.box-default > .box-header {
  color: #444;
  background: #d2d6de;
}

.box.box-solid.box-default > .box-header a, .box.box-solid.box-default > .box-header .btn {
  color: #444;
}

.box.box-solid.box-primary {
  border: 1px solid #3c8dbc;
}

.box.box-solid.box-primary > .box-header {
  color: #fff;
  background: #3c8dbc;
}

.box.box-solid.box-primary > .box-header a, .box.box-solid.box-primary > .box-header .btn {
  color: #fff;
}

.box.box-solid.box-info {
  border: 1px solid #00c0ef;
}

.box.box-solid.box-info > .box-header {
  color: #fff;
  background: #00c0ef;
}

.box.box-solid.box-info > .box-header a, .box.box-solid.box-info > .box-header .btn {
  color: #fff;
}

.box.box-solid.box-danger {
  border: 1px solid #dd4b39;
}

.box.box-solid.box-danger > .box-header {
  color: #fff;
  background: #dd4b39;
}

.box.box-solid.box-danger > .box-header a, .box.box-solid.box-danger > .box-header .btn {
  color: #fff;
}

.box.box-solid.box-warning {
  border: 1px solid #f39c12;
}

.box.box-solid.box-warning > .box-header {
  color: #fff;
  background: #f39c12;
}

.box.box-solid.box-warning > .box-header a, .box.box-solid.box-warning > .box-header .btn {
  color: #fff;
}

.box.box-solid.box-success {
  border: 1px solid #00a65a;
}

.box.box-solid.box-success > .box-header {
  color: #fff;
  background: #00a65a;
}

.box.box-solid.box-success > .box-header a, .box.box-solid.box-success > .box-header .btn {
  color: #fff;
}

.box.box-solid > .box-header > .box-tools .btn {
  box-shadow: none;
  border: 0;
}

.box.box-solid[class*="bg"] > .box-header {
  color: #fff;
}

.box .box-group > .box {
  margin-bottom: 5px;
}

.box .knob-label {
  text-align: center;
  color: #333;
  margin-bottom: .3em;
  font-size: 12px;
  font-weight: 100;
}

.box > .overlay, .overlay-wrapper > .overlay, .box > .loading-img, .overlay-wrapper > .loading-img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.box .overlay, .overlay-wrapper .overlay {
  z-index: 50;
  background: #ffffffb3;
  border-radius: 3px;
}

.box .overlay > .fa, .overlay-wrapper .overlay > .fa {
  color: #000;
  margin-top: -15px;
  margin-left: -15px;
  font-size: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
}

.box .overlay.dark, .overlay-wrapper .overlay.dark {
  background: #00000080;
}

.box-header:before, .box-body:before, .box-footer:before, .box-header:after, .box-body:after, .box-footer:after {
  content: " ";
  display: table;
}

.box-header:after, .box-body:after, .box-footer:after {
  clear: both;
}

.box-header {
  color: #444;
  padding: 10px;
  display: block;
  position: relative;
}

.box-header.with-border {
  border-bottom: 1px solid #f4f4f4;
}

.collapsed-box .box-header.with-border {
  border-bottom: none;
}

.box-header > .fa, .box-header > .glyphicon, .box-header > .ion, .box-header .box-title {
  margin: 0;
  font-size: 18px;
  line-height: 1;
  display: inline-block;
}

.box-header > .fa, .box-header > .glyphicon, .box-header > .ion {
  margin-right: 5px;
}

.box-header > .box-tools {
  position: absolute;
  top: 5px;
  right: 10px;
}

.box-header > .box-tools [data-toggle="tooltip"] {
  position: relative;
}

.box-header > .box-tools.pull-right .dropdown-menu {
  left: auto;
  right: 0;
}

.btn-box-tool {
  color: #97a0b3;
  background: #fff0;
  padding: 5px;
  font-size: 12px;
}

.open .btn-box-tool, .btn-box-tool:hover {
  color: #606c84;
}

.btn-box-tool.btn:active {
  box-shadow: none;
}

.box-body {
  border-radius: 0 0 3px 3px;
  padding: 10px;
}

.no-header .box-body {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.box-body > .table {
  margin-bottom: 0;
}

.box-body .fc {
  margin-top: 5px;
}

.box-body .full-width-chart {
  margin: -19px;
}

.box-body.no-padding .full-width-chart {
  margin: -9px;
}

.box-body .box-pane {
  border-radius: 0 0 0 3px;
}

.box-body .box-pane-right {
  border-radius: 0 0 3px;
}

.box-footer {
  background-color: #fff;
  border-top: 1px solid #f4f4f4;
  border-radius: 0 0 3px 3px;
  padding: 10px;
}

.chart-legend {
  margin: 10px 0;
}

@media (width <= 991px) {
  .chart-legend > li {
    float: left;
    margin-right: 10px;
  }
}

.box-comments {
  background: #f7f7f7;
}

.box-comments .box-comment {
  border-bottom: 1px solid #eee;
  padding: 8px 0;
}

.box-comments .box-comment:before, .box-comments .box-comment:after {
  content: " ";
  display: table;
}

.box-comments .box-comment:after {
  clear: both;
}

.box-comments .box-comment:last-of-type {
  border-bottom: 0;
}

.box-comments .box-comment:first-of-type {
  padding-top: 0;
}

.box-comments .box-comment img {
  float: left;
}

.box-comments .comment-text {
  color: #555;
  margin-left: 40px;
}

.box-comments .username {
  color: #444;
  font-weight: 600;
  display: block;
}

.box-comments .text-muted {
  font-size: 12px;
  font-weight: 400;
}

.todo-list {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: auto;
}

.todo-list > li {
  color: #444;
  background: #f4f4f4;
  border-left: 2px solid #e6e7e8;
  border-radius: 2px;
  margin-bottom: 2px;
  padding: 10px;
}

.todo-list > li:last-of-type {
  margin-bottom: 0;
}

.todo-list > li > input[type="checkbox"] {
  margin: 0 10px 0 5px;
}

.todo-list > li .text {
  margin-left: 5px;
  font-weight: 600;
  display: inline-block;
}

.todo-list > li .label {
  margin-left: 10px;
  font-size: 9px;
}

.todo-list > li .tools {
  float: right;
  color: #dd4b39;
  display: none;
}

.todo-list > li .tools > .fa, .todo-list > li .tools > .glyphicon, .todo-list > li .tools > .ion {
  cursor: pointer;
  margin-right: 5px;
}

.todo-list > li:hover .tools {
  display: inline-block;
}

.todo-list > li.done {
  color: #999;
}

.todo-list > li.done .text {
  font-weight: 500;
  text-decoration: line-through;
}

.todo-list > li.done .label {
  background: #d2d6de !important;
}

.todo-list .danger {
  border-left-color: #dd4b39;
}

.todo-list .warning {
  border-left-color: #f39c12;
}

.todo-list .info {
  border-left-color: #00c0ef;
}

.todo-list .success {
  border-left-color: #00a65a;
}

.todo-list .primary {
  border-left-color: #3c8dbc;
}

.todo-list .handle {
  cursor: move;
  margin: 0 5px;
  display: inline-block;
}

.chat {
  padding: 5px 20px 5px 10px;
}

.chat .item {
  margin-bottom: 10px;
}

.chat .item:before, .chat .item:after {
  content: " ";
  display: table;
}

.chat .item:after {
  clear: both;
}

.chat .item > img {
  border: 2px solid #fff0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

.chat .item > .online {
  border: 2px solid #00a65a;
}

.chat .item > .offline {
  border: 2px solid #dd4b39;
}

.chat .item > .message {
  margin-top: -40px;
  margin-left: 55px;
}

.chat .item > .message > .name {
  font-weight: 600;
  display: block;
}

.chat .item > .attachment {
  background: #f4f4f4;
  border-radius: 3px;
  margin-left: 65px;
  margin-right: 15px;
  padding: 10px;
}

.chat .item > .attachment > h4 {
  margin: 0 0 5px;
  font-size: 14px;
  font-weight: 600;
}

.chat .item > .attachment > p, .chat .item > .attachment > .filename {
  margin: 0;
  font-size: 13px;
  font-style: italic;
  font-weight: 600;
}

.chat .item > .attachment:before, .chat .item > .attachment:after {
  content: " ";
  display: table;
}

.chat .item > .attachment:after {
  clear: both;
}

.box-input {
  max-width: 200px;
}

.modal .panel-body {
  color: #444;
}

.info-box {
  background: #fff;
  border-radius: 2px;
  width: 100%;
  min-height: 90px;
  margin-bottom: 15px;
  display: block;
  box-shadow: 0 1px 1px #0000001a;
}

.info-box small {
  font-size: 14px;
}

.info-box .progress {
  background: #0003;
  height: 2px;
  margin: 5px -10px;
}

.info-box .progress, .info-box .progress .progress-bar {
  border-radius: 0;
}

.info-box .progress .progress-bar {
  background: #fff;
}

.info-box-icon {
  float: left;
  text-align: center;
  background: #0003;
  border-radius: 2px 0 0 2px;
  width: 90px;
  height: 90px;
  font-size: 45px;
  line-height: 90px;
  display: block;
}

.info-box-icon > img {
  max-width: 100%;
}

.info-box-content {
  margin-left: 90px;
  padding: 5px 10px;
}

.info-box-number {
  font-size: 18px;
  font-weight: 700;
  display: block;
}

.progress-description, .info-box-text {
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  display: block;
  overflow: hidden;
}

.info-box-text {
  text-transform: uppercase;
}

.info-box-more {
  display: block;
}

.progress-description {
  margin: 0;
}

.timeline {
  margin: 0 0 30px;
  padding: 0;
  list-style: none;
  position: relative;
}

.timeline:before {
  content: "";
  background: #ddd;
  border-radius: 2px;
  width: 4px;
  margin: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 31px;
}

.timeline > li {
  margin-bottom: 15px;
  margin-right: 10px;
  position: relative;
}

.timeline > li:before, .timeline > li:after {
  content: " ";
  display: table;
}

.timeline > li:after {
  clear: both;
}

.timeline > li > .timeline-item {
  color: #444;
  background: #fff;
  border-radius: 3px;
  margin-top: 0;
  margin-left: 60px;
  margin-right: 15px;
  padding: 0;
  position: relative;
  box-shadow: 0 1px 1px #0000001a;
}

.timeline > li > .timeline-item > .time {
  color: #999;
  float: right;
  padding: 10px;
  font-size: 12px;
}

.timeline > li > .timeline-item > .timeline-header {
  color: #555;
  border-bottom: 1px solid #f4f4f4;
  margin: 0;
  padding: 10px;
  font-size: 16px;
  line-height: 1.1;
}

.timeline > li > .timeline-item > .timeline-header > a {
  font-weight: 600;
}

.timeline > li > .timeline-item > .timeline-body, .timeline > li > .timeline-item > .timeline-footer {
  padding: 10px;
}

.timeline > li > .fa, .timeline > li > .glyphicon, .timeline > li > .ion {
  color: #666;
  text-align: center;
  background: #d2d6de;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 15px;
  line-height: 30px;
  position: absolute;
  top: 0;
  left: 18px;
}

.timeline > .time-label > span {
  background-color: #fff;
  border-radius: 4px;
  padding: 5px;
  font-weight: 600;
  display: inline-block;
}

.timeline-inverse > li > .timeline-item {
  box-shadow: none;
  background: #f0f0f0;
  border: 1px solid #ddd;
}

.timeline-inverse > li > .timeline-item > .timeline-header {
  border-bottom-color: #ddd;
}

.btn {
  box-shadow: none;
  border: 1px solid #fff0;
  border-radius: 3px;
}

.btn.uppercase {
  text-transform: uppercase;
}

.btn.btn-flat {
  box-shadow: none;
  border-width: 1px;
  border-radius: 0;
}

.btn:active {
  box-shadow: inset 0 3px 5px #00000020;
}

.btn:focus {
  outline: none;
}

.btn.btn-file {
  position: relative;
  overflow: hidden;
}

.btn.btn-file > input[type="file"] {
  text-align: right;
  opacity: 0;
  min-width: 100%;
  min-height: 100%;
  filter: alpha(opacity= 0);
  cursor: inherit;
  background: #fff;
  outline: none;
  font-size: 100px;
  display: block;
  position: absolute;
  top: 0;
  right: 0;
}

.btn-default {
  color: #444;
  background-color: #f4f4f4;
  border-color: #ddd;
}

.btn-default:hover, .btn-default:active, .btn-default.hover {
  background-color: #e7e7e7;
}

.btn-primary {
  background-color: #3c8dbc;
  border-color: #367fa9;
}

.btn-primary:hover, .btn-primary:active, .btn-primary.hover {
  background-color: #367fa9;
}

.btn-success {
  background-color: #00a65a;
  border-color: #008d4c;
}

.btn-success:hover, .btn-success:active, .btn-success.hover {
  background-color: #008d4c;
}

.btn-info {
  background-color: #00c0ef;
  border-color: #00acd6;
}

.btn-info:hover, .btn-info:active, .btn-info.hover {
  background-color: #00acd6;
}

.btn-danger {
  background-color: #dd4b39;
  border-color: #d73925;
}

.btn-danger:hover, .btn-danger:active, .btn-danger.hover {
  background-color: #d73925;
}

.btn-warning {
  background-color: #f39c12;
  border-color: #e08e0b;
}

.btn-warning:hover, .btn-warning:active, .btn-warning.hover {
  background-color: #e08e0b;
}

.btn-outline {
  color: #fff;
  background: #fff0;
  border: 1px solid #fff;
}

.btn-outline:hover, .btn-outline:focus, .btn-outline:active {
  color: #ffffffb3;
  border-color: #ffffffb3;
}

.btn-link {
  box-shadow: none;
}

.btn[class*="bg-"]:hover {
  box-shadow: inset 0 0 100px #0003;
}

.btn-app {
  text-align: center;
  color: #666;
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-radius: 3px;
  min-width: 80px;
  height: 60px;
  margin: 0 0 10px 10px;
  padding: 15px 5px;
  font-size: 12px;
  position: relative;
}

.btn-app > .fa, .btn-app > .glyphicon, .btn-app > .ion {
  font-size: 20px;
  display: block;
}

.btn-app:hover {
  color: #444;
  background: #f4f4f4;
  border-color: #aaa;
}

.btn-app:active, .btn-app:focus {
  box-shadow: inset 0 3px 5px #00000020;
}

.btn-app > .badge {
  font-size: 10px;
  font-weight: 400;
  position: absolute;
  top: -3px;
  right: -10px;
}

.callout {
  border-left: 5px solid #eee;
  border-radius: 3px;
  margin: 0 0 20px;
  padding: 15px 30px 15px 15px;
}

.callout a {
  color: #fff;
  text-decoration: underline;
}

.callout a:hover {
  color: #eee;
}

.callout h4 {
  margin-top: 0;
  font-weight: 600;
}

.callout p:last-child {
  margin-bottom: 0;
}

.callout code, .callout .highlight {
  background-color: #fff;
}

.callout.callout-danger {
  border-color: #c23321;
}

.callout.callout-warning {
  border-color: #c87f0a;
}

.callout.callout-info {
  border-color: #0097bc;
}

.callout.callout-success {
  border-color: #00733e;
}

.alert {
  border-radius: 3px;
}

.alert h4 {
  font-weight: 600;
}

.alert .icon {
  margin-right: 10px;
}

.alert .close {
  color: #000;
  opacity: .2;
  filter: alpha(opacity= 20);
}

.alert .close:hover {
  opacity: .5;
  filter: alpha(opacity= 50);
}

.alert a {
  color: #fff;
  text-decoration: underline;
}

.alert-success {
  border-color: #008d4c;
}

.alert-danger, .alert-error {
  border-color: #d73925;
}

.alert-warning {
  border-color: #e08e0b;
}

.alert-info {
  border-color: #00acd6;
}

.nav > li > a:hover, .nav > li > a:active, .nav > li > a:focus {
  color: #444;
  background: #f7f7f7;
}

.nav-pills > li > a {
  color: #444;
  border-top: 3px solid #fff0;
  border-radius: 0;
}

.nav-pills > li > a > .fa, .nav-pills > li > a > .glyphicon, .nav-pills > li > a > .ion {
  margin-right: 5px;
}

.nav-pills > li.active > a, .nav-pills > li.active > a:hover, .nav-pills > li.active > a:focus {
  border-top-color: #3c8dbc;
}

.nav-pills > li.active > a {
  font-weight: 600;
}

.nav-stacked > li > a {
  color: #444;
  border-top: 0;
  border-left: 3px solid #fff0;
  border-radius: 0;
}

.nav-stacked > li.active > a, .nav-stacked > li.active > a:hover {
  color: #444;
  background: #fff0;
  border-top: 0;
  border-left-color: #3c8dbc;
}

.nav-stacked > li.header {
  color: #777;
  text-transform: uppercase;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding: 5px 10px;
}

.nav-tabs-custom {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 20px;
  box-shadow: 0 1px 1px #0000001a;
}

.nav-tabs-custom > .nav-tabs {
  border-bottom-color: #f4f4f4;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  margin: 0;
}

.nav-tabs-custom > .nav-tabs > li {
  border-top: 3px solid #fff0;
  margin-bottom: -2px;
  margin-right: 5px;
}

.nav-tabs-custom > .nav-tabs > li > a {
  color: #444;
  border-radius: 0;
}

.nav-tabs-custom > .nav-tabs > li > a.text-muted {
  color: #999;
}

.nav-tabs-custom > .nav-tabs > li > a, .nav-tabs-custom > .nav-tabs > li > a:hover {
  background: #fff0;
  margin: 0;
}

.nav-tabs-custom > .nav-tabs > li > a:hover {
  color: #999;
}

.nav-tabs-custom > .nav-tabs > li:not(.active) > a:hover, .nav-tabs-custom > .nav-tabs > li:not(.active) > a:focus, .nav-tabs-custom > .nav-tabs > li:not(.active) > a:active {
  border-color: #fff0;
}

.nav-tabs-custom > .nav-tabs > li.active {
  border-top-color: #3c8dbc;
}

.nav-tabs-custom > .nav-tabs > li.active > a, .nav-tabs-custom > .nav-tabs > li.active:hover > a {
  color: #444;
  background-color: #fff;
}

.nav-tabs-custom > .nav-tabs > li.active > a {
  border-top-color: #fff0;
  border-left-color: #f4f4f4;
  border-right-color: #f4f4f4;
}

.nav-tabs-custom > .nav-tabs > li:first-of-type {
  margin-left: 0;
}

.nav-tabs-custom > .nav-tabs > li:first-of-type.active > a {
  border-left-color: #fff0;
}

.nav-tabs-custom > .nav-tabs.pull-right {
  float: none !important;
}

.nav-tabs-custom > .nav-tabs.pull-right > li {
  float: right;
}

.nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type {
  margin-right: 0;
}

.nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type > a {
  border-left-width: 1px;
}

.nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type.active > a {
  border-left-color: #f4f4f4;
  border-right-color: #fff0;
}

.nav-tabs-custom > .nav-tabs > li.header {
  color: #444;
  padding: 0 10px;
  font-size: 20px;
  line-height: 35px;
}

.nav-tabs-custom > .nav-tabs > li.header > .fa, .nav-tabs-custom > .nav-tabs > li.header > .glyphicon, .nav-tabs-custom > .nav-tabs > li.header > .ion {
  margin-right: 5px;
}

.nav-tabs-custom > .tab-content {
  background: #fff;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  padding: 10px;
}

.nav-tabs-custom .dropdown.open > a:active, .nav-tabs-custom .dropdown.open > a:focus {
  color: #999;
  background: #fff0;
}

.nav-tabs-custom.tab-primary > .nav-tabs > li.active {
  border-top-color: #3c8dbc;
}

.nav-tabs-custom.tab-info > .nav-tabs > li.active {
  border-top-color: #00c0ef;
}

.nav-tabs-custom.tab-danger > .nav-tabs > li.active {
  border-top-color: #dd4b39;
}

.nav-tabs-custom.tab-warning > .nav-tabs > li.active {
  border-top-color: #f39c12;
}

.nav-tabs-custom.tab-success > .nav-tabs > li.active {
  border-top-color: #00a65a;
}

.nav-tabs-custom.tab-default > .nav-tabs > li.active {
  border-top-color: #d2d6de;
}

.pagination > li > a {
  color: #666;
  background: #fafafa;
}

.pagination.pagination-flat > li > a {
  border-radius: 0 !important;
}

.products-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.products-list > .item {
  background: #fff;
  border-radius: 3px;
  padding: 10px 0;
  box-shadow: 0 1px 1px #0000001a;
}

.products-list > .item:before, .products-list > .item:after {
  content: " ";
  display: table;
}

.products-list > .item:after {
  clear: both;
}

.products-list .product-img {
  float: left;
}

.products-list .product-img img {
  width: 50px;
  height: 50px;
}

.products-list .product-info {
  margin-left: 60px;
}

.products-list .product-title {
  font-weight: 600;
}

.products-list .product-description {
  color: #999;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
}

.product-list-in-box > .item {
  box-shadow: none;
  border-bottom: 1px solid #f4f4f4;
  border-radius: 0;
}

.product-list-in-box > .item:last-of-type {
  border-bottom-width: 0;
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
  border-top: 1px solid #f4f4f4;
}

.table > thead > tr > th {
  border-bottom: 2px solid #f4f4f4;
}

.table tr td .progress {
  margin-top: 5px;
}

.table-bordered, .table-bordered > thead > tr > th, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > tbody > tr > td, .table-bordered > tfoot > tr > td {
  border: 1px solid #f4f4f4;
}

.table-bordered > thead > tr > th, .table-bordered > thead > tr > td {
  border-bottom-width: 2px;
}

.table.no-border, .table.no-border td, .table.no-border th {
  border: 0;
}

table.text-center, table.text-center td, table.text-center th {
  text-align: center;
}

.table.align th {
  text-align: left;
}

.table.align td {
  text-align: right;
}

.label-default {
  color: #444;
  background-color: #d2d6de;
}

.direct-chat .box-body {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0;
  position: relative;
  overflow-x: hidden;
}

.direct-chat.chat-pane-open .direct-chat-contacts {
  transform: translate(0);
}

.direct-chat-messages {
  height: 250px;
  padding: 10px;
  overflow: auto;
  transform: translate(0);
}

.direct-chat-msg, .direct-chat-text {
  display: block;
}

.direct-chat-msg {
  margin-bottom: 10px;
}

.direct-chat-msg:before, .direct-chat-msg:after {
  content: " ";
  display: table;
}

.direct-chat-msg:after {
  clear: both;
}

.direct-chat-messages, .direct-chat-contacts {
  transition: transform .5s ease-in-out;
}

.direct-chat-text {
  color: #444;
  background: #d2d6de;
  border: 1px solid #d2d6de;
  border-radius: 5px;
  margin: 5px 0 0 50px;
  padding: 5px 10px;
  position: relative;
}

.direct-chat-text:after, .direct-chat-text:before {
  content: " ";
  pointer-events: none;
  border: solid #fff0;
  border-right-color: #d2d6de;
  width: 0;
  height: 0;
  position: absolute;
  top: 15px;
  right: 100%;
}

.direct-chat-text:after {
  border-width: 5px;
  margin-top: -5px;
}

.direct-chat-text:before {
  border-width: 6px;
  margin-top: -6px;
}

.right .direct-chat-text {
  margin-left: 0;
  margin-right: 50px;
}

.right .direct-chat-text:after, .right .direct-chat-text:before {
  border-left-color: #d2d6de;
  border-right-color: #fff0;
  left: 100%;
  right: auto;
}

.direct-chat-img {
  float: left;
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

.right .direct-chat-img {
  float: right;
}

.direct-chat-info {
  margin-bottom: 2px;
  font-size: 12px;
  display: block;
}

.direct-chat-name {
  font-weight: 600;
}

.direct-chat-timestamp {
  color: #999;
}

.direct-chat-contacts-open .direct-chat-contacts {
  transform: translate(0);
}

.direct-chat-contacts {
  color: #fff;
  background: #222d32;
  width: 100%;
  height: 250px;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: auto;
  transform: translate(101%);
}

.contacts-list > li {
  border-bottom: 1px solid #0003;
  margin: 0;
  padding: 10px;
}

.contacts-list > li:before, .contacts-list > li:after {
  content: " ";
  display: table;
}

.contacts-list > li:after {
  clear: both;
}

.contacts-list > li:last-of-type {
  border-bottom: none;
}

.contacts-list-img {
  float: left;
  border-radius: 50%;
  width: 40px;
}

.contacts-list-info {
  color: #fff;
  margin-left: 45px;
}

.contacts-list-name, .contacts-list-status {
  display: block;
}

.contacts-list-name {
  font-weight: 600;
}

.contacts-list-status {
  font-size: 12px;
}

.contacts-list-date {
  color: #aaa;
  font-weight: 400;
}

.contacts-list-msg {
  color: #999;
}

.direct-chat-danger .right > .direct-chat-text {
  color: #fff;
  background: #dd4b39;
  border-color: #dd4b39;
}

.direct-chat-danger .right > .direct-chat-text:after, .direct-chat-danger .right > .direct-chat-text:before {
  border-left-color: #dd4b39;
}

.direct-chat-primary .right > .direct-chat-text {
  color: #fff;
  background: #3c8dbc;
  border-color: #3c8dbc;
}

.direct-chat-primary .right > .direct-chat-text:after, .direct-chat-primary .right > .direct-chat-text:before {
  border-left-color: #3c8dbc;
}

.direct-chat-warning .right > .direct-chat-text {
  color: #fff;
  background: #f39c12;
  border-color: #f39c12;
}

.direct-chat-warning .right > .direct-chat-text:after, .direct-chat-warning .right > .direct-chat-text:before {
  border-left-color: #f39c12;
}

.direct-chat-info .right > .direct-chat-text {
  color: #fff;
  background: #00c0ef;
  border-color: #00c0ef;
}

.direct-chat-info .right > .direct-chat-text:after, .direct-chat-info .right > .direct-chat-text:before {
  border-left-color: #00c0ef;
}

.direct-chat-success .right > .direct-chat-text {
  color: #fff;
  background: #00a65a;
  border-color: #00a65a;
}

.direct-chat-success .right > .direct-chat-text:after, .direct-chat-success .right > .direct-chat-text:before {
  border-left-color: #00a65a;
}

.users-list > li {
  float: left;
  text-align: center;
  width: 25%;
  padding: 10px;
}

.users-list > li img {
  border-radius: 50%;
  max-width: 100%;
  height: auto;
}

.users-list > li > a:hover, .users-list > li > a:hover .users-list-name {
  color: #999;
}

.users-list-name, .users-list-date {
  display: block;
}

.users-list-name {
  color: #444;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  overflow: hidden;
}

.users-list-date {
  color: #999;
  font-size: 12px;
}

.carousel-control.left, .carousel-control.right {
  background-image: none;
}

.carousel-control > .fa {
  z-index: 5;
  margin-top: -20px;
  font-size: 40px;
  display: inline-block;
  position: absolute;
  top: 50%;
}

.modal {
  background: #0000004d;
}

.modal-content {
  border: 0;
  border-radius: 0;
  box-shadow: 0 2px 3px #00000020;
}

@media (width >= 768px) {
  .modal-content {
    box-shadow: 0 2px 3px #00000020;
  }
}

.modal-header {
  border-bottom-color: #f4f4f4;
}

.modal-footer {
  border-top-color: #f4f4f4;
}

.modal-primary .modal-header, .modal-primary .modal-footer {
  border-color: #307095;
}

.modal-warning .modal-header, .modal-warning .modal-footer {
  border-color: #c87f0a;
}

.modal-info .modal-header, .modal-info .modal-footer {
  border-color: #0097bc;
}

.modal-success .modal-header, .modal-success .modal-footer {
  border-color: #00733e;
}

.modal-danger .modal-header, .modal-danger .modal-footer {
  border-color: #c23321;
}

.box-widget {
  border: none;
  position: relative;
}

.widget-user .widget-user-header {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  height: 120px;
  padding: 20px;
}

.widget-user .widget-user-username {
  text-shadow: 0 1px 1px #0003;
  margin-top: 0;
  margin-bottom: 5px;
  font-size: 25px;
  font-weight: 300;
}

.widget-user .widget-user-desc {
  margin-top: 0;
}

.widget-user .widget-user-image {
  margin-left: -45px;
  position: absolute;
  top: 65px;
  left: 50%;
}

.widget-user .widget-user-image > img {
  border: 3px solid #fff;
  width: 90px;
  height: auto;
}

.widget-user .box-footer {
  padding-top: 30px;
}

.widget-user-2 .widget-user-header {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  padding: 20px;
}

.widget-user-2 .widget-user-username {
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 25px;
  font-weight: 300;
}

.widget-user-2 .widget-user-desc {
  margin-top: 0;
}

.widget-user-2 .widget-user-username, .widget-user-2 .widget-user-desc {
  margin-left: 75px;
}

.widget-user-2 .widget-user-image > img {
  float: left;
  width: 65px;
  height: auto;
}

.mailbox-messages > .table {
  margin: 0;
}

.mailbox-controls {
  padding: 5px;
}

.mailbox-controls.with-border {
  border-bottom: 1px solid #f4f4f4;
}

.mailbox-read-info {
  border-bottom: 1px solid #f4f4f4;
  padding: 10px;
}

.mailbox-read-info h3 {
  margin: 0;
  font-size: 20px;
}

.mailbox-read-info h5 {
  margin: 0;
  padding: 5px 0 0;
}

.mailbox-read-time {
  color: #999;
  font-size: 13px;
}

.mailbox-read-message {
  padding: 10px;
}

.mailbox-attachments li {
  float: left;
  border: 1px solid #eee;
  width: 200px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.mailbox-attachment-name {
  color: #666;
  font-weight: 700;
}

.mailbox-attachment-icon, .mailbox-attachment-info, .mailbox-attachment-size {
  display: block;
}

.mailbox-attachment-info {
  background: #f4f4f4;
  padding: 10px;
}

.mailbox-attachment-size {
  color: #999;
  font-size: 12px;
}

.mailbox-attachment-icon {
  text-align: center;
  color: #666;
  padding: 20px 10px;
  font-size: 65px;
}

.mailbox-attachment-icon.has-img {
  padding: 0;
}

.mailbox-attachment-icon.has-img > img {
  max-width: 100%;
  height: auto;
}

.lockscreen {
  background: #d2d6de;
}

.lockscreen-logo {
  text-align: center;
  margin-bottom: 25px;
  font-size: 35px;
  font-weight: 300;
}

.lockscreen-logo a {
  color: #444;
}

.lockscreen-wrapper {
  max-width: 400px;
  margin: 10% auto 0;
}

.lockscreen .lockscreen-name {
  text-align: center;
  font-weight: 600;
}

.lockscreen-item {
  background: #fff;
  border-radius: 4px;
  width: 290px;
  margin: 10px auto 30px;
  padding: 0;
  position: relative;
}

.lockscreen-image {
  z-index: 10;
  background: #fff;
  border-radius: 50%;
  padding: 5px;
  position: absolute;
  top: -25px;
  left: -10px;
}

.lockscreen-image > img {
  border-radius: 50%;
  width: 70px;
  height: 70px;
}

.lockscreen-credentials {
  margin-left: 70px;
}

.lockscreen-credentials .form-control {
  border: 0;
}

.lockscreen-credentials .btn {
  background-color: #fff;
  border: 0;
  padding: 0 10px;
}

.lockscreen-footer {
  margin-top: 10px;
}

.login-logo, .register-logo {
  text-align: center;
  margin-bottom: 25px;
  font-size: 35px;
  font-weight: 300;
}

.login-logo a, .register-logo a {
  color: #444;
}

.login-page, .register-page {
  background: #d2d6de;
}

.login-box, .register-box {
  width: 360px;
  margin: 7% auto;
}

@media (width <= 768px) {
  .login-box, .register-box {
    width: 90%;
    margin-top: 20px;
  }
}

.login-box-body, .register-box-body {
  color: #666;
  background: #fff;
  border-top: 0;
  padding: 20px;
}

.login-box-body .form-control-feedback, .register-box-body .form-control-feedback {
  color: #777;
}

.login-box-msg, .register-box-msg {
  text-align: center;
  margin: 0;
  padding: 0 20px 20px;
}

.social-auth-links {
  margin: 10px 0;
}

.error-page {
  width: 600px;
  margin: 20px auto 0;
}

@media (width <= 991px) {
  .error-page {
    width: 100%;
  }
}

.error-page > .headline {
  float: left;
  font-size: 100px;
  font-weight: 300;
}

@media (width <= 991px) {
  .error-page > .headline {
    float: none;
    text-align: center;
  }
}

.error-page > .error-content {
  margin-left: 190px;
  display: block;
}

@media (width <= 991px) {
  .error-page > .error-content {
    margin-left: 0;
  }
}

.error-page > .error-content > h3 {
  font-size: 25px;
  font-weight: 300;
}

@media (width <= 991px) {
  .error-page > .error-content > h3 {
    text-align: center;
  }
}

.invoice {
  background: #fff;
  border: 1px solid #f4f4f4;
  margin: 10px 25px;
  padding: 20px;
  position: relative;
}

.invoice-title {
  margin-top: 0;
}

.profile-user-img {
  border: 3px solid #d2d6de;
  width: 100px;
  margin: 0 auto;
  padding: 3px;
}

.profile-username {
  margin-top: 5px;
  font-size: 21px;
}

.post {
  color: #666;
  border-bottom: 1px solid #d2d6de;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.post:last-of-type {
  border-bottom: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}

.post .user-block {
  margin-bottom: 15px;
}

.btn-social {
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 44px;
  position: relative;
  overflow: hidden;
}

.btn-social > :first-child {
  text-align: center;
  border-right: 1px solid #0003;
  width: 32px;
  font-size: 1.6em;
  line-height: 34px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}

.btn-social.btn-lg {
  padding-left: 61px;
}

.btn-social.btn-lg > :first-child {
  width: 45px;
  font-size: 1.8em;
  line-height: 45px;
}

.btn-social.btn-sm {
  padding-left: 38px;
}

.btn-social.btn-sm > :first-child {
  width: 28px;
  font-size: 1.4em;
  line-height: 28px;
}

.btn-social.btn-xs {
  padding-left: 30px;
}

.btn-social.btn-xs > :first-child {
  width: 20px;
  font-size: 1.2em;
  line-height: 20px;
}

.btn-social-icon {
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 34px;
  height: 34px;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.btn-social-icon > :first-child {
  text-align: center;
  border-right: 1px solid #0003;
  width: 32px;
  font-size: 1.6em;
  line-height: 34px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}

.btn-social-icon.btn-lg {
  padding-left: 61px;
}

.btn-social-icon.btn-lg > :first-child {
  width: 45px;
  font-size: 1.8em;
  line-height: 45px;
}

.btn-social-icon.btn-sm {
  padding-left: 38px;
}

.btn-social-icon.btn-sm > :first-child {
  width: 28px;
  font-size: 1.4em;
  line-height: 28px;
}

.btn-social-icon.btn-xs {
  padding-left: 30px;
}

.btn-social-icon.btn-xs > :first-child {
  width: 20px;
  font-size: 1.2em;
  line-height: 20px;
}

.btn-social-icon > :first-child {
  text-align: center;
  border: none;
  width: 100%;
}

.btn-social-icon.btn-lg {
  width: 45px;
  height: 45px;
  padding-left: 0;
  padding-right: 0;
}

.btn-social-icon.btn-sm {
  width: 30px;
  height: 30px;
  padding-left: 0;
  padding-right: 0;
}

.btn-social-icon.btn-xs {
  width: 22px;
  height: 22px;
  padding-left: 0;
  padding-right: 0;
}

.btn-adn {
  color: #fff;
  background-color: #d87a68;
  border-color: #0003;
}

.btn-adn:focus, .btn-adn.focus, .btn-adn:hover {
  color: #fff;
  background-color: #ce563f;
  border-color: #0003;
}

.btn-adn:active, .btn-adn.active, .open > .dropdown-toggle.btn-adn {
  color: #fff;
  background-color: #ce563f;
  background-image: none;
  border-color: #0003;
}

.btn-adn .badge {
  color: #d87a68;
  background-color: #fff;
}

.btn-bitbucket {
  color: #fff;
  background-color: #205081;
  border-color: #0003;
}

.btn-bitbucket:focus, .btn-bitbucket.focus, .btn-bitbucket:hover {
  color: #fff;
  background-color: #163758;
  border-color: #0003;
}

.btn-bitbucket:active, .btn-bitbucket.active, .open > .dropdown-toggle.btn-bitbucket {
  color: #fff;
  background-color: #163758;
  background-image: none;
  border-color: #0003;
}

.btn-bitbucket .badge {
  color: #205081;
  background-color: #fff;
}

.btn-dropbox {
  color: #fff;
  background-color: #1087dd;
  border-color: #0003;
}

.btn-dropbox:focus, .btn-dropbox.focus, .btn-dropbox:hover {
  color: #fff;
  background-color: #0d6aad;
  border-color: #0003;
}

.btn-dropbox:active, .btn-dropbox.active, .open > .dropdown-toggle.btn-dropbox {
  color: #fff;
  background-color: #0d6aad;
  background-image: none;
  border-color: #0003;
}

.btn-dropbox .badge {
  color: #1087dd;
  background-color: #fff;
}

.btn-facebook {
  color: #fff;
  background-color: #3b5998;
  border-color: #0003;
}

.btn-facebook:focus, .btn-facebook.focus, .btn-facebook:hover {
  color: #fff;
  background-color: #2d4373;
  border-color: #0003;
}

.btn-facebook:active, .btn-facebook.active, .open > .dropdown-toggle.btn-facebook {
  color: #fff;
  background-color: #2d4373;
  background-image: none;
  border-color: #0003;
}

.btn-facebook .badge {
  color: #3b5998;
  background-color: #fff;
}

.btn-flickr {
  color: #fff;
  background-color: #ff0084;
  border-color: #0003;
}

.btn-flickr:focus, .btn-flickr.focus, .btn-flickr:hover {
  color: #fff;
  background-color: #cc006a;
  border-color: #0003;
}

.btn-flickr:active, .btn-flickr.active, .open > .dropdown-toggle.btn-flickr {
  color: #fff;
  background-color: #cc006a;
  background-image: none;
  border-color: #0003;
}

.btn-flickr .badge {
  color: #ff0084;
  background-color: #fff;
}

.btn-foursquare {
  color: #fff;
  background-color: #f94877;
  border-color: #0003;
}

.btn-foursquare:focus, .btn-foursquare.focus, .btn-foursquare:hover {
  color: #fff;
  background-color: #f71752;
  border-color: #0003;
}

.btn-foursquare:active, .btn-foursquare.active, .open > .dropdown-toggle.btn-foursquare {
  color: #fff;
  background-color: #f71752;
  background-image: none;
  border-color: #0003;
}

.btn-foursquare .badge {
  color: #f94877;
  background-color: #fff;
}

.btn-github {
  color: #fff;
  background-color: #444;
  border-color: #0003;
}

.btn-github:focus, .btn-github.focus, .btn-github:hover {
  color: #fff;
  background-color: #2b2b2b;
  border-color: #0003;
}

.btn-github:active, .btn-github.active, .open > .dropdown-toggle.btn-github {
  color: #fff;
  background-color: #2b2b2b;
  background-image: none;
  border-color: #0003;
}

.btn-github .badge {
  color: #444;
  background-color: #fff;
}

.btn-google {
  color: #fff;
  background-color: #dd4b39;
  border-color: #0003;
}

.btn-google:focus, .btn-google.focus, .btn-google:hover {
  color: #fff;
  background-color: #c23321;
  border-color: #0003;
}

.btn-google:active, .btn-google.active, .open > .dropdown-toggle.btn-google {
  color: #fff;
  background-color: #c23321;
  background-image: none;
  border-color: #0003;
}

.btn-google .badge {
  color: #dd4b39;
  background-color: #fff;
}

.btn-instagram {
  color: #fff;
  background-color: #3f729b;
  border-color: #0003;
}

.btn-instagram:focus, .btn-instagram.focus, .btn-instagram:hover {
  color: #fff;
  background-color: #305777;
  border-color: #0003;
}

.btn-instagram:active, .btn-instagram.active, .open > .dropdown-toggle.btn-instagram {
  color: #fff;
  background-color: #305777;
  background-image: none;
  border-color: #0003;
}

.btn-instagram .badge {
  color: #3f729b;
  background-color: #fff;
}

.btn-linkedin {
  color: #fff;
  background-color: #007bb6;
  border-color: #0003;
}

.btn-linkedin:focus, .btn-linkedin.focus, .btn-linkedin:hover {
  color: #fff;
  background-color: #005983;
  border-color: #0003;
}

.btn-linkedin:active, .btn-linkedin.active, .open > .dropdown-toggle.btn-linkedin {
  color: #fff;
  background-color: #005983;
  background-image: none;
  border-color: #0003;
}

.btn-linkedin .badge {
  color: #007bb6;
  background-color: #fff;
}

.btn-microsoft {
  color: #fff;
  background-color: #2672ec;
  border-color: #0003;
}

.btn-microsoft:focus, .btn-microsoft.focus, .btn-microsoft:hover {
  color: #fff;
  background-color: #125acd;
  border-color: #0003;
}

.btn-microsoft:active, .btn-microsoft.active, .open > .dropdown-toggle.btn-microsoft {
  color: #fff;
  background-color: #125acd;
  background-image: none;
  border-color: #0003;
}

.btn-microsoft .badge {
  color: #2672ec;
  background-color: #fff;
}

.btn-openid {
  color: #fff;
  background-color: #f7931e;
  border-color: #0003;
}

.btn-openid:focus, .btn-openid.focus, .btn-openid:hover {
  color: #fff;
  background-color: #da7908;
  border-color: #0003;
}

.btn-openid:active, .btn-openid.active, .open > .dropdown-toggle.btn-openid {
  color: #fff;
  background-color: #da7908;
  background-image: none;
  border-color: #0003;
}

.btn-openid .badge {
  color: #f7931e;
  background-color: #fff;
}

.btn-pinterest {
  color: #fff;
  background-color: #cb2027;
  border-color: #0003;
}

.btn-pinterest:focus, .btn-pinterest.focus, .btn-pinterest:hover {
  color: #fff;
  background-color: #9f191f;
  border-color: #0003;
}

.btn-pinterest:active, .btn-pinterest.active, .open > .dropdown-toggle.btn-pinterest {
  color: #fff;
  background-color: #9f191f;
  background-image: none;
  border-color: #0003;
}

.btn-pinterest .badge {
  color: #cb2027;
  background-color: #fff;
}

.btn-reddit {
  color: #000;
  background-color: #eff7ff;
  border-color: #0003;
}

.btn-reddit:focus, .btn-reddit.focus, .btn-reddit:hover {
  color: #000;
  background-color: #bcddff;
  border-color: #0003;
}

.btn-reddit:active, .btn-reddit.active, .open > .dropdown-toggle.btn-reddit {
  color: #000;
  background-color: #bcddff;
  background-image: none;
  border-color: #0003;
}

.btn-reddit .badge {
  color: #eff7ff;
  background-color: #000;
}

.btn-soundcloud {
  color: #fff;
  background-color: #f50;
  border-color: #0003;
}

.btn-soundcloud:focus, .btn-soundcloud.focus, .btn-soundcloud:hover {
  color: #fff;
  background-color: #c40;
  border-color: #0003;
}

.btn-soundcloud:active, .btn-soundcloud.active, .open > .dropdown-toggle.btn-soundcloud {
  color: #fff;
  background-color: #c40;
  background-image: none;
  border-color: #0003;
}

.btn-soundcloud .badge {
  color: #f50;
  background-color: #fff;
}

.btn-tumblr {
  color: #fff;
  background-color: #2c4762;
  border-color: #0003;
}

.btn-tumblr:focus, .btn-tumblr.focus, .btn-tumblr:hover {
  color: #fff;
  background-color: #1c2d3f;
  border-color: #0003;
}

.btn-tumblr:active, .btn-tumblr.active, .open > .dropdown-toggle.btn-tumblr {
  color: #fff;
  background-color: #1c2d3f;
  background-image: none;
  border-color: #0003;
}

.btn-tumblr .badge {
  color: #2c4762;
  background-color: #fff;
}

.btn-twitter {
  color: #fff;
  background-color: #55acee;
  border-color: #0003;
}

.btn-twitter:focus, .btn-twitter.focus, .btn-twitter:hover {
  color: #fff;
  background-color: #2795e9;
  border-color: #0003;
}

.btn-twitter:active, .btn-twitter.active, .open > .dropdown-toggle.btn-twitter {
  color: #fff;
  background-color: #2795e9;
  background-image: none;
  border-color: #0003;
}

.btn-twitter .badge {
  color: #55acee;
  background-color: #fff;
}

.btn-vimeo {
  color: #fff;
  background-color: #1ab7ea;
  border-color: #0003;
}

.btn-vimeo:focus, .btn-vimeo.focus, .btn-vimeo:hover {
  color: #fff;
  background-color: #1295bf;
  border-color: #0003;
}

.btn-vimeo:active, .btn-vimeo.active, .open > .dropdown-toggle.btn-vimeo {
  color: #fff;
  background-color: #1295bf;
  background-image: none;
  border-color: #0003;
}

.btn-vimeo .badge {
  color: #1ab7ea;
  background-color: #fff;
}

.btn-vk {
  color: #fff;
  background-color: #587ea3;
  border-color: #0003;
}

.btn-vk:focus, .btn-vk.focus, .btn-vk:hover {
  color: #fff;
  background-color: #466482;
  border-color: #0003;
}

.btn-vk:active, .btn-vk.active, .open > .dropdown-toggle.btn-vk {
  color: #fff;
  background-color: #466482;
  background-image: none;
  border-color: #0003;
}

.btn-vk .badge {
  color: #587ea3;
  background-color: #fff;
}

.btn-yahoo {
  color: #fff;
  background-color: #720e9e;
  border-color: #0003;
}

.btn-yahoo:focus, .btn-yahoo.focus, .btn-yahoo:hover {
  color: #fff;
  background-color: #500a6f;
  border-color: #0003;
}

.btn-yahoo:active, .btn-yahoo.active, .open > .dropdown-toggle.btn-yahoo {
  color: #fff;
  background-color: #500a6f;
  background-image: none;
  border-color: #0003;
}

.btn-yahoo .badge {
  color: #720e9e;
  background-color: #fff;
}

.fc-button {
  color: #444;
  background: #f4f4f4;
  border-color: #ddd;
}

.fc-button:hover, .fc-button:active, .fc-button.hover {
  background-color: #e9e9e9;
}

.fc-header-title h2 {
  color: #666;
  margin-left: 10px;
  font-size: 15px;
  line-height: 1.6em;
}

.fc-header-right {
  padding-right: 10px;
}

.fc-header-left {
  padding-left: 10px;
}

.fc-widget-header {
  background: #fafafa;
}

.fc-grid {
  border: 0;
  width: 100%;
}

.fc-widget-header:first-of-type, .fc-widget-content:first-of-type {
  border-left: 0;
  border-right: 0;
}

.fc-widget-header:last-of-type, .fc-widget-content:last-of-type {
  border-right: 0;
}

.fc-toolbar {
  margin: 0;
  padding: 10px;
}

.fc-day-number {
  padding-right: 10px;
  font-size: 20px;
  font-weight: 300;
}

.fc-color-picker {
  margin: 0;
  padding: 0;
  list-style: none;
}

.fc-color-picker > li {
  float: left;
  margin-right: 5px;
  font-size: 30px;
  line-height: 30px;
}

.fc-color-picker > li .fa {
  transition: transform .3s linear;
}

.fc-color-picker > li .fa:hover {
  transform: rotate(30deg);
}

#add-new-event {
  transition: all .3s linear;
}

.external-event {
  text-shadow: 0 1px 1px #0000001a;
  cursor: move;
  border-radius: 3px;
  margin-bottom: 4px;
  padding: 5px 10px;
  font-weight: 700;
  box-shadow: 0 1px 1px #0000001a;
}

.external-event:hover {
  box-shadow: inset 0 0 90px #0003;
}

.select2-container--default.select2-container--focus, .select2-selection.select2-container--focus, .select2-container--default:focus, .select2-selection:focus, .select2-container--default:active, .select2-selection:active {
  outline: none;
}

.select2-container--default .select2-selection--single, .select2-selection .select2-selection--single {
  border: 1px solid #d2d6de;
  border-radius: 0;
  height: 34px;
  padding: 6px 12px;
}

.select2-container--default.select2-container--open {
  border-color: #3c8dbc;
}

.select2-dropdown {
  border: 1px solid #d2d6de;
  border-radius: 0;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  color: #fff;
  background-color: #3c8dbc;
}

.select2-results__option {
  -webkit-user-select: none;
  user-select: none;
  padding: 6px 12px;
}

.select2-container .select2-selection--single .select2-selection__rendered {
  height: auto;
  margin-top: -4px;
  padding-left: 0;
  padding-right: 0;
}

.select2-container[dir="rtl"] .select2-selection--single .select2-selection__rendered {
  padding-left: 20px;
  padding-right: 6px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 28px;
  right: 3px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
  margin-top: 0;
}

.select2-dropdown .select2-search__field, .select2-search--inline .select2-search__field {
  border: 1px solid #d2d6de;
}

.select2-dropdown .select2-search__field:focus, .select2-search--inline .select2-search__field:focus {
  border: 1px solid #3c8dbc;
  outline: none;
}

.select2-container--default .select2-results__option[aria-disabled="true"] {
  color: #999;
}

.select2-container--default .select2-results__option[aria-selected="true"] {
  background-color: #ddd;
}

.select2-container--default .select2-results__option[aria-selected="true"], .select2-container--default .select2-results__option[aria-selected="true"]:hover {
  color: #444;
}

.select2-container--default .select2-selection--multiple {
  border: 1px solid #d2d6de;
  border-radius: 0;
}

.select2-container--default .select2-selection--multiple:focus {
  border-color: #3c8dbc;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: #d2d6de;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
  color: #fff;
  background-color: #3c8dbc;
  border-color: #367fa9;
  padding: 1px 10px;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  color: #ffffffb3;
  margin-right: 5px;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover {
  color: #fff;
}

.select2-container .select2-selection--single .select2-selection__rendered {
  padding-right: 10px;
}

.pad {
  padding: 10px;
}

.margin {
  margin: 10px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.margin-bottom-none {
  margin-bottom: 0;
}

.margin-r-5 {
  margin-right: 5px;
}

.inline {
  display: inline;
}

.description-block {
  text-align: center;
  margin: 10px 0;
  display: block;
}

.description-block.margin-bottom {
  margin-bottom: 25px;
}

.description-block > .description-header {
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-weight: 600;
}

.description-block > .description-text {
  text-transform: uppercase;
}

.bg-red, .bg-yellow, .bg-aqua, .bg-blue, .bg-light-blue, .bg-green, .bg-navy, .bg-teal, .bg-olive, .bg-lime, .bg-orange, .bg-fuchsia, .bg-purple, .bg-maroon, .bg-black, .bg-red-active, .bg-yellow-active, .bg-aqua-active, .bg-blue-active, .bg-light-blue-active, .bg-green-active, .bg-navy-active, .bg-teal-active, .bg-olive-active, .bg-lime-active, .bg-orange-active, .bg-fuchsia-active, .bg-purple-active, .bg-maroon-active, .bg-black-active, .callout.callout-danger, .callout.callout-warning, .callout.callout-info, .callout.callout-success, .alert-success, .alert-danger, .alert-error, .alert-warning, .alert-info, .label-danger, .label-info, .label-warning, .label-primary, .label-success, .modal-primary .modal-body, .modal-primary .modal-header, .modal-primary .modal-footer, .modal-warning .modal-body, .modal-warning .modal-header, .modal-warning .modal-footer, .modal-info .modal-body, .modal-info .modal-header, .modal-info .modal-footer, .modal-success .modal-body, .modal-success .modal-header, .modal-success .modal-footer, .modal-danger .modal-body, .modal-danger .modal-header, .modal-danger .modal-footer {
  color: #fff !important;
}

.bg-gray {
  color: #000;
  background-color: #d2d6de !important;
}

.bg-gray-light {
  background-color: #f7f7f7;
}

.bg-black {
  background-color: #111 !important;
}

.bg-red, .callout.callout-danger, .alert-danger, .alert-error, .label-danger, .modal-danger .modal-body {
  background-color: #dd4b39 !important;
}

.bg-yellow, .callout.callout-warning, .alert-warning, .label-warning, .modal-warning .modal-body {
  background-color: #f39c12 !important;
}

.bg-aqua, .callout.callout-info, .alert-info, .label-info, .modal-info .modal-body {
  background-color: #00c0ef !important;
}

.bg-blue {
  background-color: #0073b7 !important;
}

.bg-light-blue, .label-primary, .modal-primary .modal-body {
  background-color: #3c8dbc !important;
}

.bg-green, .callout.callout-success, .alert-success, .label-success, .modal-success .modal-body {
  background-color: #00a65a !important;
}

.bg-navy {
  background-color: #001f3f !important;
}

.bg-teal {
  background-color: #39cccc !important;
}

.bg-olive {
  background-color: #3d9970 !important;
}

.bg-lime {
  background-color: #01ff70 !important;
}

.bg-orange {
  background-color: #ff851b !important;
}

.bg-fuchsia {
  background-color: #f012be !important;
}

.bg-purple {
  background-color: #6c7e9d !important;
}

.bg-maroon {
  background-color: #d81b60 !important;
}

.bg-gray-active {
  color: #000;
  background-color: #b5bbc8 !important;
}

.bg-black-active {
  background-color: #000 !important;
}

.bg-red-active, .modal-danger .modal-header, .modal-danger .modal-footer {
  background-color: #d33724 !important;
}

.bg-yellow-active, .modal-warning .modal-header, .modal-warning .modal-footer {
  background-color: #db8b0b !important;
}

.bg-aqua-active, .modal-info .modal-header, .modal-info .modal-footer {
  background-color: #00a7d0 !important;
}

.bg-blue-active {
  background-color: #005384 !important;
}

.bg-light-blue-active, .modal-primary .modal-header, .modal-primary .modal-footer {
  background-color: #357ca5 !important;
}

.bg-green-active, .modal-success .modal-header, .modal-success .modal-footer {
  background-color: #008d4c !important;
}

.bg-navy-active {
  background-color: #001a35 !important;
}

.bg-teal-active {
  background-color: #30bbbb !important;
}

.bg-olive-active {
  background-color: #368763 !important;
}

.bg-lime-active {
  background-color: #00e765 !important;
}

.bg-orange-active {
  background-color: #ff7701 !important;
}

.bg-fuchsia-active {
  background-color: #db0ead !important;
}

.bg-purple-active {
  background-color: #536584 !important;
}

.bg-maroon-active {
  background-color: #ca195a !important;
}

[class^="bg-"].disabled {
  opacity: .65;
  filter: alpha(opacity= 65);
}

.text-red {
  color: #dd4b39 !important;
}

.text-yellow {
  color: #f39c12 !important;
}

.text-aqua {
  color: #00c0ef !important;
}

.text-black {
  color: #111 !important;
}

.text-light-blue {
  color: #3c8dbc !important;
}

.text-green {
  color: #00a65a !important;
}

.text-gray {
  color: #d2d6de !important;
}

.text-navy {
  color: #001f3f !important;
}

.text-teal {
  color: #39cccc !important;
}

.text-olive {
  color: #3d9970 !important;
}

.text-lime {
  color: #01ff70 !important;
}

.text-orange {
  color: #ff851b !important;
}

.text-fuchsia {
  color: #f012be !important;
}

.text-purple {
  color: #6c7e9d !important;
}

.text-maroon {
  color: #d81b60 !important;
}

.link-muted {
  color: #7a869d;
}

.link-muted:hover, .link-muted:focus {
  color: #606c84;
}

.link-black {
  color: #666;
}

.link-black:hover, .link-black:focus {
  color: #999;
}

.hide {
  display: none !important;
}

.no-border {
  border: 0 !important;
}

.no-padding {
  padding: 0 !important;
}

.no-margin {
  margin: 0 !important;
}

.no-shadow {
  box-shadow: none !important;
}

.list-unstyled, .chart-legend, .contacts-list, .users-list, .mailbox-attachments {
  margin: 0;
  padding: 0;
  list-style: none;
}

.list-group-unbordered > .list-group-item {
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}

.flat {
  border-radius: 0 !important;
}

.text-bold, .text-bold.table td, .text-bold.table th {
  font-weight: 700;
}

.text-sm {
  font-size: 12px;
}

.jqstooltip {
  width: auto !important;
  height: auto !important;
  padding: 5px !important;
}

.bg-teal-gradient {
  color: #fff;
  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= "#7adddd", endColorstr= "#39cccc", GradientType= 0) !important;
  background: -o-linear-gradient(#7adddd, #39cccc) !important;
}

.bg-light-blue-gradient {
  color: #fff;
  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= "#67a8ce", endColorstr= "#3c8dbc", GradientType= 0) !important;
  background: -o-linear-gradient(#67a8ce, #3c8dbc) !important;
}

.bg-blue-gradient {
  color: #fff;
  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= "#0089db", endColorstr= "#0073b7", GradientType= 0) !important;
  background: -o-linear-gradient(#0089db, #0073b7) !important;
}

.bg-aqua-gradient {
  color: #fff;
  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= "#14d1ff", endColorstr= "#00c0ef", GradientType= 0) !important;
  background: -o-linear-gradient(#14d1ff, #00c0ef) !important;
}

.bg-yellow-gradient {
  color: #fff;
  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= "#f7bc60", endColorstr= "#f39c12", GradientType= 0) !important;
  background: -o-linear-gradient(#f7bc60, #f39c12) !important;
}

.bg-purple-gradient {
  color: #fff;
  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= "#9491c4", endColorstr= "#6c7e9d", GradientType= 0) !important;
  background: -o-linear-gradient(#9491c4, #6c7e9d) !important;
}

.bg-green-gradient {
  color: #fff;
  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= "#00ca6d", endColorstr= "#00a65a", GradientType= 0) !important;
  background: -o-linear-gradient(#00ca6d, #00a65a) !important;
}

.bg-red-gradient {
  color: #fff;
  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= "#e47365", endColorstr= "#dd4b39", GradientType= 0) !important;
  background: -o-linear-gradient(#e47365, #dd4b39) !important;
}

.bg-black-gradient {
  color: #fff;
  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= "#2b2b2b", endColorstr= "#111111", GradientType= 0) !important;
  background: -o-linear-gradient(#2b2b2b, #111) !important;
}

.bg-maroon-gradient {
  color: #fff;
  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= "#e73f7c", endColorstr= "#d81b60", GradientType= 0) !important;
  background: -o-linear-gradient(#e73f7c, #d81b60) !important;
}

.description-block .description-icon {
  font-size: 16px;
}

.no-pad-top {
  padding-top: 0;
}

.position-static {
  position: static !important;
}

.list-header {
  color: #666;
  padding: 10px 4px;
  font-size: 15px;
  font-weight: 700;
}

.list-seperator {
  background: #f4f4f4;
  height: 1px;
  margin: 15px 0 9px;
}

.list-link > a {
  color: #777;
  padding: 4px;
}

.list-link > a:hover {
  color: #222;
}

.font-light {
  font-weight: 300;
}

.user-block:before, .user-block:after {
  content: " ";
  display: table;
}

.user-block:after {
  clear: both;
}

.user-block img {
  float: left;
  width: 40px;
  height: 40px;
}

.user-block .username, .user-block .description, .user-block .comment {
  margin-left: 50px;
  display: block;
}

.user-block .username {
  font-size: 16px;
  font-weight: 600;
}

.user-block .description {
  color: #999;
  font-size: 13px;
}

.user-block.user-block-sm .username, .user-block.user-block-sm .description, .user-block.user-block-sm .comment {
  margin-left: 40px;
}

.user-block.user-block-sm .username {
  font-size: 14px;
}

.img-sm, .img-md, .img-lg, .box-comments .box-comment img, .user-block.user-block-sm img {
  float: left;
}

.img-sm, .box-comments .box-comment img, .user-block.user-block-sm img {
  width: 30px !important;
  height: 30px !important;
}

.img-sm + .img-push {
  margin-left: 40px;
}

.img-md {
  width: 60px;
  height: 60px;
}

.img-md + .img-push {
  margin-left: 70px;
}

.img-lg {
  width: 100px;
  height: 100px;
}

.img-lg + .img-push {
  margin-left: 110px;
}

.img-bordered {
  border: 3px solid #d2d6de;
  padding: 3px;
}

.img-bordered-sm {
  border: 2px solid #d2d6de;
  padding: 2px;
}

.attachment-block {
  background: #f7f7f7;
  border: 1px solid #f4f4f4;
  margin-bottom: 10px;
  padding: 5px;
}

.attachment-block .attachment-img {
  float: left;
  max-width: 100px;
  height: auto;
  max-height: 100px;
}

.attachment-block .attachment-pushed {
  margin-left: 110px;
}

.attachment-block .attachment-heading {
  margin: 0;
}

.attachment-block .attachment-text {
  color: #555;
}

.connectedSortable {
  min-height: 100px;
}

.ui-helper-hidden-accessible {
  clip: rect(0 0 0 0);
  border: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  position: absolute;
  overflow: hidden;
}

.sort-highlight {
  background: #f4f4f4;
  border: 1px dashed #ddd;
  margin-bottom: 10px;
}

.full-opacity-hover {
  opacity: .65;
  filter: alpha(opacity= 65);
}

.full-opacity-hover:hover {
  opacity: 1;
  filter: alpha(opacity= 100);
}

.chart {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.chart svg, .chart canvas {
  width: 100% !important;
}

@media print {
  .no-print, .left-side, .main-header, .content-header {
    display: none !important;
  }

  .content-wrapper, .right-side, .main-footer {
    min-height: 0 !important;
    margin-left: 0 !important;
    transform: translate(0) !important;
  }

  .fixed .content-wrapper, .fixed .right-side {
    padding-top: 0 !important;
  }

  .invoice {
    border: 0;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .invoice-col {
    float: left;
    width: 33.3333%;
  }

  .table-responsive {
    overflow: auto;
  }

  .table-responsive > .table tr th, .table-responsive > .table tr td {
    white-space: normal !important;
  }
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/public/AdminLTE/AdminLTE.min.css","webpack://./services/frontend/public/AdminLTE/AdminLTE.min.css"],"names":[],"mappings":"AADA;ECEE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yDAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yDAAyD;EACzD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,SAAS;EACT,SAAS;EACT,aAAa;AACf;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,4DAA4D;EAC5D,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,2BAA2B;IAC3B,MAAM;EACR;;EAEA;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,MAAM;EACN,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,mCAAmC;IACnC,qDAAqD;EACvD;;EAEA;IACE,mCAAmC;IACnC,sDAAsD;EACxD;;EAEA;IACE,UAAU;IACV,qDAAqD;EACvD;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2GAA2G;AAC7G;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2GAA2G;AAC7G;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2GAA2G;AAC7G;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2GAA2G;AAC7G;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2GAA2G;AAC7G;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,SAAS;EACT,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kIAAkI;EAClI,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kIAAkI;EAClI,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kIAAkI;EAClI,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kIAAkI;EAClI,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kIAAkI;EAClI,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kIAAkI;EAClI,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kIAAkI;EAClI,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kIAAkI;EAClI,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kIAAkI;EAClI,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,kIAAkI;EAClI,2DAA2D;AAC7D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,yBAAyB;IACzB,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,WAAW;IACX,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".layout-boxed html,.layout-boxed body{height:100%}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.wrapper{min-height:100%;position:relative;overflow:hidden}.wrapper:before,.wrapper:after{content:' ';display:table}.wrapper:after{clear:both}.layout-boxed .wrapper{max-width:1250px;margin:0 auto;min-height:100%;box-shadow:0 0 8px rgb(0 0 0 / .5);position:relative}.layout-boxed{background:url(../img/boxed-bg.jpg) repeat fixed}.content-wrapper,.right-side,.main-footer{transition:transform 0.3s ease-in-out,margin 0.3s ease-in-out;margin-left:230px;z-index:820}.layout-top-nav .content-wrapper,.layout-top-nav .right-side,.layout-top-nav .main-footer{margin-left:0}@media (max-width:767px){.content-wrapper,.right-side,.main-footer{margin-left:0}}@media (min-width:768px){.sidebar-collapse .content-wrapper,.sidebar-collapse .right-side,.sidebar-collapse .main-footer{margin-left:0}}@media (max-width:767px){.sidebar-open .content-wrapper,.sidebar-open .right-side,.sidebar-open .main-footer{transform:translate(230px,0)}}.content-wrapper,.right-side{min-height:100%;background-color:#ecf0f5;z-index:800}.main-footer{background:#fff;padding:15px;color:#444;border-top:1px solid #d2d6de}.fixed .main-header,.fixed .main-sidebar,.fixed .left-side{position:fixed}.fixed .main-header{top:0;right:0;left:0}.fixed .content-wrapper,.fixed .right-side{padding-top:50px}@media (max-width:767px){.fixed .content-wrapper,.fixed .right-side{padding-top:100px}}.fixed.layout-boxed .wrapper{max-width:100%}body.hold-transition .content-wrapper,body.hold-transition .right-side,body.hold-transition .main-footer,body.hold-transition .main-sidebar,body.hold-transition .left-side,body.hold-transition .main-header>.navbar,body.hold-transition .main-header .logo{transition:none}.content{min-height:250px;padding:15px;margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}a:hover,a:active,a:focus{outline:none;text-decoration:none;}.page-header{margin:10px 0 20px 0;font-size:22px}.page-header>small{color:#666;display:block;margin-top:5px}.main-header{position:relative;max-height:100px;z-index:1030}.main-header>.navbar{transition:margin-left 0.3s ease-in-out;margin-bottom:0;margin-left:230px;border:none;min-height:50px;border-radius:0}.layout-top-nav .main-header>.navbar{margin-left:0}.main-header #navbar-search-input.form-control{background:rgb(255 255 255 / .2);border-color:#fff0}.main-header #navbar-search-input.form-control:focus,.main-header #navbar-search-input.form-control:active{border-color:rgb(0 0 0 / .1);background:rgb(255 255 255 / .9)}.main-header #navbar-search-input.form-control::-moz-placeholder{color:#ccc;opacity:1}.main-header #navbar-search-input.form-control:-ms-input-placeholder{color:#ccc}.main-header #navbar-search-input.form-control::-webkit-input-placeholder{color:#ccc}.main-header .navbar-custom-menu,.main-header .navbar-right{float:right}@media (max-width:991px){.main-header .navbar-custom-menu a,.main-header .navbar-right a{color:inherit;background:#fff0}}.main-header .navbar .nav>li.user>a>.fa,.main-header .navbar .nav>li.user>a>.glyphicon,.main-header .navbar .nav>li.user>a>.ion{margin-right:5px}.main-header .navbar .nav>li>a>.label{position:absolute;top:9px;right:7px;text-align:center;font-size:9px;padding:2px 3px;line-height:.9}.main-header .logo{transition:width 0.3s ease-in-out;display:block;float:left;height:50px;font-size:20px;line-height:50px;text-align:center;width:230px;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;padding:0 15px;font-weight:300;overflow:hidden}.main-header .logo .logo-lg{display:block}.main-header .logo .logo-mini{display:none}.main-header .navbar-brand{color:#fff}.content-header{position:relative;padding:15px 15px 0 15px}.content-header>h1{margin:0;font-size:24px}.content-header>h1>small{font-size:15px;display:inline-block;padding-left:4px;font-weight:300}.content-header>.breadcrumb{float:right;background:#fff0;margin-top:0;margin-bottom:0;font-size:12px;padding:7px 5px;position:absolute;top:15px;right:10px;border-radius:2px}.content-header>.breadcrumb>li>a{color:#444;text-decoration:none;display:inline-block}.content-header>.breadcrumb>li>a>.fa,.content-header>.breadcrumb>li>a>.glyphicon,.content-header>.breadcrumb>li>a>.ion{margin-right:5px}.content-header>.breadcrumb>li+li:before{content:'>\\00a0'}@media (max-width:991px){.content-header>.breadcrumb{position:relative;margin-top:5px;top:0;right:0;float:none;background:#d2d6de;padding-left:10px}.content-header>.breadcrumb li:before{color:#97a0b3}}.navbar-toggle{color:#fff;border:0;margin:0;padding:15px 15px}@media (max-width:991px){.navbar-custom-menu .navbar-nav>li{float:left}.navbar-custom-menu .navbar-nav{margin:0;float:left}.navbar-custom-menu .navbar-nav>li>a{padding-top:15px;padding-bottom:15px;line-height:20px}.navbar-collapse.pull-left{float:none!important}.navbar-collapse.pull-left+.navbar-custom-menu{display:block;position:absolute;top:0;right:40px}}.main-sidebar,.left-side{position:absolute;top:0;left:0;padding-top:50px;min-height:100%;width:230px;z-index:810;transition:transform 0.3s ease-in-out,width 0.3s ease-in-out}@media (max-width:767px){.main-sidebar,.left-side{padding-top:100px;transform:translate(-230px,0)}}@media (min-width:768px){.sidebar-collapse .main-sidebar,.sidebar-collapse .left-side{transform:translate(-230px,0)}}@media (max-width:767px){.sidebar-open .main-sidebar,.sidebar-open .left-side{transform:translate(0,0)}}.sidebar{padding-bottom:10px}.sidebar-form input:focus{border-color:#fff0}.user-panel{position:relative;width:100%;padding:10px;overflow:hidden}.user-panel:before,.user-panel:after{content:' ';display:table}.user-panel:after{clear:both}.user-panel>.image>img{width:100%;max-width:45px;height:auto}.user-panel>.info{padding:5px 5px 5px 15px;line-height:1;position:absolute;left:55px}.user-panel>.info>p{font-weight:600;margin-bottom:9px}.user-panel>.info>a{text-decoration:none;padding-right:5px;margin-top:3px;font-size:11px}.user-panel>.info>a>.fa,.user-panel>.info>a>.ion,.user-panel>.info>a>.glyphicon{margin-right:3px}.sidebar-menu{list-style:none;margin:0;padding:0}.sidebar-menu>li{position:relative;margin:0;padding:0}.sidebar-menu>li>a{padding:12px 5px 12px 15px;display:block}.sidebar-menu>li>a>.fa,.sidebar-menu>li>a>.glyphicon,.sidebar-menu>li>a>.ion{width:20px}.sidebar-menu>li .label,.sidebar-menu>li .badge{margin-top:3px;margin-right:5px}.sidebar-menu li.header{padding:10px 25px 10px 15px;font-size:12px}.sidebar-menu li>a>.fa-angle-left{width:auto;height:auto;padding:0;margin-right:10px;margin-top:3px}.sidebar-menu li.active>a>.fa-angle-left{transform:rotate(-90deg)}.sidebar-menu li.active>.treeview-menu{display:block}.sidebar-menu .treeview-menu{display:none;list-style:none;padding:0;margin:0;padding-left:5px}.sidebar-menu .treeview-menu .treeview-menu{padding-left:20px}.sidebar-menu .treeview-menu>li{margin:0}.sidebar-menu .treeview-menu>li>a{padding:5px 5px 5px 15px;display:block;font-size:14px}.sidebar-menu .treeview-menu>li>a>.fa,.sidebar-menu .treeview-menu>li>a>.glyphicon,.sidebar-menu .treeview-menu>li>a>.ion{width:20px}.sidebar-menu .treeview-menu>li>a>.fa-angle-left,.sidebar-menu .treeview-menu>li>a>.fa-angle-down{width:auto}@media (min-width:768px){.sidebar-mini.sidebar-collapse .content-wrapper,.sidebar-mini.sidebar-collapse .right-side,.sidebar-mini.sidebar-collapse .main-footer{margin-left:50px!important;z-index:840}.sidebar-mini.sidebar-collapse .main-sidebar{transform:translate(0,0);width:50px!important;z-index:850}.sidebar-mini.sidebar-collapse .sidebar-menu>li{position:relative}.sidebar-mini.sidebar-collapse .sidebar-menu>li>a{margin-right:0}.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>span{border-top-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:not(.treeview)>a>span{border-bottom-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li>.treeview-menu{padding-top:5px;padding-bottom:5px;border-bottom-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>span:not(.pull-right),.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>.treeview-menu{display:block!important;position:absolute;width:180px;left:50px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>span{top:0;margin-left:-3px;padding:12px 5px 12px 20px;background-color:inherit}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>.treeview-menu{top:44px;margin-left:0}.sidebar-mini.sidebar-collapse .main-sidebar .user-panel>.info,.sidebar-mini.sidebar-collapse .sidebar-form,.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>span,.sidebar-mini.sidebar-collapse .sidebar-menu>li>.treeview-menu,.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>.pull-right,.sidebar-mini.sidebar-collapse .sidebar-menu li.header{display:none!important;-webkit-transform:translateZ(0)}.sidebar-mini.sidebar-collapse .main-header .logo{width:50px}.sidebar-mini.sidebar-collapse .main-header .logo>.logo-mini{display:block;margin-left:-15px;margin-right:-15px;font-size:18px}.sidebar-mini.sidebar-collapse .main-header .logo>.logo-lg{display:none}.sidebar-mini.sidebar-collapse .main-header .navbar{margin-left:50px}}.sidebar-menu,.main-sidebar .user-panel,.sidebar-menu>li.header{white-space:nowrap;overflow:hidden}.sidebar-menu:hover{overflow:visible}.sidebar-form,.sidebar-menu>li.header{overflow:hidden;text-overflow:clip}.sidebar-menu li>a{position:relative}.sidebar-menu li>a>.pull-right{position:absolute;right:10px;top:50%;margin-top:-7px}.control-sidebar-bg{position:fixed;z-index:1000;bottom:0}.control-sidebar-bg,.control-sidebar{top:0;right:-230px;width:230px;transition:right 0.3s ease-in-out}.control-sidebar{position:absolute;padding-top:50px;z-index:1010}@media (max-width:768px){.control-sidebar{padding-top:100px}}.control-sidebar>.tab-content{padding:10px 15px}.control-sidebar.control-sidebar-open,.control-sidebar.control-sidebar-open+.control-sidebar-bg{right:0}.control-sidebar-open .control-sidebar-bg,.control-sidebar-open .control-sidebar{right:0}@media (min-width:768px){.control-sidebar-open .content-wrapper,.control-sidebar-open .right-side,.control-sidebar-open .main-footer{margin-right:230px}}.nav-tabs.control-sidebar-tabs>li:first-of-type>a,.nav-tabs.control-sidebar-tabs>li:first-of-type>a:hover,.nav-tabs.control-sidebar-tabs>li:first-of-type>a:focus{border-left-width:0}.nav-tabs.control-sidebar-tabs>li>a{border-radius:0}.nav-tabs.control-sidebar-tabs>li>a,.nav-tabs.control-sidebar-tabs>li>a:hover{border-top:none;border-right:none;border-left:1px solid #fff0;border-bottom:1px solid #fff0}.nav-tabs.control-sidebar-tabs>li>a .icon{font-size:16px}.nav-tabs.control-sidebar-tabs>li.active>a,.nav-tabs.control-sidebar-tabs>li.active>a:hover,.nav-tabs.control-sidebar-tabs>li.active>a:focus,.nav-tabs.control-sidebar-tabs>li.active>a:active{border-top:none;border-right:none;border-bottom:none}@media (max-width:768px){.nav-tabs.control-sidebar-tabs{display:table}.nav-tabs.control-sidebar-tabs>li{display:table-cell}}.control-sidebar-heading{font-weight:400;font-size:16px;padding:10px 0;margin-bottom:10px}.control-sidebar-subheading{display:block;font-weight:400;font-size:14px}.control-sidebar-menu{list-style:none;padding:0;margin:0 -15px}.control-sidebar-menu>li>a{display:block;padding:10px 15px}.control-sidebar-menu>li>a:before,.control-sidebar-menu>li>a:after{content:' ';display:table}.control-sidebar-menu>li>a:after{clear:both}.control-sidebar-menu>li>a>.control-sidebar-subheading{margin-top:0}.control-sidebar-menu .menu-icon{float:left;width:35px;height:35px;border-radius:50%;text-align:center;line-height:35px}.control-sidebar-menu .menu-info{margin-left:45px;margin-top:3px}.control-sidebar-menu .menu-info>.control-sidebar-subheading{margin:0}.control-sidebar-menu .menu-info>p{margin:0;font-size:11px}.control-sidebar-menu .progress{margin:0}.control-sidebar-dark{color:#b8c7ce}.control-sidebar-dark,.control-sidebar-dark+.control-sidebar-bg{background:#222d32}.control-sidebar-dark .nav-tabs.control-sidebar-tabs{border-bottom:#1c2529}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a{background:#181f23;color:#b8c7ce}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:focus{border-left-color:#141a1d;border-bottom-color:#141a1d}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:active{background:#1c2529}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover{color:#fff}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:hover,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:focus,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:active{background:#222d32;color:#fff}.control-sidebar-dark .control-sidebar-heading,.control-sidebar-dark .control-sidebar-subheading{color:#fff}.control-sidebar-dark .control-sidebar-menu>li>a:hover{background:#1e282c}.control-sidebar-dark .control-sidebar-menu>li>a .menu-info>p{color:#b8c7ce}.control-sidebar-light{color:#5e5e5e}.control-sidebar-light,.control-sidebar-light+.control-sidebar-bg{background:#f9fafc;border-left:1px solid #d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs{border-bottom:#d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a{background:#e8ecf4;color:#444}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:hover,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:focus{border-left-color:#d2d6de;border-bottom-color:#d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:hover,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:active{background:#eff1f7}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:hover,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:focus,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:active{background:#f9fafc;color:#111}.control-sidebar-light .control-sidebar-heading,.control-sidebar-light .control-sidebar-subheading{color:#111}.control-sidebar-light .control-sidebar-menu{margin-left:-14px}.control-sidebar-light .control-sidebar-menu>li>a:hover{background:#f4f4f5}.control-sidebar-light .control-sidebar-menu>li>a .menu-info>p{color:#5e5e5e}.dropdown-menu{box-shadow:none;border-color:#eee}.dropdown-menu>li>a{color:#777}.dropdown-menu>li>a>.glyphicon,.dropdown-menu>li>a>.fa,.dropdown-menu>li>a>.ion{margin-right:10px}.dropdown-menu>li>a:hover{background-color:#e1e3e9;color:#333}.dropdown-menu>.divider{background-color:#eee}.navbar-nav>.notifications-menu>.dropdown-menu,.navbar-nav>.messages-menu>.dropdown-menu,.navbar-nav>.tasks-menu>.dropdown-menu{width:280px;padding:0 0 0 0;margin:0;top:100%}.navbar-nav>.notifications-menu>.dropdown-menu>li,.navbar-nav>.messages-menu>.dropdown-menu>li,.navbar-nav>.tasks-menu>.dropdown-menu>li{position:relative}.navbar-nav>.notifications-menu>.dropdown-menu>li.header,.navbar-nav>.messages-menu>.dropdown-menu>li.header,.navbar-nav>.tasks-menu>.dropdown-menu>li.header{border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0;background-color:#fff;padding:7px 10px;border-bottom:1px solid #f4f4f4;color:#444;font-size:14px}.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a,.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px;font-size:12px;background-color:#fff;padding:7px 10px;border-bottom:1px solid #eee;color:#444!important;text-align:center}.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a:hover,.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a:hover,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a:hover{text-decoration:none;font-weight:400}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu,.navbar-nav>.messages-menu>.dropdown-menu>li .menu,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu{max-height:200px;margin:0;padding:0;list-style:none;overflow-x:hidden}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a,.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a{display:block;white-space:nowrap;border-bottom:1px solid #f4f4f4}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a:hover,.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:hover,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background:#f4f4f4;text-decoration:none}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a{color:#444;overflow:hidden;text-overflow:ellipsis;padding:10px}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.glyphicon,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.fa,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.ion{width:20px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a{margin:0;padding:10px 10px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>div>img{margin:auto 10px auto auto;width:40px;height:40px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>h4{padding:0;margin:0 0 0 45px;color:#444;font-size:15px;position:relative}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>h4>small{color:#999;font-size:10px;position:absolute;top:0;right:0}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>p{margin:0 0 0 45px;font-size:12px;color:#888}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:before,.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:after{content:' ';display:table}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:after{clear:both}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a{padding:10px}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a>h3{font-size:14px;padding:0;margin:0 0 10px 0;color:#666}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a>.progress{padding:0;margin:0}.navbar-nav>.user-menu>.dropdown-menu{border-top-right-radius:0;border-top-left-radius:0;padding:1px 0 0 0;border-top-width:0;width:280px}.navbar-nav>.user-menu>.dropdown-menu,.navbar-nav>.user-menu>.dropdown-menu>.user-body{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.navbar-nav>.user-menu>.dropdown-menu>li.user-header{height:175px;padding:10px;text-align:center}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>img{z-index:5;height:90px;width:90px;border:3px solid;border-color:#fff0;border-color:rgb(255 255 255 / .2)}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>p{z-index:5;color:#fff;color:rgb(255 255 255 / .8);font-size:17px;margin-top:10px}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>p>small{display:block;font-size:12px}.navbar-nav>.user-menu>.dropdown-menu>.user-body{padding:15px;border-bottom:1px solid #f4f4f4;border-top:1px solid #ddd}.navbar-nav>.user-menu>.dropdown-menu>.user-body:before,.navbar-nav>.user-menu>.dropdown-menu>.user-body:after{content:' ';display:table}.navbar-nav>.user-menu>.dropdown-menu>.user-body:after{clear:both}.navbar-nav>.user-menu>.dropdown-menu>.user-body a{color:#444!important}@media (max-width:991px){.navbar-nav>.user-menu>.dropdown-menu>.user-body a{background:#fff!important;color:#444!important}}.navbar-nav>.user-menu>.dropdown-menu>.user-footer{background-color:#f9f9f9;padding:10px}.navbar-nav>.user-menu>.dropdown-menu>.user-footer:before,.navbar-nav>.user-menu>.dropdown-menu>.user-footer:after{content:' ';display:table}.navbar-nav>.user-menu>.dropdown-menu>.user-footer:after{clear:both}.navbar-nav>.user-menu>.dropdown-menu>.user-footer .btn-default{color:#666}.navbar-nav>.user-menu .user-image{float:left;width:25px;height:25px;border-radius:50%;margin-right:10px;margin-top:-2px}.open:not(.dropup)>.animated-dropdown-menu{backface-visibility:visible!important;animation:flipInX 0.7s both}@keyframes flipInX{0%{transform:perspective(400px) rotate3d(1,0,0,90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotate3d(1,0,0,-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotate3d(1,0,0,10deg);opacity:1}80%{transform:perspective(400px) rotate3d(1,0,0,-5deg)}100%{transform:perspective(400px)}}.navbar-custom-menu>.navbar-nav>li{position:relative}.navbar-custom-menu>.navbar-nav>li>.dropdown-menu{position:absolute;right:0;left:auto}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}.form-control:focus{border-color:#3c8dbc;box-shadow:none}.form-control::-moz-placeholder,.form-control:-ms-input-placeholder,.form-control::-webkit-input-placeholder{color:#bbb;opacity:1}.form-control:not(select){appearance:none}.form-group.has-success label{color:#00a65a}.form-group.has-success .form-control{border-color:#00a65a;box-shadow:none}.form-group.has-success .help-block{color:#00a65a}.form-group.has-warning label{color:#f39c12}.form-group.has-warning .form-control{border-color:#f39c12;box-shadow:none}.form-group.has-warning .help-block{color:#f39c12}.form-group.has-error label{color:#dd4b39}.form-group.has-error .form-control{border-color:#dd4b39;box-shadow:none}.form-group.has-error .help-block{color:#dd4b39}.input-group .input-group-addon{border-radius:0;border-color:#d2d6de;background-color:#fff}.btn-group-vertical .btn.btn-flat:first-of-type,.btn-group-vertical .btn.btn-flat:last-of-type{border-radius:0}.icheck>label{padding-left:0}.form-control-feedback.fa{line-height:34px}.input-lg+.form-control-feedback.fa,.input-group-lg+.form-control-feedback.fa,.form-group-lg .form-control+.form-control-feedback.fa{line-height:46px}.input-sm+.form-control-feedback.fa,.input-group-sm+.form-control-feedback.fa,.form-group-sm .form-control+.form-control-feedback.fa{line-height:30px}.progress,.progress>.progress-bar{box-shadow:none}.progress,.progress>.progress-bar,.progress .progress-bar,.progress>.progress-bar .progress-bar{border-radius:1px}.progress.sm,.progress-sm{height:10px}.progress.sm,.progress-sm,.progress.sm .progress-bar,.progress-sm .progress-bar{border-radius:1px}.progress.xs,.progress-xs{height:7px}.progress.xs,.progress-xs,.progress.xs .progress-bar,.progress-xs .progress-bar{border-radius:1px}.progress.xxs,.progress-xxs{height:3px}.progress.xxs,.progress-xxs,.progress.xxs .progress-bar,.progress-xxs .progress-bar{border-radius:1px}.progress.vertical{position:relative;width:30px;height:200px;display:inline-block;margin-right:10px}.progress.vertical>.progress-bar{width:100%;position:absolute;bottom:0}.progress.vertical.sm,.progress.vertical.progress-sm{width:20px}.progress.vertical.xs,.progress.vertical.progress-xs{width:10px}.progress.vertical.xxs,.progress.vertical.progress-xxs{width:3px}.progress-group .progress-text{font-weight:600}.progress-group .progress-number{float:right}.table tr>td .progress{margin:0}.progress-bar-light-blue,.progress-bar-primary{background-color:#3c8dbc}.progress-striped .progress-bar-light-blue,.progress-striped .progress-bar-primary{background-image:linear-gradient(45deg,rgb(255 255 255 / .15) 25%,transparent 25%,transparent 50%,rgb(255 255 255 / .15) 50%,rgb(255 255 255 / .15) 75%,transparent 75%,transparent)}.progress-bar-green,.progress-bar-success{background-color:#00a65a}.progress-striped .progress-bar-green,.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,rgb(255 255 255 / .15) 25%,transparent 25%,transparent 50%,rgb(255 255 255 / .15) 50%,rgb(255 255 255 / .15) 75%,transparent 75%,transparent)}.progress-bar-aqua,.progress-bar-info{background-color:#00c0ef}.progress-striped .progress-bar-aqua,.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,rgb(255 255 255 / .15) 25%,transparent 25%,transparent 50%,rgb(255 255 255 / .15) 50%,rgb(255 255 255 / .15) 75%,transparent 75%,transparent)}.progress-bar-yellow,.progress-bar-warning{background-color:#f39c12}.progress-striped .progress-bar-yellow,.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,rgb(255 255 255 / .15) 25%,transparent 25%,transparent 50%,rgb(255 255 255 / .15) 50%,rgb(255 255 255 / .15) 75%,transparent 75%,transparent)}.progress-bar-red,.progress-bar-danger{background-color:#dd4b39}.progress-striped .progress-bar-red,.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,rgb(255 255 255 / .15) 25%,transparent 25%,transparent 50%,rgb(255 255 255 / .15) 50%,rgb(255 255 255 / .15) 75%,transparent 75%,transparent)}.small-box{border-radius:2px;position:relative;display:block;margin-bottom:20px;box-shadow:0 1px 1px rgb(0 0 0 / .1)}.small-box>.inner{padding:10px}.small-box>.small-box-footer{position:relative;text-align:center;padding:3px 0;color:#fff;color:rgb(255 255 255 / .8);display:block;z-index:10;background:rgb(0 0 0 / .1);text-decoration:none}.small-box>.small-box-footer:hover{color:#fff;background:rgb(0 0 0 / .15)}.small-box h3{font-size:38px;font-weight:700;margin:0 0 10px 0;white-space:nowrap;padding:0}.small-box p{font-size:15px}.small-box p>small{display:block;color:#f9f9f9;font-size:13px;margin-top:5px}.small-box h3,.small-box p{z-index:5}.small-box .icon{transition:all 0.3s linear;position:absolute;top:-10px;right:10px;z-index:0;font-size:90px;color:rgb(0 0 0 / .15)}.small-box:hover{text-decoration:none;color:#f9f9f9}.small-box:hover .icon{font-size:95px}@media (max-width:767px){.small-box{text-align:center}.small-box .icon{display:none}.small-box p{font-size:12px}}.box{position:relative;border-radius:3px;background:#fff;border-top:3px solid #d2d6de;margin-bottom:20px;width:100%;box-shadow:0 1px 1px rgb(0 0 0 / .1)}.box.box-primary{border-top-color:#3c8dbc}.box.box-info{border-top-color:#00c0ef}.box.box-danger{border-top-color:#dd4b39}.box.box-warning{border-top-color:#f39c12}.box.box-success{border-top-color:#00a65a}.box.box-default{border-top-color:#d2d6de}.box.collapsed-box .box-body,.box.collapsed-box .box-footer{display:none}.box .nav-stacked>li{border-bottom:1px solid #f4f4f4;margin:0}.box .nav-stacked>li:last-of-type{border-bottom:none}.box.height-control .box-body{max-height:300px;overflow:auto}.box .border-right{border-right:1px solid #f4f4f4}.box .border-left{border-left:1px solid #f4f4f4}.box.box-solid{border-top:0}.box.box-solid>.box-header .btn.btn-default{background:#fff0}.box.box-solid>.box-header .btn:hover,.box.box-solid>.box-header a:hover{background:rgb(0 0 0 / .1)}.box.box-solid.box-default{border:1px solid #d2d6de}.box.box-solid.box-default>.box-header{color:#444;background:#d2d6de;background-color:#d2d6de}.box.box-solid.box-default>.box-header a,.box.box-solid.box-default>.box-header .btn{color:#444}.box.box-solid.box-primary{border:1px solid #3c8dbc}.box.box-solid.box-primary>.box-header{color:#fff;background:#3c8dbc;background-color:#3c8dbc}.box.box-solid.box-primary>.box-header a,.box.box-solid.box-primary>.box-header .btn{color:#fff}.box.box-solid.box-info{border:1px solid #00c0ef}.box.box-solid.box-info>.box-header{color:#fff;background:#00c0ef;background-color:#00c0ef}.box.box-solid.box-info>.box-header a,.box.box-solid.box-info>.box-header .btn{color:#fff}.box.box-solid.box-danger{border:1px solid #dd4b39}.box.box-solid.box-danger>.box-header{color:#fff;background:#dd4b39;background-color:#dd4b39}.box.box-solid.box-danger>.box-header a,.box.box-solid.box-danger>.box-header .btn{color:#fff}.box.box-solid.box-warning{border:1px solid #f39c12}.box.box-solid.box-warning>.box-header{color:#fff;background:#f39c12;background-color:#f39c12}.box.box-solid.box-warning>.box-header a,.box.box-solid.box-warning>.box-header .btn{color:#fff}.box.box-solid.box-success{border:1px solid #00a65a}.box.box-solid.box-success>.box-header{color:#fff;background:#00a65a;background-color:#00a65a}.box.box-solid.box-success>.box-header a,.box.box-solid.box-success>.box-header .btn{color:#fff}.box.box-solid>.box-header>.box-tools .btn{border:0;box-shadow:none}.box.box-solid[class*='bg']>.box-header{color:#fff}.box .box-group>.box{margin-bottom:5px}.box .knob-label{text-align:center;color:#333;font-weight:100;font-size:12px;margin-bottom:.3em}.box>.overlay,.overlay-wrapper>.overlay,.box>.loading-img,.overlay-wrapper>.loading-img{position:absolute;top:0;left:0;width:100%;height:100%}.box .overlay,.overlay-wrapper .overlay{z-index:50;background:rgb(255 255 255 / .7);border-radius:3px}.box .overlay>.fa,.overlay-wrapper .overlay>.fa{position:absolute;top:50%;left:50%;margin-left:-15px;margin-top:-15px;color:#000;font-size:30px}.box .overlay.dark,.overlay-wrapper .overlay.dark{background:rgb(0 0 0 / .5)}.box-header:before,.box-body:before,.box-footer:before,.box-header:after,.box-body:after,.box-footer:after{content:' ';display:table}.box-header:after,.box-body:after,.box-footer:after{clear:both}.box-header{color:#444;display:block;padding:10px;position:relative}.box-header.with-border{border-bottom:1px solid #f4f4f4}.collapsed-box .box-header.with-border{border-bottom:none}.box-header>.fa,.box-header>.glyphicon,.box-header>.ion,.box-header .box-title{display:inline-block;font-size:18px;margin:0;line-height:1}.box-header>.fa,.box-header>.glyphicon,.box-header>.ion{margin-right:5px}.box-header>.box-tools{position:absolute;right:10px;top:5px}.box-header>.box-tools [data-toggle='tooltip']{position:relative}.box-header>.box-tools.pull-right .dropdown-menu{right:0;left:auto}.btn-box-tool{padding:5px;font-size:12px;background:#fff0;color:#97a0b3}.open .btn-box-tool,.btn-box-tool:hover{color:#606c84}.btn-box-tool.btn:active{box-shadow:none}.box-body{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px;padding:10px}.no-header .box-body{border-top-right-radius:3px;border-top-left-radius:3px}.box-body>.table{margin-bottom:0}.box-body .fc{margin-top:5px}.box-body .full-width-chart{margin:-19px}.box-body.no-padding .full-width-chart{margin:-9px}.box-body .box-pane{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:3px}.box-body .box-pane-right{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:0}.box-footer{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px;border-top:1px solid #f4f4f4;padding:10px;background-color:#fff}.chart-legend{margin:10px 0}@media (max-width:991px){.chart-legend>li{float:left;margin-right:10px}}.box-comments{background:#f7f7f7}.box-comments .box-comment{padding:8px 0;border-bottom:1px solid #eee}.box-comments .box-comment:before,.box-comments .box-comment:after{content:' ';display:table}.box-comments .box-comment:after{clear:both}.box-comments .box-comment:last-of-type{border-bottom:0}.box-comments .box-comment:first-of-type{padding-top:0}.box-comments .box-comment img{float:left}.box-comments .comment-text{margin-left:40px;color:#555}.box-comments .username{color:#444;display:block;font-weight:600}.box-comments .text-muted{font-weight:400;font-size:12px}.todo-list{margin:0;padding:0;list-style:none;overflow:auto}.todo-list>li{border-radius:2px;padding:10px;background:#f4f4f4;margin-bottom:2px;border-left:2px solid #e6e7e8;color:#444}.todo-list>li:last-of-type{margin-bottom:0}.todo-list>li>input[type='checkbox']{margin:0 10px 0 5px}.todo-list>li .text{display:inline-block;margin-left:5px;font-weight:600}.todo-list>li .label{margin-left:10px;font-size:9px}.todo-list>li .tools{display:none;float:right;color:#dd4b39}.todo-list>li .tools>.fa,.todo-list>li .tools>.glyphicon,.todo-list>li .tools>.ion{margin-right:5px;cursor:pointer}.todo-list>li:hover .tools{display:inline-block}.todo-list>li.done{color:#999}.todo-list>li.done .text{text-decoration:line-through;font-weight:500}.todo-list>li.done .label{background:#d2d6de!important}.todo-list .danger{border-left-color:#dd4b39}.todo-list .warning{border-left-color:#f39c12}.todo-list .info{border-left-color:#00c0ef}.todo-list .success{border-left-color:#00a65a}.todo-list .primary{border-left-color:#3c8dbc}.todo-list .handle{display:inline-block;cursor:move;margin:0 5px}.chat{padding:5px 20px 5px 10px}.chat .item{margin-bottom:10px}.chat .item:before,.chat .item:after{content:' ';display:table}.chat .item:after{clear:both}.chat .item>img{width:40px;height:40px;border:2px solid #fff0;border-radius:50%}.chat .item>.online{border:2px solid #00a65a}.chat .item>.offline{border:2px solid #dd4b39}.chat .item>.message{margin-left:55px;margin-top:-40px}.chat .item>.message>.name{display:block;font-weight:600}.chat .item>.attachment{border-radius:3px;background:#f4f4f4;margin-left:65px;margin-right:15px;padding:10px}.chat .item>.attachment>h4{margin:0 0 5px 0;font-weight:600;font-size:14px}.chat .item>.attachment>p,.chat .item>.attachment>.filename{font-weight:600;font-size:13px;font-style:italic;margin:0}.chat .item>.attachment:before,.chat .item>.attachment:after{content:' ';display:table}.chat .item>.attachment:after{clear:both}.box-input{max-width:200px}.modal .panel-body{color:#444}.info-box{display:block;min-height:90px;background:#fff;width:100%;box-shadow:0 1px 1px rgb(0 0 0 / .1);border-radius:2px;margin-bottom:15px}.info-box small{font-size:14px}.info-box .progress{background:rgb(0 0 0 / .2);margin:5px -10px 5px -10px;height:2px}.info-box .progress,.info-box .progress .progress-bar{border-radius:0}.info-box .progress .progress-bar{background:#fff}.info-box-icon{border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px;display:block;float:left;height:90px;width:90px;text-align:center;font-size:45px;line-height:90px;background:rgb(0 0 0 / .2)}.info-box-icon>img{max-width:100%}.info-box-content{padding:5px 10px;margin-left:90px}.info-box-number{display:block;font-weight:700;font-size:18px}.progress-description,.info-box-text{display:block;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.info-box-text{text-transform:uppercase}.info-box-more{display:block}.progress-description{margin:0}.timeline{position:relative;margin:0 0 30px 0;padding:0;list-style:none}.timeline:before{content:'';position:absolute;top:0;bottom:0;width:4px;background:#ddd;left:31px;margin:0;border-radius:2px}.timeline>li{position:relative;margin-right:10px;margin-bottom:15px}.timeline>li:before,.timeline>li:after{content:' ';display:table}.timeline>li:after{clear:both}.timeline>li>.timeline-item{box-shadow:0 1px 1px rgb(0 0 0 / .1);border-radius:3px;margin-top:0;background:#fff;color:#444;margin-left:60px;margin-right:15px;padding:0;position:relative}.timeline>li>.timeline-item>.time{color:#999;float:right;padding:10px;font-size:12px}.timeline>li>.timeline-item>.timeline-header{margin:0;color:#555;border-bottom:1px solid #f4f4f4;padding:10px;font-size:16px;line-height:1.1}.timeline>li>.timeline-item>.timeline-header>a{font-weight:600}.timeline>li>.timeline-item>.timeline-body,.timeline>li>.timeline-item>.timeline-footer{padding:10px}.timeline>li>.fa,.timeline>li>.glyphicon,.timeline>li>.ion{width:30px;height:30px;font-size:15px;line-height:30px;position:absolute;color:#666;background:#d2d6de;border-radius:50%;text-align:center;left:18px;top:0}.timeline>.time-label>span{font-weight:600;padding:5px;display:inline-block;background-color:#fff;border-radius:4px}.timeline-inverse>li>.timeline-item{background:#f0f0f0;border:1px solid #ddd;box-shadow:none}.timeline-inverse>li>.timeline-item>.timeline-header{border-bottom-color:#ddd}.btn{border-radius:3px;box-shadow:none;border:1px solid #fff0}.btn.uppercase{text-transform:uppercase}.btn.btn-flat{border-radius:0;box-shadow:none;border-width:1px}.btn:active{box-shadow:inset 0 3px 5px rgb(0 0 0 / .125)}.btn:focus{outline:none}.btn.btn-file{position:relative;overflow:hidden}.btn.btn-file>input[type='file']{position:absolute;top:0;right:0;min-width:100%;min-height:100%;font-size:100px;text-align:right;opacity:0;filter:alpha(opacity=0);outline:none;background:#fff;cursor:inherit;display:block}.btn-default{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-default:hover,.btn-default:active,.btn-default.hover{background-color:#e7e7e7}.btn-primary{background-color:#3c8dbc;border-color:#367fa9}.btn-primary:hover,.btn-primary:active,.btn-primary.hover{background-color:#367fa9}.btn-success{background-color:#00a65a;border-color:#008d4c}.btn-success:hover,.btn-success:active,.btn-success.hover{background-color:#008d4c}.btn-info{background-color:#00c0ef;border-color:#00acd6}.btn-info:hover,.btn-info:active,.btn-info.hover{background-color:#00acd6}.btn-danger{background-color:#dd4b39;border-color:#d73925}.btn-danger:hover,.btn-danger:active,.btn-danger.hover{background-color:#d73925}.btn-warning{background-color:#f39c12;border-color:#e08e0b}.btn-warning:hover,.btn-warning:active,.btn-warning.hover{background-color:#e08e0b}.btn-outline{border:1px solid #fff;background:#fff0;color:#fff}.btn-outline:hover,.btn-outline:focus,.btn-outline:active{color:rgb(255 255 255 / .7);border-color:rgb(255 255 255 / .7)}.btn-link{box-shadow:none}.btn[class*='bg-']:hover{box-shadow:inset 0 0 100px rgb(0 0 0 / .2)}.btn-app{border-radius:3px;position:relative;padding:15px 5px;margin:0 0 10px 10px;min-width:80px;height:60px;text-align:center;color:#666;border:1px solid #ddd;background-color:#f4f4f4;font-size:12px}.btn-app>.fa,.btn-app>.glyphicon,.btn-app>.ion{font-size:20px;display:block}.btn-app:hover{background:#f4f4f4;color:#444;border-color:#aaa}.btn-app:active,.btn-app:focus{box-shadow:inset 0 3px 5px rgb(0 0 0 / .125)}.btn-app>.badge{position:absolute;top:-3px;right:-10px;font-size:10px;font-weight:400}.callout{border-radius:3px;margin:0 0 20px 0;padding:15px 30px 15px 15px;border-left:5px solid #eee}.callout a{color:#fff;text-decoration:underline}.callout a:hover{color:#eee}.callout h4{margin-top:0;font-weight:600}.callout p:last-child{margin-bottom:0}.callout code,.callout .highlight{background-color:#fff}.callout.callout-danger{border-color:#c23321}.callout.callout-warning{border-color:#c87f0a}.callout.callout-info{border-color:#0097bc}.callout.callout-success{border-color:#00733e}.alert{border-radius:3px}.alert h4{font-weight:600}.alert .icon{margin-right:10px}.alert .close{color:#000;opacity:.2;filter:alpha(opacity=20)}.alert .close:hover{opacity:.5;filter:alpha(opacity=50)}.alert a{color:#fff;text-decoration:underline}.alert-success{border-color:#008d4c}.alert-danger,.alert-error{border-color:#d73925}.alert-warning{border-color:#e08e0b}.alert-info{border-color:#00acd6}.nav>li>a:hover,.nav>li>a:active,.nav>li>a:focus{color:#444;background:#f7f7f7}.nav-pills>li>a{border-radius:0;border-top:3px solid #fff0;color:#444}.nav-pills>li>a>.fa,.nav-pills>li>a>.glyphicon,.nav-pills>li>a>.ion{margin-right:5px}.nav-pills>li.active>a,.nav-pills>li.active>a:hover,.nav-pills>li.active>a:focus{border-top-color:#3c8dbc}.nav-pills>li.active>a{font-weight:600}.nav-stacked>li>a{border-radius:0;border-top:0;border-left:3px solid #fff0;color:#444}.nav-stacked>li.active>a,.nav-stacked>li.active>a:hover{background:#fff0;color:#444;border-top:0;border-left-color:#3c8dbc}.nav-stacked>li.header{border-bottom:1px solid #ddd;color:#777;margin-bottom:10px;padding:5px 10px;text-transform:uppercase}.nav-tabs-custom{margin-bottom:20px;background:#fff;box-shadow:0 1px 1px rgb(0 0 0 / .1);border-radius:3px}.nav-tabs-custom>.nav-tabs{margin:0;border-bottom-color:#f4f4f4;border-top-right-radius:3px;border-top-left-radius:3px}.nav-tabs-custom>.nav-tabs>li{border-top:3px solid #fff0;margin-bottom:-2px;margin-right:5px}.nav-tabs-custom>.nav-tabs>li>a{color:#444;border-radius:0}.nav-tabs-custom>.nav-tabs>li>a.text-muted{color:#999}.nav-tabs-custom>.nav-tabs>li>a,.nav-tabs-custom>.nav-tabs>li>a:hover{background:#fff0;margin:0}.nav-tabs-custom>.nav-tabs>li>a:hover{color:#999}.nav-tabs-custom>.nav-tabs>li:not(.active)>a:hover,.nav-tabs-custom>.nav-tabs>li:not(.active)>a:focus,.nav-tabs-custom>.nav-tabs>li:not(.active)>a:active{border-color:#fff0}.nav-tabs-custom>.nav-tabs>li.active{border-top-color:#3c8dbc}.nav-tabs-custom>.nav-tabs>li.active>a,.nav-tabs-custom>.nav-tabs>li.active:hover>a{background-color:#fff;color:#444}.nav-tabs-custom>.nav-tabs>li.active>a{border-top-color:#fff0;border-left-color:#f4f4f4;border-right-color:#f4f4f4}.nav-tabs-custom>.nav-tabs>li:first-of-type{margin-left:0}.nav-tabs-custom>.nav-tabs>li:first-of-type.active>a{border-left-color:#fff0}.nav-tabs-custom>.nav-tabs.pull-right{float:none!important}.nav-tabs-custom>.nav-tabs.pull-right>li{float:right}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type{margin-right:0}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type>a{border-left-width:1px}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type.active>a{border-left-color:#f4f4f4;border-right-color:#fff0}.nav-tabs-custom>.nav-tabs>li.header{line-height:35px;padding:0 10px;font-size:20px;color:#444}.nav-tabs-custom>.nav-tabs>li.header>.fa,.nav-tabs-custom>.nav-tabs>li.header>.glyphicon,.nav-tabs-custom>.nav-tabs>li.header>.ion{margin-right:5px}.nav-tabs-custom>.tab-content{background:#fff;padding:10px;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.nav-tabs-custom .dropdown.open>a:active,.nav-tabs-custom .dropdown.open>a:focus{background:#fff0;color:#999}.nav-tabs-custom.tab-primary>.nav-tabs>li.active{border-top-color:#3c8dbc}.nav-tabs-custom.tab-info>.nav-tabs>li.active{border-top-color:#00c0ef}.nav-tabs-custom.tab-danger>.nav-tabs>li.active{border-top-color:#dd4b39}.nav-tabs-custom.tab-warning>.nav-tabs>li.active{border-top-color:#f39c12}.nav-tabs-custom.tab-success>.nav-tabs>li.active{border-top-color:#00a65a}.nav-tabs-custom.tab-default>.nav-tabs>li.active{border-top-color:#d2d6de}.pagination>li>a{background:#fafafa;color:#666}.pagination.pagination-flat>li>a{border-radius:0!important}.products-list{list-style:none;margin:0;padding:0}.products-list>.item{border-radius:3px;box-shadow:0 1px 1px rgb(0 0 0 / .1);padding:10px 0;background:#fff}.products-list>.item:before,.products-list>.item:after{content:' ';display:table}.products-list>.item:after{clear:both}.products-list .product-img{float:left}.products-list .product-img img{width:50px;height:50px}.products-list .product-info{margin-left:60px}.products-list .product-title{font-weight:600}.products-list .product-description{display:block;color:#999;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.product-list-in-box>.item{box-shadow:none;border-radius:0;border-bottom:1px solid #f4f4f4}.product-list-in-box>.item:last-of-type{border-bottom-width:0}.table>thead>tr>th,.table>tbody>tr>th,.table>tfoot>tr>th,.table>thead>tr>td,.table>tbody>tr>td,.table>tfoot>tr>td{border-top:1px solid #f4f4f4}.table>thead>tr>th{border-bottom:2px solid #f4f4f4}.table tr td .progress{margin-top:5px}.table-bordered{border:1px solid #f4f4f4}.table-bordered>thead>tr>th,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>tbody>tr>td,.table-bordered>tfoot>tr>td{border:1px solid #f4f4f4}.table-bordered>thead>tr>th,.table-bordered>thead>tr>td{border-bottom-width:2px}.table.no-border,.table.no-border td,.table.no-border th{border:0}table.text-center,table.text-center td,table.text-center th{text-align:center}.table.align th{text-align:left}.table.align td{text-align:right}.label-default{background-color:#d2d6de;color:#444}.direct-chat .box-body{border-bottom-right-radius:0;border-bottom-left-radius:0;position:relative;overflow-x:hidden;padding:0}.direct-chat.chat-pane-open .direct-chat-contacts{transform:translate(0,0)}.direct-chat-messages{transform:translate(0,0);padding:10px;height:250px;overflow:auto}.direct-chat-msg,.direct-chat-text{display:block}.direct-chat-msg{margin-bottom:10px}.direct-chat-msg:before,.direct-chat-msg:after{content:' ';display:table}.direct-chat-msg:after{clear:both}.direct-chat-messages,.direct-chat-contacts{transition:transform 0.5s ease-in-out}.direct-chat-text{border-radius:5px;position:relative;padding:5px 10px;background:#d2d6de;border:1px solid #d2d6de;margin:5px 0 0 50px;color:#444}.direct-chat-text:after,.direct-chat-text:before{position:absolute;right:100%;top:15px;border:solid #fff0;border-right-color:#d2d6de;content:' ';height:0;width:0;pointer-events:none}.direct-chat-text:after{border-width:5px;margin-top:-5px}.direct-chat-text:before{border-width:6px;margin-top:-6px}.right .direct-chat-text{margin-right:50px;margin-left:0}.right .direct-chat-text:after,.right .direct-chat-text:before{right:auto;left:100%;border-right-color:#fff0;border-left-color:#d2d6de}.direct-chat-img{border-radius:50%;float:left;width:40px;height:40px}.right .direct-chat-img{float:right}.direct-chat-info{display:block;margin-bottom:2px;font-size:12px}.direct-chat-name{font-weight:600}.direct-chat-timestamp{color:#999}.direct-chat-contacts-open .direct-chat-contacts{transform:translate(0,0)}.direct-chat-contacts{transform:translate(101%,0);position:absolute;top:0;bottom:0;height:250px;width:100%;background:#222d32;color:#fff;overflow:auto}.contacts-list>li{border-bottom:1px solid rgb(0 0 0 / .2);padding:10px;margin:0}.contacts-list>li:before,.contacts-list>li:after{content:' ';display:table}.contacts-list>li:after{clear:both}.contacts-list>li:last-of-type{border-bottom:none}.contacts-list-img{border-radius:50%;width:40px;float:left}.contacts-list-info{margin-left:45px;color:#fff}.contacts-list-name,.contacts-list-status{display:block}.contacts-list-name{font-weight:600}.contacts-list-status{font-size:12px}.contacts-list-date{color:#aaa;font-weight:400}.contacts-list-msg{color:#999}.direct-chat-danger .right>.direct-chat-text{background:#dd4b39;border-color:#dd4b39;color:#fff}.direct-chat-danger .right>.direct-chat-text:after,.direct-chat-danger .right>.direct-chat-text:before{border-left-color:#dd4b39}.direct-chat-primary .right>.direct-chat-text{background:#3c8dbc;border-color:#3c8dbc;color:#fff}.direct-chat-primary .right>.direct-chat-text:after,.direct-chat-primary .right>.direct-chat-text:before{border-left-color:#3c8dbc}.direct-chat-warning .right>.direct-chat-text{background:#f39c12;border-color:#f39c12;color:#fff}.direct-chat-warning .right>.direct-chat-text:after,.direct-chat-warning .right>.direct-chat-text:before{border-left-color:#f39c12}.direct-chat-info .right>.direct-chat-text{background:#00c0ef;border-color:#00c0ef;color:#fff}.direct-chat-info .right>.direct-chat-text:after,.direct-chat-info .right>.direct-chat-text:before{border-left-color:#00c0ef}.direct-chat-success .right>.direct-chat-text{background:#00a65a;border-color:#00a65a;color:#fff}.direct-chat-success .right>.direct-chat-text:after,.direct-chat-success .right>.direct-chat-text:before{border-left-color:#00a65a}.users-list>li{width:25%;float:left;padding:10px;text-align:center}.users-list>li img{border-radius:50%;max-width:100%;height:auto}.users-list>li>a:hover,.users-list>li>a:hover .users-list-name{color:#999}.users-list-name,.users-list-date{display:block}.users-list-name{font-weight:600;color:#444;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.users-list-date{color:#999;font-size:12px}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.modal{background:rgb(0 0 0 / .3)}.modal-content{border-radius:0;box-shadow:0 2px 3px rgb(0 0 0 / .125);border:0}@media (min-width:768px){.modal-content{box-shadow:0 2px 3px rgb(0 0 0 / .125)}}.modal-header{border-bottom-color:#f4f4f4}.modal-footer{border-top-color:#f4f4f4}.modal-primary .modal-header,.modal-primary .modal-footer{border-color:#307095}.modal-warning .modal-header,.modal-warning .modal-footer{border-color:#c87f0a}.modal-info .modal-header,.modal-info .modal-footer{border-color:#0097bc}.modal-success .modal-header,.modal-success .modal-footer{border-color:#00733e}.modal-danger .modal-header,.modal-danger .modal-footer{border-color:#c23321}.box-widget{border:none;position:relative}.widget-user .widget-user-header{padding:20px;height:120px;border-top-right-radius:3px;border-top-left-radius:3px}.widget-user .widget-user-username{margin-top:0;margin-bottom:5px;font-size:25px;font-weight:300;text-shadow:0 1px 1px rgb(0 0 0 / .2)}.widget-user .widget-user-desc{margin-top:0}.widget-user .widget-user-image{position:absolute;top:65px;left:50%;margin-left:-45px}.widget-user .widget-user-image>img{width:90px;height:auto;border:3px solid #fff}.widget-user .box-footer{padding-top:30px}.widget-user-2 .widget-user-header{padding:20px;border-top-right-radius:3px;border-top-left-radius:3px}.widget-user-2 .widget-user-username{margin-top:5px;margin-bottom:5px;font-size:25px;font-weight:300}.widget-user-2 .widget-user-desc{margin-top:0}.widget-user-2 .widget-user-username,.widget-user-2 .widget-user-desc{margin-left:75px}.widget-user-2 .widget-user-image>img{width:65px;height:auto;float:left}.mailbox-messages>.table{margin:0}.mailbox-controls{padding:5px}.mailbox-controls.with-border{border-bottom:1px solid #f4f4f4}.mailbox-read-info{border-bottom:1px solid #f4f4f4;padding:10px}.mailbox-read-info h3{font-size:20px;margin:0}.mailbox-read-info h5{margin:0;padding:5px 0 0 0}.mailbox-read-time{color:#999;font-size:13px}.mailbox-read-message{padding:10px}.mailbox-attachments li{float:left;width:200px;border:1px solid #eee;margin-bottom:10px;margin-right:10px}.mailbox-attachment-name{font-weight:700;color:#666}.mailbox-attachment-icon,.mailbox-attachment-info,.mailbox-attachment-size{display:block}.mailbox-attachment-info{padding:10px;background:#f4f4f4}.mailbox-attachment-size{color:#999;font-size:12px}.mailbox-attachment-icon{text-align:center;font-size:65px;color:#666;padding:20px 10px}.mailbox-attachment-icon.has-img{padding:0}.mailbox-attachment-icon.has-img>img{max-width:100%;height:auto}.lockscreen{background:#d2d6de}.lockscreen-logo{font-size:35px;text-align:center;margin-bottom:25px;font-weight:300}.lockscreen-logo a{color:#444}.lockscreen-wrapper{max-width:400px;margin:0 auto;margin-top:10%}.lockscreen .lockscreen-name{text-align:center;font-weight:600}.lockscreen-item{border-radius:4px;padding:0;background:#fff;position:relative;margin:10px auto 30px auto;width:290px}.lockscreen-image{border-radius:50%;position:absolute;left:-10px;top:-25px;background:#fff;padding:5px;z-index:10}.lockscreen-image>img{border-radius:50%;width:70px;height:70px}.lockscreen-credentials{margin-left:70px}.lockscreen-credentials .form-control{border:0}.lockscreen-credentials .btn{background-color:#fff;border:0;padding:0 10px}.lockscreen-footer{margin-top:10px}.login-logo,.register-logo{font-size:35px;text-align:center;margin-bottom:25px;font-weight:300}.login-logo a,.register-logo a{color:#444}.login-page,.register-page{background:#d2d6de}.login-box,.register-box{width:360px;margin:7% auto}@media (max-width:768px){.login-box,.register-box{width:90%;margin-top:20px}}.login-box-body,.register-box-body{background:#fff;padding:20px;border-top:0;color:#666}.login-box-body .form-control-feedback,.register-box-body .form-control-feedback{color:#777}.login-box-msg,.register-box-msg{margin:0;text-align:center;padding:0 20px 20px 20px}.social-auth-links{margin:10px 0}.error-page{width:600px;margin:20px auto 0 auto}@media (max-width:991px){.error-page{width:100%}}.error-page>.headline{float:left;font-size:100px;font-weight:300}@media (max-width:991px){.error-page>.headline{float:none;text-align:center}}.error-page>.error-content{margin-left:190px;display:block}@media (max-width:991px){.error-page>.error-content{margin-left:0}}.error-page>.error-content>h3{font-weight:300;font-size:25px}@media (max-width:991px){.error-page>.error-content>h3{text-align:center}}.invoice{position:relative;background:#fff;border:1px solid #f4f4f4;padding:20px;margin:10px 25px}.invoice-title{margin-top:0}.profile-user-img{margin:0 auto;width:100px;padding:3px;border:3px solid #d2d6de}.profile-username{font-size:21px;margin-top:5px}.post{border-bottom:1px solid #d2d6de;margin-bottom:15px;padding-bottom:15px;color:#666}.post:last-of-type{border-bottom:0;margin-bottom:0;padding-bottom:0}.post .user-block{margin-bottom:15px}.btn-social{position:relative;padding-left:44px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.btn-social>:first-child{position:absolute;left:0;top:0;bottom:0;width:32px;line-height:34px;font-size:1.6em;text-align:center;border-right:1px solid rgb(0 0 0 / .2)}.btn-social.btn-lg{padding-left:61px}.btn-social.btn-lg>:first-child{line-height:45px;width:45px;font-size:1.8em}.btn-social.btn-sm{padding-left:38px}.btn-social.btn-sm>:first-child{line-height:28px;width:28px;font-size:1.4em}.btn-social.btn-xs{padding-left:30px}.btn-social.btn-xs>:first-child{line-height:20px;width:20px;font-size:1.2em}.btn-social-icon{position:relative;padding-left:44px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:34px;width:34px;padding:0}.btn-social-icon>:first-child{position:absolute;left:0;top:0;bottom:0;width:32px;line-height:34px;font-size:1.6em;text-align:center;border-right:1px solid rgb(0 0 0 / .2)}.btn-social-icon.btn-lg{padding-left:61px}.btn-social-icon.btn-lg>:first-child{line-height:45px;width:45px;font-size:1.8em}.btn-social-icon.btn-sm{padding-left:38px}.btn-social-icon.btn-sm>:first-child{line-height:28px;width:28px;font-size:1.4em}.btn-social-icon.btn-xs{padding-left:30px}.btn-social-icon.btn-xs>:first-child{line-height:20px;width:20px;font-size:1.2em}.btn-social-icon>:first-child{border:none;text-align:center;width:100%}.btn-social-icon.btn-lg{height:45px;width:45px;padding-left:0;padding-right:0}.btn-social-icon.btn-sm{height:30px;width:30px;padding-left:0;padding-right:0}.btn-social-icon.btn-xs{height:22px;width:22px;padding-left:0;padding-right:0}.btn-adn{color:#fff;background-color:#d87a68;border-color:rgb(0 0 0 / .2)}.btn-adn:focus,.btn-adn.focus{color:#fff;background-color:#ce563f;border-color:rgb(0 0 0 / .2)}.btn-adn:hover{color:#fff;background-color:#ce563f;border-color:rgb(0 0 0 / .2)}.btn-adn:active,.btn-adn.active,.open>.dropdown-toggle.btn-adn{color:#fff;background-color:#ce563f;border-color:rgb(0 0 0 / .2);background-image:none}.btn-adn .badge{color:#d87a68;background-color:#fff}.btn-bitbucket{color:#fff;background-color:#205081;border-color:rgb(0 0 0 / .2)}.btn-bitbucket:focus,.btn-bitbucket.focus{color:#fff;background-color:#163758;border-color:rgb(0 0 0 / .2)}.btn-bitbucket:hover{color:#fff;background-color:#163758;border-color:rgb(0 0 0 / .2)}.btn-bitbucket:active,.btn-bitbucket.active,.open>.dropdown-toggle.btn-bitbucket{color:#fff;background-color:#163758;border-color:rgb(0 0 0 / .2);background-image:none}.btn-bitbucket .badge{color:#205081;background-color:#fff}.btn-dropbox{color:#fff;background-color:#1087dd;border-color:rgb(0 0 0 / .2)}.btn-dropbox:focus,.btn-dropbox.focus{color:#fff;background-color:#0d6aad;border-color:rgb(0 0 0 / .2)}.btn-dropbox:hover{color:#fff;background-color:#0d6aad;border-color:rgb(0 0 0 / .2)}.btn-dropbox:active,.btn-dropbox.active,.open>.dropdown-toggle.btn-dropbox{color:#fff;background-color:#0d6aad;border-color:rgb(0 0 0 / .2);background-image:none}.btn-dropbox .badge{color:#1087dd;background-color:#fff}.btn-facebook{color:#fff;background-color:#3b5998;border-color:rgb(0 0 0 / .2)}.btn-facebook:focus,.btn-facebook.focus{color:#fff;background-color:#2d4373;border-color:rgb(0 0 0 / .2)}.btn-facebook:hover{color:#fff;background-color:#2d4373;border-color:rgb(0 0 0 / .2)}.btn-facebook:active,.btn-facebook.active,.open>.dropdown-toggle.btn-facebook{color:#fff;background-color:#2d4373;border-color:rgb(0 0 0 / .2);background-image:none}.btn-facebook .badge{color:#3b5998;background-color:#fff}.btn-flickr{color:#fff;background-color:#ff0084;border-color:rgb(0 0 0 / .2)}.btn-flickr:focus,.btn-flickr.focus{color:#fff;background-color:#cc006a;border-color:rgb(0 0 0 / .2)}.btn-flickr:hover{color:#fff;background-color:#cc006a;border-color:rgb(0 0 0 / .2)}.btn-flickr:active,.btn-flickr.active,.open>.dropdown-toggle.btn-flickr{color:#fff;background-color:#cc006a;border-color:rgb(0 0 0 / .2);background-image:none}.btn-flickr .badge{color:#ff0084;background-color:#fff}.btn-foursquare{color:#fff;background-color:#f94877;border-color:rgb(0 0 0 / .2)}.btn-foursquare:focus,.btn-foursquare.focus{color:#fff;background-color:#f71752;border-color:rgb(0 0 0 / .2)}.btn-foursquare:hover{color:#fff;background-color:#f71752;border-color:rgb(0 0 0 / .2)}.btn-foursquare:active,.btn-foursquare.active,.open>.dropdown-toggle.btn-foursquare{color:#fff;background-color:#f71752;border-color:rgb(0 0 0 / .2);background-image:none}.btn-foursquare .badge{color:#f94877;background-color:#fff}.btn-github{color:#fff;background-color:#444;border-color:rgb(0 0 0 / .2)}.btn-github:focus,.btn-github.focus{color:#fff;background-color:#2b2b2b;border-color:rgb(0 0 0 / .2)}.btn-github:hover{color:#fff;background-color:#2b2b2b;border-color:rgb(0 0 0 / .2)}.btn-github:active,.btn-github.active,.open>.dropdown-toggle.btn-github{color:#fff;background-color:#2b2b2b;border-color:rgb(0 0 0 / .2);background-image:none}.btn-github .badge{color:#444;background-color:#fff}.btn-google{color:#fff;background-color:#dd4b39;border-color:rgb(0 0 0 / .2)}.btn-google:focus,.btn-google.focus{color:#fff;background-color:#c23321;border-color:rgb(0 0 0 / .2)}.btn-google:hover{color:#fff;background-color:#c23321;border-color:rgb(0 0 0 / .2)}.btn-google:active,.btn-google.active,.open>.dropdown-toggle.btn-google{color:#fff;background-color:#c23321;border-color:rgb(0 0 0 / .2);background-image:none}.btn-google .badge{color:#dd4b39;background-color:#fff}.btn-instagram{color:#fff;background-color:#3f729b;border-color:rgb(0 0 0 / .2)}.btn-instagram:focus,.btn-instagram.focus{color:#fff;background-color:#305777;border-color:rgb(0 0 0 / .2)}.btn-instagram:hover{color:#fff;background-color:#305777;border-color:rgb(0 0 0 / .2)}.btn-instagram:active,.btn-instagram.active,.open>.dropdown-toggle.btn-instagram{color:#fff;background-color:#305777;border-color:rgb(0 0 0 / .2);background-image:none}.btn-instagram .badge{color:#3f729b;background-color:#fff}.btn-linkedin{color:#fff;background-color:#007bb6;border-color:rgb(0 0 0 / .2)}.btn-linkedin:focus,.btn-linkedin.focus{color:#fff;background-color:#005983;border-color:rgb(0 0 0 / .2)}.btn-linkedin:hover{color:#fff;background-color:#005983;border-color:rgb(0 0 0 / .2)}.btn-linkedin:active,.btn-linkedin.active,.open>.dropdown-toggle.btn-linkedin{color:#fff;background-color:#005983;border-color:rgb(0 0 0 / .2);background-image:none}.btn-linkedin .badge{color:#007bb6;background-color:#fff}.btn-microsoft{color:#fff;background-color:#2672ec;border-color:rgb(0 0 0 / .2)}.btn-microsoft:focus,.btn-microsoft.focus{color:#fff;background-color:#125acd;border-color:rgb(0 0 0 / .2)}.btn-microsoft:hover{color:#fff;background-color:#125acd;border-color:rgb(0 0 0 / .2)}.btn-microsoft:active,.btn-microsoft.active,.open>.dropdown-toggle.btn-microsoft{color:#fff;background-color:#125acd;border-color:rgb(0 0 0 / .2);background-image:none}.btn-microsoft .badge{color:#2672ec;background-color:#fff}.btn-openid{color:#fff;background-color:#f7931e;border-color:rgb(0 0 0 / .2)}.btn-openid:focus,.btn-openid.focus{color:#fff;background-color:#da7908;border-color:rgb(0 0 0 / .2)}.btn-openid:hover{color:#fff;background-color:#da7908;border-color:rgb(0 0 0 / .2)}.btn-openid:active,.btn-openid.active,.open>.dropdown-toggle.btn-openid{color:#fff;background-color:#da7908;border-color:rgb(0 0 0 / .2);background-image:none}.btn-openid .badge{color:#f7931e;background-color:#fff}.btn-pinterest{color:#fff;background-color:#cb2027;border-color:rgb(0 0 0 / .2)}.btn-pinterest:focus,.btn-pinterest.focus{color:#fff;background-color:#9f191f;border-color:rgb(0 0 0 / .2)}.btn-pinterest:hover{color:#fff;background-color:#9f191f;border-color:rgb(0 0 0 / .2)}.btn-pinterest:active,.btn-pinterest.active,.open>.dropdown-toggle.btn-pinterest{color:#fff;background-color:#9f191f;border-color:rgb(0 0 0 / .2);background-image:none}.btn-pinterest .badge{color:#cb2027;background-color:#fff}.btn-reddit{color:#000;background-color:#eff7ff;border-color:rgb(0 0 0 / .2)}.btn-reddit:focus,.btn-reddit.focus{color:#000;background-color:#bcddff;border-color:rgb(0 0 0 / .2)}.btn-reddit:hover{color:#000;background-color:#bcddff;border-color:rgb(0 0 0 / .2)}.btn-reddit:active,.btn-reddit.active,.open>.dropdown-toggle.btn-reddit{color:#000;background-color:#bcddff;border-color:rgb(0 0 0 / .2);background-image:none}.btn-reddit .badge{color:#eff7ff;background-color:#000}.btn-soundcloud{color:#fff;background-color:#f50;border-color:rgb(0 0 0 / .2)}.btn-soundcloud:focus,.btn-soundcloud.focus{color:#fff;background-color:#c40;border-color:rgb(0 0 0 / .2)}.btn-soundcloud:hover{color:#fff;background-color:#c40;border-color:rgb(0 0 0 / .2)}.btn-soundcloud:active,.btn-soundcloud.active,.open>.dropdown-toggle.btn-soundcloud{color:#fff;background-color:#c40;border-color:rgb(0 0 0 / .2);background-image:none}.btn-soundcloud .badge{color:#f50;background-color:#fff}.btn-tumblr{color:#fff;background-color:#2c4762;border-color:rgb(0 0 0 / .2)}.btn-tumblr:focus,.btn-tumblr.focus{color:#fff;background-color:#1c2d3f;border-color:rgb(0 0 0 / .2)}.btn-tumblr:hover{color:#fff;background-color:#1c2d3f;border-color:rgb(0 0 0 / .2)}.btn-tumblr:active,.btn-tumblr.active,.open>.dropdown-toggle.btn-tumblr{color:#fff;background-color:#1c2d3f;border-color:rgb(0 0 0 / .2);background-image:none}.btn-tumblr .badge{color:#2c4762;background-color:#fff}.btn-twitter{color:#fff;background-color:#55acee;border-color:rgb(0 0 0 / .2)}.btn-twitter:focus,.btn-twitter.focus{color:#fff;background-color:#2795e9;border-color:rgb(0 0 0 / .2)}.btn-twitter:hover{color:#fff;background-color:#2795e9;border-color:rgb(0 0 0 / .2)}.btn-twitter:active,.btn-twitter.active,.open>.dropdown-toggle.btn-twitter{color:#fff;background-color:#2795e9;border-color:rgb(0 0 0 / .2);background-image:none}.btn-twitter .badge{color:#55acee;background-color:#fff}.btn-vimeo{color:#fff;background-color:#1ab7ea;border-color:rgb(0 0 0 / .2)}.btn-vimeo:focus,.btn-vimeo.focus{color:#fff;background-color:#1295bf;border-color:rgb(0 0 0 / .2)}.btn-vimeo:hover{color:#fff;background-color:#1295bf;border-color:rgb(0 0 0 / .2)}.btn-vimeo:active,.btn-vimeo.active,.open>.dropdown-toggle.btn-vimeo{color:#fff;background-color:#1295bf;border-color:rgb(0 0 0 / .2);background-image:none}.btn-vimeo .badge{color:#1ab7ea;background-color:#fff}.btn-vk{color:#fff;background-color:#587ea3;border-color:rgb(0 0 0 / .2)}.btn-vk:focus,.btn-vk.focus{color:#fff;background-color:#466482;border-color:rgb(0 0 0 / .2)}.btn-vk:hover{color:#fff;background-color:#466482;border-color:rgb(0 0 0 / .2)}.btn-vk:active,.btn-vk.active,.open>.dropdown-toggle.btn-vk{color:#fff;background-color:#466482;border-color:rgb(0 0 0 / .2);background-image:none}.btn-vk .badge{color:#587ea3;background-color:#fff}.btn-yahoo{color:#fff;background-color:#720e9e;border-color:rgb(0 0 0 / .2)}.btn-yahoo:focus,.btn-yahoo.focus{color:#fff;background-color:#500a6f;border-color:rgb(0 0 0 / .2)}.btn-yahoo:hover{color:#fff;background-color:#500a6f;border-color:rgb(0 0 0 / .2)}.btn-yahoo:active,.btn-yahoo.active,.open>.dropdown-toggle.btn-yahoo{color:#fff;background-color:#500a6f;border-color:rgb(0 0 0 / .2);background-image:none}.btn-yahoo .badge{color:#720e9e;background-color:#fff}.fc-button{background:#f4f4f4;background-image:none;color:#444;border-color:#ddd;border-bottom-color:#ddd}.fc-button:hover,.fc-button:active,.fc-button.hover{background-color:#e9e9e9}.fc-header-title h2{font-size:15px;line-height:1.6em;color:#666;margin-left:10px}.fc-header-right{padding-right:10px}.fc-header-left{padding-left:10px}.fc-widget-header{background:#fafafa}.fc-grid{width:100%;border:0}.fc-widget-header:first-of-type,.fc-widget-content:first-of-type{border-left:0;border-right:0}.fc-widget-header:last-of-type,.fc-widget-content:last-of-type{border-right:0}.fc-toolbar{padding:10px;margin:0}.fc-day-number{font-size:20px;font-weight:300;padding-right:10px}.fc-color-picker{list-style:none;margin:0;padding:0}.fc-color-picker>li{float:left;font-size:30px;margin-right:5px;line-height:30px}.fc-color-picker>li .fa{transition:transform linear 0.3s}.fc-color-picker>li .fa:hover{transform:rotate(30deg)}#add-new-event{transition:all linear 0.3s}.external-event{padding:5px 10px;font-weight:700;margin-bottom:4px;box-shadow:0 1px 1px rgb(0 0 0 / .1);text-shadow:0 1px 1px rgb(0 0 0 / .1);border-radius:3px;cursor:move}.external-event:hover{box-shadow:inset 0 0 90px rgb(0 0 0 / .2)}.select2-container--default.select2-container--focus,.select2-selection.select2-container--focus,.select2-container--default:focus,.select2-selection:focus,.select2-container--default:active,.select2-selection:active{outline:none}.select2-container--default .select2-selection--single,.select2-selection .select2-selection--single{border:1px solid #d2d6de;border-radius:0;padding:6px 12px;height:34px}.select2-container--default.select2-container--open{border-color:#3c8dbc}.select2-dropdown{border:1px solid #d2d6de;border-radius:0}.select2-container--default .select2-results__option--highlighted[aria-selected]{background-color:#3c8dbc;color:#fff}.select2-results__option{padding:6px 12px;user-select:none;-webkit-user-select:none}.select2-container .select2-selection--single .select2-selection__rendered{padding-left:0;padding-right:0;height:auto;margin-top:-4px}.select2-container[dir='rtl'] .select2-selection--single .select2-selection__rendered{padding-right:6px;padding-left:20px}.select2-container--default .select2-selection--single .select2-selection__arrow{height:28px;right:3px}.select2-container--default .select2-selection--single .select2-selection__arrow b{margin-top:0}.select2-dropdown .select2-search__field,.select2-search--inline .select2-search__field{border:1px solid #d2d6de}.select2-dropdown .select2-search__field:focus,.select2-search--inline .select2-search__field:focus{outline:none;border:1px solid #3c8dbc}.select2-container--default .select2-results__option[aria-disabled='true']{color:#999}.select2-container--default .select2-results__option[aria-selected='true']{background-color:#ddd}.select2-container--default .select2-results__option[aria-selected='true'],.select2-container--default .select2-results__option[aria-selected='true']:hover{color:#444}.select2-container--default .select2-selection--multiple{border:1px solid #d2d6de;border-radius:0}.select2-container--default .select2-selection--multiple:focus{border-color:#3c8dbc}.select2-container--default.select2-container--focus .select2-selection--multiple{border-color:#d2d6de}.select2-container--default .select2-selection--multiple .select2-selection__choice{background-color:#3c8dbc;border-color:#367fa9;padding:1px 10px;color:#fff}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove{margin-right:5px;color:rgb(255 255 255 / .7)}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover{color:#fff}.select2-container .select2-selection--single .select2-selection__rendered{padding-right:10px}.pad{padding:10px}.margin{margin:10px}.margin-bottom{margin-bottom:20px}.margin-bottom-none{margin-bottom:0}.margin-r-5{margin-right:5px}.inline{display:inline}.description-block{display:block;margin:10px 0;text-align:center}.description-block.margin-bottom{margin-bottom:25px}.description-block>.description-header{margin:0;padding:0;font-weight:600;font-size:16px}.description-block>.description-text{text-transform:uppercase}.bg-red,.bg-yellow,.bg-aqua,.bg-blue,.bg-light-blue,.bg-green,.bg-navy,.bg-teal,.bg-olive,.bg-lime,.bg-orange,.bg-fuchsia,.bg-purple,.bg-maroon,.bg-black,.bg-red-active,.bg-yellow-active,.bg-aqua-active,.bg-blue-active,.bg-light-blue-active,.bg-green-active,.bg-navy-active,.bg-teal-active,.bg-olive-active,.bg-lime-active,.bg-orange-active,.bg-fuchsia-active,.bg-purple-active,.bg-maroon-active,.bg-black-active,.callout.callout-danger,.callout.callout-warning,.callout.callout-info,.callout.callout-success,.alert-success,.alert-danger,.alert-error,.alert-warning,.alert-info,.label-danger,.label-info,.label-warning,.label-primary,.label-success,.modal-primary .modal-body,.modal-primary .modal-header,.modal-primary .modal-footer,.modal-warning .modal-body,.modal-warning .modal-header,.modal-warning .modal-footer,.modal-info .modal-body,.modal-info .modal-header,.modal-info .modal-footer,.modal-success .modal-body,.modal-success .modal-header,.modal-success .modal-footer,.modal-danger .modal-body,.modal-danger .modal-header,.modal-danger .modal-footer{color:#fff!important}.bg-gray{color:#000;background-color:#d2d6de!important}.bg-gray-light{background-color:#f7f7f7}.bg-black{background-color:#111111!important}.bg-red,.callout.callout-danger,.alert-danger,.alert-error,.label-danger,.modal-danger .modal-body{background-color:#dd4b39!important}.bg-yellow,.callout.callout-warning,.alert-warning,.label-warning,.modal-warning .modal-body{background-color:#f39c12!important}.bg-aqua,.callout.callout-info,.alert-info,.label-info,.modal-info .modal-body{background-color:#00c0ef!important}.bg-blue{background-color:#0073b7!important}.bg-light-blue,.label-primary,.modal-primary .modal-body{background-color:#3c8dbc!important}.bg-green,.callout.callout-success,.alert-success,.label-success,.modal-success .modal-body{background-color:#00a65a!important}.bg-navy{background-color:#001f3f!important}.bg-teal{background-color:#39cccc!important}.bg-olive{background-color:#3d9970!important}.bg-lime{background-color:#01ff70!important}.bg-orange{background-color:#ff851b!important}.bg-fuchsia{background-color:#f012be!important}.bg-purple{background-color:#6c7e9d!important}.bg-maroon{background-color:#d81b60!important}.bg-gray-active{color:#000;background-color:#b5bbc8!important}.bg-black-active{background-color:#000000!important}.bg-red-active,.modal-danger .modal-header,.modal-danger .modal-footer{background-color:#d33724!important}.bg-yellow-active,.modal-warning .modal-header,.modal-warning .modal-footer{background-color:#db8b0b!important}.bg-aqua-active,.modal-info .modal-header,.modal-info .modal-footer{background-color:#00a7d0!important}.bg-blue-active{background-color:#005384!important}.bg-light-blue-active,.modal-primary .modal-header,.modal-primary .modal-footer{background-color:#357ca5!important}.bg-green-active,.modal-success .modal-header,.modal-success .modal-footer{background-color:#008d4c!important}.bg-navy-active{background-color:#001a35!important}.bg-teal-active{background-color:#30bbbb!important}.bg-olive-active{background-color:#368763!important}.bg-lime-active{background-color:#00e765!important}.bg-orange-active{background-color:#ff7701!important}.bg-fuchsia-active{background-color:#db0ead!important}.bg-purple-active{background-color:#536584!important}.bg-maroon-active{background-color:#ca195a!important}[class^='bg-'].disabled{opacity:.65;filter:alpha(opacity=65)}.text-red{color:#dd4b39!important}.text-yellow{color:#f39c12!important}.text-aqua{color:#00c0ef!important}.text-black{color:#111111!important}.text-light-blue{color:#3c8dbc!important}.text-green{color:#00a65a!important}.text-gray{color:#d2d6de!important}.text-navy{color:#001f3f!important}.text-teal{color:#39cccc!important}.text-olive{color:#3d9970!important}.text-lime{color:#01ff70!important}.text-orange{color:#ff851b!important}.text-fuchsia{color:#f012be!important}.text-purple{color:#6c7e9d!important}.text-maroon{color:#d81b60!important}.link-muted{color:#7a869d}.link-muted:hover,.link-muted:focus{color:#606c84}.link-black{color:#666}.link-black:hover,.link-black:focus{color:#999}.hide{display:none!important}.no-border{border:0!important}.no-padding{padding:0!important}.no-margin{margin:0!important}.no-shadow{box-shadow:none!important}.list-unstyled,.chart-legend,.contacts-list,.users-list,.mailbox-attachments{list-style:none;margin:0;padding:0}.list-group-unbordered>.list-group-item{border-left:0;border-right:0;border-radius:0;padding-left:0;padding-right:0}.flat{border-radius:0!important}.text-bold,.text-bold.table td,.text-bold.table th{font-weight:700}.text-sm{font-size:12px}.jqstooltip{padding:5px!important;width:auto!important;height:auto!important}.bg-teal-gradient{background:#39cccc!important;background:-o-linear-gradient(#7adddd,#39cccc)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#7adddd',endColorstr='#39cccc',GradientType=0)!important;color:#fff}.bg-light-blue-gradient{background:#3c8dbc!important;background:-o-linear-gradient(#67a8ce,#3c8dbc)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#67a8ce',endColorstr='#3c8dbc',GradientType=0)!important;color:#fff}.bg-blue-gradient{background:#0073b7!important;background:-o-linear-gradient(#0089db,#0073b7)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#0089db',endColorstr='#0073b7',GradientType=0)!important;color:#fff}.bg-aqua-gradient{background:#00c0ef!important;background:-o-linear-gradient(#14d1ff,#00c0ef)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#14d1ff',endColorstr='#00c0ef',GradientType=0)!important;color:#fff}.bg-yellow-gradient{background:#f39c12!important;background:-o-linear-gradient(#f7bc60,#f39c12)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#f7bc60',endColorstr='#f39c12',GradientType=0)!important;color:#fff}.bg-purple-gradient{background:#6c7e9d!important;background:-o-linear-gradient(#9491c4,#6c7e9d)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#9491c4',endColorstr='#6c7e9d',GradientType=0)!important;color:#fff}.bg-green-gradient{background:#00a65a!important;background:-o-linear-gradient(#00ca6d,#00a65a)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ca6d',endColorstr='#00a65a',GradientType=0)!important;color:#fff}.bg-red-gradient{background:#dd4b39!important;background:-o-linear-gradient(#e47365,#dd4b39)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#e47365',endColorstr='#dd4b39',GradientType=0)!important;color:#fff}.bg-black-gradient{background:#111111!important;background:-o-linear-gradient(#2b2b2b,#111111)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#2b2b2b',endColorstr='#111111',GradientType=0)!important;color:#fff}.bg-maroon-gradient{background:#d81b60!important;background:-o-linear-gradient(#e73f7c,#d81b60)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#e73f7c',endColorstr='#d81b60',GradientType=0)!important;color:#fff}.description-block .description-icon{font-size:16px}.no-pad-top{padding-top:0}.position-static{position:static!important}.list-header{font-size:15px;padding:10px 4px;font-weight:700;color:#666}.list-seperator{height:1px;background:#f4f4f4;margin:15px 0 9px 0}.list-link>a{padding:4px;color:#777}.list-link>a:hover{color:#222}.font-light{font-weight:300}.user-block:before,.user-block:after{content:' ';display:table}.user-block:after{clear:both}.user-block img{width:40px;height:40px;float:left}.user-block .username,.user-block .description,.user-block .comment{display:block;margin-left:50px}.user-block .username{font-size:16px;font-weight:600}.user-block .description{color:#999;font-size:13px}.user-block.user-block-sm .username,.user-block.user-block-sm .description,.user-block.user-block-sm .comment{margin-left:40px}.user-block.user-block-sm .username{font-size:14px}.img-sm,.img-md,.img-lg,.box-comments .box-comment img,.user-block.user-block-sm img{float:left}.img-sm,.box-comments .box-comment img,.user-block.user-block-sm img{width:30px!important;height:30px!important}.img-sm+.img-push{margin-left:40px}.img-md{width:60px;height:60px}.img-md+.img-push{margin-left:70px}.img-lg{width:100px;height:100px}.img-lg+.img-push{margin-left:110px}.img-bordered{border:3px solid #d2d6de;padding:3px}.img-bordered-sm{border:2px solid #d2d6de;padding:2px}.attachment-block{border:1px solid #f4f4f4;padding:5px;margin-bottom:10px;background:#f7f7f7}.attachment-block .attachment-img{max-width:100px;max-height:100px;height:auto;float:left}.attachment-block .attachment-pushed{margin-left:110px}.attachment-block .attachment-heading{margin:0}.attachment-block .attachment-text{color:#555}.connectedSortable{min-height:100px}.ui-helper-hidden-accessible{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sort-highlight{background:#f4f4f4;border:1px dashed #ddd;margin-bottom:10px}.full-opacity-hover{opacity:.65;filter:alpha(opacity=65)}.full-opacity-hover:hover{opacity:1;filter:alpha(opacity=100)}.chart{position:relative;overflow:hidden;width:100%}.chart svg,.chart canvas{width:100%!important}@media print{.no-print,.left-side,.main-header,.content-header{display:none!important}.content-wrapper,.right-side,.main-footer{margin-left:0!important;min-height:0!important;transform:translate(0,0)!important}.fixed .content-wrapper,.fixed .right-side{padding-top:0!important}.invoice{width:100%;border:0;margin:0;padding:0}.invoice-col{float:left;width:33.3333333%}.table-responsive{overflow:auto}.table-responsive>.table tr th,.table-responsive>.table tr td{white-space:normal!important}}\n",".layout-boxed html, .layout-boxed body {\n  height: 100%;\n}\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.wrapper {\n  min-height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.wrapper:before, .wrapper:after {\n  content: \" \";\n  display: table;\n}\n\n.wrapper:after {\n  clear: both;\n}\n\n.layout-boxed .wrapper {\n  max-width: 1250px;\n  min-height: 100%;\n  margin: 0 auto;\n  position: relative;\n  box-shadow: 0 0 8px #00000080;\n}\n\n.layout-boxed {\n  background: url(\"../img/boxed-bg.jpg\") fixed;\n}\n\n.content-wrapper, .right-side, .main-footer {\n  z-index: 820;\n  margin-left: 230px;\n  transition: transform .3s ease-in-out, margin .3s ease-in-out;\n}\n\n.layout-top-nav .content-wrapper, .layout-top-nav .right-side, .layout-top-nav .main-footer {\n  margin-left: 0;\n}\n\n@media (width <= 767px) {\n  .content-wrapper, .right-side, .main-footer {\n    margin-left: 0;\n  }\n}\n\n@media (width >= 768px) {\n  .sidebar-collapse .content-wrapper, .sidebar-collapse .right-side, .sidebar-collapse .main-footer {\n    margin-left: 0;\n  }\n}\n\n@media (width <= 767px) {\n  .sidebar-open .content-wrapper, .sidebar-open .right-side, .sidebar-open .main-footer {\n    transform: translate(230px);\n  }\n}\n\n.content-wrapper, .right-side {\n  z-index: 800;\n  background-color: #ecf0f5;\n  min-height: 100%;\n}\n\n.main-footer {\n  color: #444;\n  background: #fff;\n  border-top: 1px solid #d2d6de;\n  padding: 15px;\n}\n\n.fixed .main-header, .fixed .main-sidebar, .fixed .left-side {\n  position: fixed;\n}\n\n.fixed .main-header {\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.fixed .content-wrapper, .fixed .right-side {\n  padding-top: 50px;\n}\n\n@media (width <= 767px) {\n  .fixed .content-wrapper, .fixed .right-side {\n    padding-top: 100px;\n  }\n}\n\n.fixed.layout-boxed .wrapper {\n  max-width: 100%;\n}\n\nbody.hold-transition .content-wrapper, body.hold-transition .right-side, body.hold-transition .main-footer, body.hold-transition .main-sidebar, body.hold-transition .left-side, body.hold-transition .main-header > .navbar, body.hold-transition .main-header .logo {\n  transition: none;\n}\n\n.content {\n  min-height: 250px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 15px;\n}\n\na:hover, a:active, a:focus {\n  outline: none;\n  text-decoration: none;\n}\n\n.page-header {\n  margin: 10px 0 20px;\n  font-size: 22px;\n}\n\n.page-header > small {\n  color: #666;\n  margin-top: 5px;\n  display: block;\n}\n\n.main-header {\n  z-index: 1030;\n  max-height: 100px;\n  position: relative;\n}\n\n.main-header > .navbar {\n  border: none;\n  border-radius: 0;\n  min-height: 50px;\n  margin-bottom: 0;\n  margin-left: 230px;\n  transition: margin-left .3s ease-in-out;\n}\n\n.layout-top-nav .main-header > .navbar {\n  margin-left: 0;\n}\n\n.main-header #navbar-search-input.form-control {\n  background: #fff3;\n  border-color: #fff0;\n}\n\n.main-header #navbar-search-input.form-control:focus, .main-header #navbar-search-input.form-control:active {\n  background: #ffffffe6;\n  border-color: #0000001a;\n}\n\n.main-header #navbar-search-input.form-control::-moz-placeholder {\n  color: #ccc;\n  opacity: 1;\n}\n\n.main-header #navbar-search-input.form-control:-ms-placeholder-shown {\n  color: #ccc;\n}\n\n.main-header #navbar-search-input.form-control::-webkit-input-placeholder {\n  color: #ccc;\n}\n\n.main-header .navbar-custom-menu, .main-header .navbar-right {\n  float: right;\n}\n\n@media (width <= 991px) {\n  .main-header .navbar-custom-menu a, .main-header .navbar-right a {\n    color: inherit;\n    background: #fff0;\n  }\n}\n\n.main-header .navbar .nav > li.user > a > .fa, .main-header .navbar .nav > li.user > a > .glyphicon, .main-header .navbar .nav > li.user > a > .ion {\n  margin-right: 5px;\n}\n\n.main-header .navbar .nav > li > a > .label {\n  text-align: center;\n  padding: 2px 3px;\n  font-size: 9px;\n  line-height: .9;\n  position: absolute;\n  top: 9px;\n  right: 7px;\n}\n\n.main-header .logo {\n  float: left;\n  text-align: center;\n  width: 230px;\n  height: 50px;\n  padding: 0 15px;\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-size: 20px;\n  font-weight: 300;\n  line-height: 50px;\n  transition: width .3s ease-in-out;\n  display: block;\n  overflow: hidden;\n}\n\n.main-header .logo .logo-lg {\n  display: block;\n}\n\n.main-header .logo .logo-mini {\n  display: none;\n}\n\n.main-header .navbar-brand {\n  color: #fff;\n}\n\n.content-header {\n  padding: 15px 15px 0;\n  position: relative;\n}\n\n.content-header > h1 {\n  margin: 0;\n  font-size: 24px;\n}\n\n.content-header > h1 > small {\n  padding-left: 4px;\n  font-size: 15px;\n  font-weight: 300;\n  display: inline-block;\n}\n\n.content-header > .breadcrumb {\n  float: right;\n  background: #fff0;\n  border-radius: 2px;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding: 7px 5px;\n  font-size: 12px;\n  position: absolute;\n  top: 15px;\n  right: 10px;\n}\n\n.content-header > .breadcrumb > li > a {\n  color: #444;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.content-header > .breadcrumb > li > a > .fa, .content-header > .breadcrumb > li > a > .glyphicon, .content-header > .breadcrumb > li > a > .ion {\n  margin-right: 5px;\n}\n\n.content-header > .breadcrumb > li + li:before {\n  content: \"> \";\n}\n\n@media (width <= 991px) {\n  .content-header > .breadcrumb {\n    float: none;\n    background: #d2d6de;\n    margin-top: 5px;\n    padding-left: 10px;\n    position: relative;\n    top: 0;\n    right: 0;\n  }\n\n  .content-header > .breadcrumb li:before {\n    color: #97a0b3;\n  }\n}\n\n.navbar-toggle {\n  color: #fff;\n  border: 0;\n  margin: 0;\n  padding: 15px;\n}\n\n@media (width <= 991px) {\n  .navbar-custom-menu .navbar-nav > li {\n    float: left;\n  }\n\n  .navbar-custom-menu .navbar-nav {\n    float: left;\n    margin: 0;\n  }\n\n  .navbar-custom-menu .navbar-nav > li > a {\n    padding-top: 15px;\n    padding-bottom: 15px;\n    line-height: 20px;\n  }\n\n  .navbar-collapse.pull-left {\n    float: none !important;\n  }\n\n  .navbar-collapse.pull-left + .navbar-custom-menu {\n    display: block;\n    position: absolute;\n    top: 0;\n    right: 40px;\n  }\n}\n\n.main-sidebar, .left-side {\n  z-index: 810;\n  width: 230px;\n  min-height: 100%;\n  padding-top: 50px;\n  transition: transform .3s ease-in-out, width .3s ease-in-out;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n@media (width <= 767px) {\n  .main-sidebar, .left-side {\n    padding-top: 100px;\n    transform: translate(-230px);\n  }\n}\n\n@media (width >= 768px) {\n  .sidebar-collapse .main-sidebar, .sidebar-collapse .left-side {\n    transform: translate(-230px);\n  }\n}\n\n@media (width <= 767px) {\n  .sidebar-open .main-sidebar, .sidebar-open .left-side {\n    transform: translate(0);\n  }\n}\n\n.sidebar {\n  padding-bottom: 10px;\n}\n\n.sidebar-form input:focus {\n  border-color: #fff0;\n}\n\n.user-panel {\n  width: 100%;\n  padding: 10px;\n  position: relative;\n  overflow: hidden;\n}\n\n.user-panel:before, .user-panel:after {\n  content: \" \";\n  display: table;\n}\n\n.user-panel:after {\n  clear: both;\n}\n\n.user-panel > .image > img {\n  width: 100%;\n  max-width: 45px;\n  height: auto;\n}\n\n.user-panel > .info {\n  padding: 5px 5px 5px 15px;\n  line-height: 1;\n  position: absolute;\n  left: 55px;\n}\n\n.user-panel > .info > p {\n  margin-bottom: 9px;\n  font-weight: 600;\n}\n\n.user-panel > .info > a {\n  margin-top: 3px;\n  padding-right: 5px;\n  font-size: 11px;\n  text-decoration: none;\n}\n\n.user-panel > .info > a > .fa, .user-panel > .info > a > .ion, .user-panel > .info > a > .glyphicon {\n  margin-right: 3px;\n}\n\n.sidebar-menu {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.sidebar-menu > li {\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n\n.sidebar-menu > li > a {\n  padding: 12px 5px 12px 15px;\n  display: block;\n}\n\n.sidebar-menu > li > a > .fa, .sidebar-menu > li > a > .glyphicon, .sidebar-menu > li > a > .ion {\n  width: 20px;\n}\n\n.sidebar-menu > li .label, .sidebar-menu > li .badge {\n  margin-top: 3px;\n  margin-right: 5px;\n}\n\n.sidebar-menu li.header {\n  padding: 10px 25px 10px 15px;\n  font-size: 12px;\n}\n\n.sidebar-menu li > a > .fa-angle-left {\n  width: auto;\n  height: auto;\n  margin-top: 3px;\n  margin-right: 10px;\n  padding: 0;\n}\n\n.sidebar-menu li.active > a > .fa-angle-left {\n  transform: rotate(-90deg);\n}\n\n.sidebar-menu li.active > .treeview-menu {\n  display: block;\n}\n\n.sidebar-menu .treeview-menu {\n  margin: 0;\n  padding: 0 0 0 5px;\n  list-style: none;\n  display: none;\n}\n\n.sidebar-menu .treeview-menu .treeview-menu {\n  padding-left: 20px;\n}\n\n.sidebar-menu .treeview-menu > li {\n  margin: 0;\n}\n\n.sidebar-menu .treeview-menu > li > a {\n  padding: 5px 5px 5px 15px;\n  font-size: 14px;\n  display: block;\n}\n\n.sidebar-menu .treeview-menu > li > a > .fa, .sidebar-menu .treeview-menu > li > a > .glyphicon, .sidebar-menu .treeview-menu > li > a > .ion {\n  width: 20px;\n}\n\n.sidebar-menu .treeview-menu > li > a > .fa-angle-left, .sidebar-menu .treeview-menu > li > a > .fa-angle-down {\n  width: auto;\n}\n\n@media (width >= 768px) {\n  .sidebar-mini.sidebar-collapse .content-wrapper, .sidebar-mini.sidebar-collapse .right-side, .sidebar-mini.sidebar-collapse .main-footer {\n    z-index: 840;\n    margin-left: 50px !important;\n  }\n\n  .sidebar-mini.sidebar-collapse .main-sidebar {\n    z-index: 850;\n    transform: translate(0);\n    width: 50px !important;\n  }\n\n  .sidebar-mini.sidebar-collapse .sidebar-menu > li {\n    position: relative;\n  }\n\n  .sidebar-mini.sidebar-collapse .sidebar-menu > li > a {\n    margin-right: 0;\n  }\n\n  .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > span {\n    border-top-right-radius: 4px;\n  }\n\n  .sidebar-mini.sidebar-collapse .sidebar-menu > li:not(.treeview) > a > span {\n    border-bottom-right-radius: 4px;\n  }\n\n  .sidebar-mini.sidebar-collapse .sidebar-menu > li > .treeview-menu {\n    border-bottom-right-radius: 4px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n\n  .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > a > span:not(.pull-right), .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {\n    width: 180px;\n    position: absolute;\n    left: 50px;\n    display: block !important;\n  }\n\n  .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > a > span {\n    background-color: inherit;\n    margin-left: -3px;\n    padding: 12px 5px 12px 20px;\n    top: 0;\n  }\n\n  .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {\n    margin-left: 0;\n    top: 44px;\n  }\n\n  .sidebar-mini.sidebar-collapse .main-sidebar .user-panel > .info, .sidebar-mini.sidebar-collapse .sidebar-form, .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > span, .sidebar-mini.sidebar-collapse .sidebar-menu > li > .treeview-menu, .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > .pull-right, .sidebar-mini.sidebar-collapse .sidebar-menu li.header {\n    -webkit-transform: translateZ(0);\n    display: none !important;\n  }\n\n  .sidebar-mini.sidebar-collapse .main-header .logo {\n    width: 50px;\n  }\n\n  .sidebar-mini.sidebar-collapse .main-header .logo > .logo-mini {\n    margin-left: -15px;\n    margin-right: -15px;\n    font-size: 18px;\n    display: block;\n  }\n\n  .sidebar-mini.sidebar-collapse .main-header .logo > .logo-lg {\n    display: none;\n  }\n\n  .sidebar-mini.sidebar-collapse .main-header .navbar {\n    margin-left: 50px;\n  }\n}\n\n.sidebar-menu, .main-sidebar .user-panel, .sidebar-menu > li.header {\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.sidebar-menu:hover {\n  overflow: visible;\n}\n\n.sidebar-form, .sidebar-menu > li.header {\n  text-overflow: clip;\n  overflow: hidden;\n}\n\n.sidebar-menu li > a {\n  position: relative;\n}\n\n.sidebar-menu li > a > .pull-right {\n  margin-top: -7px;\n  position: absolute;\n  top: 50%;\n  right: 10px;\n}\n\n.control-sidebar-bg {\n  z-index: 1000;\n  position: fixed;\n  bottom: 0;\n}\n\n.control-sidebar-bg, .control-sidebar {\n  width: 230px;\n  transition: right .3s ease-in-out;\n  top: 0;\n  right: -230px;\n}\n\n.control-sidebar {\n  z-index: 1010;\n  padding-top: 50px;\n  position: absolute;\n}\n\n@media (width <= 768px) {\n  .control-sidebar {\n    padding-top: 100px;\n  }\n}\n\n.control-sidebar > .tab-content {\n  padding: 10px 15px;\n}\n\n.control-sidebar.control-sidebar-open, .control-sidebar.control-sidebar-open + .control-sidebar-bg, .control-sidebar-open .control-sidebar-bg, .control-sidebar-open .control-sidebar {\n  right: 0;\n}\n\n@media (width >= 768px) {\n  .control-sidebar-open .content-wrapper, .control-sidebar-open .right-side, .control-sidebar-open .main-footer {\n    margin-right: 230px;\n  }\n}\n\n.nav-tabs.control-sidebar-tabs > li:first-of-type > a, .nav-tabs.control-sidebar-tabs > li:first-of-type > a:hover, .nav-tabs.control-sidebar-tabs > li:first-of-type > a:focus {\n  border-left-width: 0;\n}\n\n.nav-tabs.control-sidebar-tabs > li > a {\n  border-radius: 0;\n}\n\n.nav-tabs.control-sidebar-tabs > li > a, .nav-tabs.control-sidebar-tabs > li > a:hover {\n  border-top: none;\n  border-bottom: 1px solid #fff0;\n  border-left: 1px solid #fff0;\n  border-right: none;\n}\n\n.nav-tabs.control-sidebar-tabs > li > a .icon {\n  font-size: 16px;\n}\n\n.nav-tabs.control-sidebar-tabs > li.active > a, .nav-tabs.control-sidebar-tabs > li.active > a:hover, .nav-tabs.control-sidebar-tabs > li.active > a:focus, .nav-tabs.control-sidebar-tabs > li.active > a:active {\n  border-top: none;\n  border-bottom: none;\n  border-right: none;\n}\n\n@media (width <= 768px) {\n  .nav-tabs.control-sidebar-tabs {\n    display: table;\n  }\n\n  .nav-tabs.control-sidebar-tabs > li {\n    display: table-cell;\n  }\n}\n\n.control-sidebar-heading {\n  margin-bottom: 10px;\n  padding: 10px 0;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.control-sidebar-subheading {\n  font-size: 14px;\n  font-weight: 400;\n  display: block;\n}\n\n.control-sidebar-menu {\n  margin: 0 -15px;\n  padding: 0;\n  list-style: none;\n}\n\n.control-sidebar-menu > li > a {\n  padding: 10px 15px;\n  display: block;\n}\n\n.control-sidebar-menu > li > a:before, .control-sidebar-menu > li > a:after {\n  content: \" \";\n  display: table;\n}\n\n.control-sidebar-menu > li > a:after {\n  clear: both;\n}\n\n.control-sidebar-menu > li > a > .control-sidebar-subheading {\n  margin-top: 0;\n}\n\n.control-sidebar-menu .menu-icon {\n  float: left;\n  text-align: center;\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  line-height: 35px;\n}\n\n.control-sidebar-menu .menu-info {\n  margin-top: 3px;\n  margin-left: 45px;\n}\n\n.control-sidebar-menu .menu-info > .control-sidebar-subheading {\n  margin: 0;\n}\n\n.control-sidebar-menu .menu-info > p {\n  margin: 0;\n  font-size: 11px;\n}\n\n.control-sidebar-menu .progress {\n  margin: 0;\n}\n\n.control-sidebar-dark {\n  color: #b8c7ce;\n}\n\n.control-sidebar-dark, .control-sidebar-dark + .control-sidebar-bg {\n  background: #222d32;\n}\n\n.control-sidebar-dark .nav-tabs.control-sidebar-tabs {\n  border-bottom: #1c2529;\n}\n\n.control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a {\n  color: #b8c7ce;\n  background: #181f23;\n}\n\n.control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:focus {\n  border-bottom-color: #141a1d;\n  border-left-color: #141a1d;\n}\n\n.control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:focus, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:active {\n  background: #1c2529;\n}\n\n.control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover {\n  color: #fff;\n}\n\n.control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:hover, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:focus, .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:active {\n  color: #fff;\n  background: #222d32;\n}\n\n.control-sidebar-dark .control-sidebar-heading, .control-sidebar-dark .control-sidebar-subheading {\n  color: #fff;\n}\n\n.control-sidebar-dark .control-sidebar-menu > li > a:hover {\n  background: #1e282c;\n}\n\n.control-sidebar-dark .control-sidebar-menu > li > a .menu-info > p {\n  color: #b8c7ce;\n}\n\n.control-sidebar-light {\n  color: #5e5e5e;\n}\n\n.control-sidebar-light, .control-sidebar-light + .control-sidebar-bg {\n  background: #f9fafc;\n  border-left: 1px solid #d2d6de;\n}\n\n.control-sidebar-light .nav-tabs.control-sidebar-tabs {\n  border-bottom: #d2d6de;\n}\n\n.control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a {\n  color: #444;\n  background: #e8ecf4;\n}\n\n.control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:hover, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:focus {\n  border-bottom-color: #d2d6de;\n  border-left-color: #d2d6de;\n}\n\n.control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:hover, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:focus, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:active {\n  background: #eff1f7;\n}\n\n.control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:hover, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:focus, .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:active {\n  color: #111;\n  background: #f9fafc;\n}\n\n.control-sidebar-light .control-sidebar-heading, .control-sidebar-light .control-sidebar-subheading {\n  color: #111;\n}\n\n.control-sidebar-light .control-sidebar-menu {\n  margin-left: -14px;\n}\n\n.control-sidebar-light .control-sidebar-menu > li > a:hover {\n  background: #f4f4f5;\n}\n\n.control-sidebar-light .control-sidebar-menu > li > a .menu-info > p {\n  color: #5e5e5e;\n}\n\n.dropdown-menu {\n  box-shadow: none;\n  border-color: #eee;\n}\n\n.dropdown-menu > li > a {\n  color: #777;\n}\n\n.dropdown-menu > li > a > .glyphicon, .dropdown-menu > li > a > .fa, .dropdown-menu > li > a > .ion {\n  margin-right: 10px;\n}\n\n.dropdown-menu > li > a:hover {\n  color: #333;\n  background-color: #e1e3e9;\n}\n\n.dropdown-menu > .divider {\n  background-color: #eee;\n}\n\n.navbar-nav > .notifications-menu > .dropdown-menu, .navbar-nav > .messages-menu > .dropdown-menu, .navbar-nav > .tasks-menu > .dropdown-menu {\n  width: 280px;\n  margin: 0;\n  padding: 0;\n  top: 100%;\n}\n\n.navbar-nav > .notifications-menu > .dropdown-menu > li, .navbar-nav > .messages-menu > .dropdown-menu > li, .navbar-nav > .tasks-menu > .dropdown-menu > li {\n  position: relative;\n}\n\n.navbar-nav > .notifications-menu > .dropdown-menu > li.header, .navbar-nav > .messages-menu > .dropdown-menu > li.header, .navbar-nav > .tasks-menu > .dropdown-menu > li.header {\n  color: #444;\n  background-color: #fff;\n  border-bottom: 1px solid #f4f4f4;\n  border-radius: 4px 4px 0 0;\n  padding: 7px 10px;\n  font-size: 14px;\n}\n\n.navbar-nav > .notifications-menu > .dropdown-menu > li.footer > a, .navbar-nav > .messages-menu > .dropdown-menu > li.footer > a, .navbar-nav > .tasks-menu > .dropdown-menu > li.footer > a {\n  text-align: center;\n  background-color: #fff;\n  border-bottom: 1px solid #eee;\n  border-radius: 0 0 4px 4px;\n  padding: 7px 10px;\n  font-size: 12px;\n  color: #444 !important;\n}\n\n.navbar-nav > .notifications-menu > .dropdown-menu > li.footer > a:hover, .navbar-nav > .messages-menu > .dropdown-menu > li.footer > a:hover, .navbar-nav > .tasks-menu > .dropdown-menu > li.footer > a:hover {\n  font-weight: 400;\n  text-decoration: none;\n}\n\n.navbar-nav > .notifications-menu > .dropdown-menu > li .menu, .navbar-nav > .messages-menu > .dropdown-menu > li .menu, .navbar-nav > .tasks-menu > .dropdown-menu > li .menu {\n  max-height: 200px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  overflow-x: hidden;\n}\n\n.navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a, .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a, .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a {\n  white-space: nowrap;\n  border-bottom: 1px solid #f4f4f4;\n  display: block;\n}\n\n.navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a:hover, .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:hover, .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a:hover {\n  background: #f4f4f4;\n  text-decoration: none;\n}\n\n.navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a {\n  color: #444;\n  text-overflow: ellipsis;\n  padding: 10px;\n  overflow: hidden;\n}\n\n.navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .glyphicon, .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .fa, .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .ion {\n  width: 20px;\n}\n\n.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a {\n  margin: 0;\n  padding: 10px;\n}\n\n.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > div > img {\n  width: 40px;\n  height: 40px;\n  margin: auto 10px auto auto;\n}\n\n.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > h4 {\n  color: #444;\n  margin: 0 0 0 45px;\n  padding: 0;\n  font-size: 15px;\n  position: relative;\n}\n\n.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > h4 > small {\n  color: #999;\n  font-size: 10px;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > p {\n  color: #888;\n  margin: 0 0 0 45px;\n  font-size: 12px;\n}\n\n.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:before, .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:after {\n  content: \" \";\n  display: table;\n}\n\n.navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:after {\n  clear: both;\n}\n\n.navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a {\n  padding: 10px;\n}\n\n.navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a > h3 {\n  color: #666;\n  margin: 0 0 10px;\n  padding: 0;\n  font-size: 14px;\n}\n\n.navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a > .progress {\n  margin: 0;\n  padding: 0;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu {\n  border-top-width: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  width: 280px;\n  padding: 1px 0 0;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu, .navbar-nav > .user-menu > .dropdown-menu > .user-body {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > li.user-header {\n  text-align: center;\n  height: 175px;\n  padding: 10px;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > li.user-header > img {\n  z-index: 5;\n  border: 3px solid #fff3;\n  width: 90px;\n  height: 90px;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > li.user-header > p {\n  z-index: 5;\n  color: #fffc;\n  margin-top: 10px;\n  font-size: 17px;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > li.user-header > p > small {\n  font-size: 12px;\n  display: block;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > .user-body {\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #f4f4f4;\n  padding: 15px;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > .user-body:before, .navbar-nav > .user-menu > .dropdown-menu > .user-body:after {\n  content: \" \";\n  display: table;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > .user-body:after {\n  clear: both;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > .user-body a {\n  color: #444 !important;\n}\n\n@media (width <= 991px) {\n  .navbar-nav > .user-menu > .dropdown-menu > .user-body a {\n    color: #444 !important;\n    background: #fff !important;\n  }\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > .user-footer {\n  background-color: #f9f9f9;\n  padding: 10px;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > .user-footer:before, .navbar-nav > .user-menu > .dropdown-menu > .user-footer:after {\n  content: \" \";\n  display: table;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > .user-footer:after {\n  clear: both;\n}\n\n.navbar-nav > .user-menu > .dropdown-menu > .user-footer .btn-default {\n  color: #666;\n}\n\n.navbar-nav > .user-menu .user-image {\n  float: left;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  margin-top: -2px;\n  margin-right: 10px;\n}\n\n.open:not(.dropup) > .animated-dropdown-menu {\n  animation: .7s both flipInX;\n  backface-visibility: visible !important;\n}\n\n@keyframes flipInX {\n  0% {\n    opacity: 0;\n    transition-timing-function: ease-in;\n    transform: perspective(400px)rotate3d(1, 0, 0, 90deg);\n  }\n\n  40% {\n    transition-timing-function: ease-in;\n    transform: perspective(400px)rotate3d(1, 0, 0, -20deg);\n  }\n\n  60% {\n    opacity: 1;\n    transform: perspective(400px)rotate3d(1, 0, 0, 10deg);\n  }\n\n  80% {\n    transform: perspective(400px)rotate3d(1, 0, 0, -5deg);\n  }\n\n  100% {\n    transform: perspective(400px);\n  }\n}\n\n.navbar-custom-menu > .navbar-nav > li {\n  position: relative;\n}\n\n.navbar-custom-menu > .navbar-nav > li > .dropdown-menu {\n  position: absolute;\n  left: auto;\n  right: 0;\n}\n\n.form-control {\n  box-shadow: none;\n  border-color: #d2d6de;\n  border-radius: 0;\n}\n\n.form-control:focus {\n  box-shadow: none;\n  border-color: #3c8dbc;\n}\n\n.form-control::-moz-placeholder, .form-control:-ms-placeholder-shown, .form-control::-webkit-input-placeholder {\n  color: #bbb;\n  opacity: 1;\n}\n\n.form-control:not(select) {\n  appearance: none;\n}\n\n.form-group.has-success label {\n  color: #00a65a;\n}\n\n.form-group.has-success .form-control {\n  box-shadow: none;\n  border-color: #00a65a;\n}\n\n.form-group.has-success .help-block {\n  color: #00a65a;\n}\n\n.form-group.has-warning label {\n  color: #f39c12;\n}\n\n.form-group.has-warning .form-control {\n  box-shadow: none;\n  border-color: #f39c12;\n}\n\n.form-group.has-warning .help-block {\n  color: #f39c12;\n}\n\n.form-group.has-error label {\n  color: #dd4b39;\n}\n\n.form-group.has-error .form-control {\n  box-shadow: none;\n  border-color: #dd4b39;\n}\n\n.form-group.has-error .help-block {\n  color: #dd4b39;\n}\n\n.input-group .input-group-addon {\n  background-color: #fff;\n  border-color: #d2d6de;\n  border-radius: 0;\n}\n\n.btn-group-vertical .btn.btn-flat:first-of-type, .btn-group-vertical .btn.btn-flat:last-of-type {\n  border-radius: 0;\n}\n\n.icheck > label {\n  padding-left: 0;\n}\n\n.form-control-feedback.fa {\n  line-height: 34px;\n}\n\n.input-lg + .form-control-feedback.fa, .input-group-lg + .form-control-feedback.fa, .form-group-lg .form-control + .form-control-feedback.fa {\n  line-height: 46px;\n}\n\n.input-sm + .form-control-feedback.fa, .input-group-sm + .form-control-feedback.fa, .form-group-sm .form-control + .form-control-feedback.fa {\n  line-height: 30px;\n}\n\n.progress, .progress > .progress-bar {\n  box-shadow: none;\n}\n\n.progress, .progress > .progress-bar, .progress .progress-bar, .progress > .progress-bar .progress-bar {\n  border-radius: 1px;\n}\n\n.progress.sm, .progress-sm {\n  height: 10px;\n}\n\n.progress.sm, .progress-sm, .progress.sm .progress-bar, .progress-sm .progress-bar {\n  border-radius: 1px;\n}\n\n.progress.xs, .progress-xs {\n  height: 7px;\n}\n\n.progress.xs, .progress-xs, .progress.xs .progress-bar, .progress-xs .progress-bar {\n  border-radius: 1px;\n}\n\n.progress.xxs, .progress-xxs {\n  height: 3px;\n}\n\n.progress.xxs, .progress-xxs, .progress.xxs .progress-bar, .progress-xxs .progress-bar {\n  border-radius: 1px;\n}\n\n.progress.vertical {\n  width: 30px;\n  height: 200px;\n  margin-right: 10px;\n  display: inline-block;\n  position: relative;\n}\n\n.progress.vertical > .progress-bar {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n}\n\n.progress.vertical.sm, .progress.vertical.progress-sm {\n  width: 20px;\n}\n\n.progress.vertical.xs, .progress.vertical.progress-xs {\n  width: 10px;\n}\n\n.progress.vertical.xxs, .progress.vertical.progress-xxs {\n  width: 3px;\n}\n\n.progress-group .progress-text {\n  font-weight: 600;\n}\n\n.progress-group .progress-number {\n  float: right;\n}\n\n.table tr > td .progress {\n  margin: 0;\n}\n\n.progress-bar-light-blue, .progress-bar-primary {\n  background-color: #3c8dbc;\n}\n\n.progress-striped .progress-bar-light-blue, .progress-striped .progress-bar-primary {\n  background-image: linear-gradient(45deg, #ffffff26 25%, #0000 25% 50%, #ffffff26 50% 75%, #0000 75%, #0000);\n}\n\n.progress-bar-green, .progress-bar-success {\n  background-color: #00a65a;\n}\n\n.progress-striped .progress-bar-green, .progress-striped .progress-bar-success {\n  background-image: linear-gradient(45deg, #ffffff26 25%, #0000 25% 50%, #ffffff26 50% 75%, #0000 75%, #0000);\n}\n\n.progress-bar-aqua, .progress-bar-info {\n  background-color: #00c0ef;\n}\n\n.progress-striped .progress-bar-aqua, .progress-striped .progress-bar-info {\n  background-image: linear-gradient(45deg, #ffffff26 25%, #0000 25% 50%, #ffffff26 50% 75%, #0000 75%, #0000);\n}\n\n.progress-bar-yellow, .progress-bar-warning {\n  background-color: #f39c12;\n}\n\n.progress-striped .progress-bar-yellow, .progress-striped .progress-bar-warning {\n  background-image: linear-gradient(45deg, #ffffff26 25%, #0000 25% 50%, #ffffff26 50% 75%, #0000 75%, #0000);\n}\n\n.progress-bar-red, .progress-bar-danger {\n  background-color: #dd4b39;\n}\n\n.progress-striped .progress-bar-red, .progress-striped .progress-bar-danger {\n  background-image: linear-gradient(45deg, #ffffff26 25%, #0000 25% 50%, #ffffff26 50% 75%, #0000 75%, #0000);\n}\n\n.small-box {\n  border-radius: 2px;\n  margin-bottom: 20px;\n  display: block;\n  position: relative;\n  box-shadow: 0 1px 1px #0000001a;\n}\n\n.small-box > .inner {\n  padding: 10px;\n}\n\n.small-box > .small-box-footer {\n  text-align: center;\n  color: #fffc;\n  z-index: 10;\n  background: #0000001a;\n  padding: 3px 0;\n  text-decoration: none;\n  display: block;\n  position: relative;\n}\n\n.small-box > .small-box-footer:hover {\n  color: #fff;\n  background: #00000026;\n}\n\n.small-box h3 {\n  white-space: nowrap;\n  margin: 0 0 10px;\n  padding: 0;\n  font-size: 38px;\n  font-weight: 700;\n}\n\n.small-box p {\n  font-size: 15px;\n}\n\n.small-box p > small {\n  color: #f9f9f9;\n  margin-top: 5px;\n  font-size: 13px;\n  display: block;\n}\n\n.small-box h3, .small-box p {\n  z-index: 5;\n}\n\n.small-box .icon {\n  z-index: 0;\n  color: #00000026;\n  font-size: 90px;\n  transition: all .3s linear;\n  position: absolute;\n  top: -10px;\n  right: 10px;\n}\n\n.small-box:hover {\n  color: #f9f9f9;\n  text-decoration: none;\n}\n\n.small-box:hover .icon {\n  font-size: 95px;\n}\n\n@media (width <= 767px) {\n  .small-box {\n    text-align: center;\n  }\n\n  .small-box .icon {\n    display: none;\n  }\n\n  .small-box p {\n    font-size: 12px;\n  }\n}\n\n.box {\n  background: #fff;\n  border-top: 3px solid #d2d6de;\n  border-radius: 3px;\n  width: 100%;\n  margin-bottom: 20px;\n  position: relative;\n  box-shadow: 0 1px 1px #0000001a;\n}\n\n.box.box-primary {\n  border-top-color: #3c8dbc;\n}\n\n.box.box-info {\n  border-top-color: #00c0ef;\n}\n\n.box.box-danger {\n  border-top-color: #dd4b39;\n}\n\n.box.box-warning {\n  border-top-color: #f39c12;\n}\n\n.box.box-success {\n  border-top-color: #00a65a;\n}\n\n.box.box-default {\n  border-top-color: #d2d6de;\n}\n\n.box.collapsed-box .box-body, .box.collapsed-box .box-footer {\n  display: none;\n}\n\n.box .nav-stacked > li {\n  border-bottom: 1px solid #f4f4f4;\n  margin: 0;\n}\n\n.box .nav-stacked > li:last-of-type {\n  border-bottom: none;\n}\n\n.box.height-control .box-body {\n  max-height: 300px;\n  overflow: auto;\n}\n\n.box .border-right {\n  border-right: 1px solid #f4f4f4;\n}\n\n.box .border-left {\n  border-left: 1px solid #f4f4f4;\n}\n\n.box.box-solid {\n  border-top: 0;\n}\n\n.box.box-solid > .box-header .btn.btn-default {\n  background: #fff0;\n}\n\n.box.box-solid > .box-header .btn:hover, .box.box-solid > .box-header a:hover {\n  background: #0000001a;\n}\n\n.box.box-solid.box-default {\n  border: 1px solid #d2d6de;\n}\n\n.box.box-solid.box-default > .box-header {\n  color: #444;\n  background: #d2d6de;\n}\n\n.box.box-solid.box-default > .box-header a, .box.box-solid.box-default > .box-header .btn {\n  color: #444;\n}\n\n.box.box-solid.box-primary {\n  border: 1px solid #3c8dbc;\n}\n\n.box.box-solid.box-primary > .box-header {\n  color: #fff;\n  background: #3c8dbc;\n}\n\n.box.box-solid.box-primary > .box-header a, .box.box-solid.box-primary > .box-header .btn {\n  color: #fff;\n}\n\n.box.box-solid.box-info {\n  border: 1px solid #00c0ef;\n}\n\n.box.box-solid.box-info > .box-header {\n  color: #fff;\n  background: #00c0ef;\n}\n\n.box.box-solid.box-info > .box-header a, .box.box-solid.box-info > .box-header .btn {\n  color: #fff;\n}\n\n.box.box-solid.box-danger {\n  border: 1px solid #dd4b39;\n}\n\n.box.box-solid.box-danger > .box-header {\n  color: #fff;\n  background: #dd4b39;\n}\n\n.box.box-solid.box-danger > .box-header a, .box.box-solid.box-danger > .box-header .btn {\n  color: #fff;\n}\n\n.box.box-solid.box-warning {\n  border: 1px solid #f39c12;\n}\n\n.box.box-solid.box-warning > .box-header {\n  color: #fff;\n  background: #f39c12;\n}\n\n.box.box-solid.box-warning > .box-header a, .box.box-solid.box-warning > .box-header .btn {\n  color: #fff;\n}\n\n.box.box-solid.box-success {\n  border: 1px solid #00a65a;\n}\n\n.box.box-solid.box-success > .box-header {\n  color: #fff;\n  background: #00a65a;\n}\n\n.box.box-solid.box-success > .box-header a, .box.box-solid.box-success > .box-header .btn {\n  color: #fff;\n}\n\n.box.box-solid > .box-header > .box-tools .btn {\n  box-shadow: none;\n  border: 0;\n}\n\n.box.box-solid[class*=\"bg\"] > .box-header {\n  color: #fff;\n}\n\n.box .box-group > .box {\n  margin-bottom: 5px;\n}\n\n.box .knob-label {\n  text-align: center;\n  color: #333;\n  margin-bottom: .3em;\n  font-size: 12px;\n  font-weight: 100;\n}\n\n.box > .overlay, .overlay-wrapper > .overlay, .box > .loading-img, .overlay-wrapper > .loading-img {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.box .overlay, .overlay-wrapper .overlay {\n  z-index: 50;\n  background: #ffffffb3;\n  border-radius: 3px;\n}\n\n.box .overlay > .fa, .overlay-wrapper .overlay > .fa {\n  color: #000;\n  margin-top: -15px;\n  margin-left: -15px;\n  font-size: 30px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.box .overlay.dark, .overlay-wrapper .overlay.dark {\n  background: #00000080;\n}\n\n.box-header:before, .box-body:before, .box-footer:before, .box-header:after, .box-body:after, .box-footer:after {\n  content: \" \";\n  display: table;\n}\n\n.box-header:after, .box-body:after, .box-footer:after {\n  clear: both;\n}\n\n.box-header {\n  color: #444;\n  padding: 10px;\n  display: block;\n  position: relative;\n}\n\n.box-header.with-border {\n  border-bottom: 1px solid #f4f4f4;\n}\n\n.collapsed-box .box-header.with-border {\n  border-bottom: none;\n}\n\n.box-header > .fa, .box-header > .glyphicon, .box-header > .ion, .box-header .box-title {\n  margin: 0;\n  font-size: 18px;\n  line-height: 1;\n  display: inline-block;\n}\n\n.box-header > .fa, .box-header > .glyphicon, .box-header > .ion {\n  margin-right: 5px;\n}\n\n.box-header > .box-tools {\n  position: absolute;\n  top: 5px;\n  right: 10px;\n}\n\n.box-header > .box-tools [data-toggle=\"tooltip\"] {\n  position: relative;\n}\n\n.box-header > .box-tools.pull-right .dropdown-menu {\n  left: auto;\n  right: 0;\n}\n\n.btn-box-tool {\n  color: #97a0b3;\n  background: #fff0;\n  padding: 5px;\n  font-size: 12px;\n}\n\n.open .btn-box-tool, .btn-box-tool:hover {\n  color: #606c84;\n}\n\n.btn-box-tool.btn:active {\n  box-shadow: none;\n}\n\n.box-body {\n  border-radius: 0 0 3px 3px;\n  padding: 10px;\n}\n\n.no-header .box-body {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.box-body > .table {\n  margin-bottom: 0;\n}\n\n.box-body .fc {\n  margin-top: 5px;\n}\n\n.box-body .full-width-chart {\n  margin: -19px;\n}\n\n.box-body.no-padding .full-width-chart {\n  margin: -9px;\n}\n\n.box-body .box-pane {\n  border-radius: 0 0 0 3px;\n}\n\n.box-body .box-pane-right {\n  border-radius: 0 0 3px;\n}\n\n.box-footer {\n  background-color: #fff;\n  border-top: 1px solid #f4f4f4;\n  border-radius: 0 0 3px 3px;\n  padding: 10px;\n}\n\n.chart-legend {\n  margin: 10px 0;\n}\n\n@media (width <= 991px) {\n  .chart-legend > li {\n    float: left;\n    margin-right: 10px;\n  }\n}\n\n.box-comments {\n  background: #f7f7f7;\n}\n\n.box-comments .box-comment {\n  border-bottom: 1px solid #eee;\n  padding: 8px 0;\n}\n\n.box-comments .box-comment:before, .box-comments .box-comment:after {\n  content: \" \";\n  display: table;\n}\n\n.box-comments .box-comment:after {\n  clear: both;\n}\n\n.box-comments .box-comment:last-of-type {\n  border-bottom: 0;\n}\n\n.box-comments .box-comment:first-of-type {\n  padding-top: 0;\n}\n\n.box-comments .box-comment img {\n  float: left;\n}\n\n.box-comments .comment-text {\n  color: #555;\n  margin-left: 40px;\n}\n\n.box-comments .username {\n  color: #444;\n  font-weight: 600;\n  display: block;\n}\n\n.box-comments .text-muted {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.todo-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  overflow: auto;\n}\n\n.todo-list > li {\n  color: #444;\n  background: #f4f4f4;\n  border-left: 2px solid #e6e7e8;\n  border-radius: 2px;\n  margin-bottom: 2px;\n  padding: 10px;\n}\n\n.todo-list > li:last-of-type {\n  margin-bottom: 0;\n}\n\n.todo-list > li > input[type=\"checkbox\"] {\n  margin: 0 10px 0 5px;\n}\n\n.todo-list > li .text {\n  margin-left: 5px;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.todo-list > li .label {\n  margin-left: 10px;\n  font-size: 9px;\n}\n\n.todo-list > li .tools {\n  float: right;\n  color: #dd4b39;\n  display: none;\n}\n\n.todo-list > li .tools > .fa, .todo-list > li .tools > .glyphicon, .todo-list > li .tools > .ion {\n  cursor: pointer;\n  margin-right: 5px;\n}\n\n.todo-list > li:hover .tools {\n  display: inline-block;\n}\n\n.todo-list > li.done {\n  color: #999;\n}\n\n.todo-list > li.done .text {\n  font-weight: 500;\n  text-decoration: line-through;\n}\n\n.todo-list > li.done .label {\n  background: #d2d6de !important;\n}\n\n.todo-list .danger {\n  border-left-color: #dd4b39;\n}\n\n.todo-list .warning {\n  border-left-color: #f39c12;\n}\n\n.todo-list .info {\n  border-left-color: #00c0ef;\n}\n\n.todo-list .success {\n  border-left-color: #00a65a;\n}\n\n.todo-list .primary {\n  border-left-color: #3c8dbc;\n}\n\n.todo-list .handle {\n  cursor: move;\n  margin: 0 5px;\n  display: inline-block;\n}\n\n.chat {\n  padding: 5px 20px 5px 10px;\n}\n\n.chat .item {\n  margin-bottom: 10px;\n}\n\n.chat .item:before, .chat .item:after {\n  content: \" \";\n  display: table;\n}\n\n.chat .item:after {\n  clear: both;\n}\n\n.chat .item > img {\n  border: 2px solid #fff0;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n}\n\n.chat .item > .online {\n  border: 2px solid #00a65a;\n}\n\n.chat .item > .offline {\n  border: 2px solid #dd4b39;\n}\n\n.chat .item > .message {\n  margin-top: -40px;\n  margin-left: 55px;\n}\n\n.chat .item > .message > .name {\n  font-weight: 600;\n  display: block;\n}\n\n.chat .item > .attachment {\n  background: #f4f4f4;\n  border-radius: 3px;\n  margin-left: 65px;\n  margin-right: 15px;\n  padding: 10px;\n}\n\n.chat .item > .attachment > h4 {\n  margin: 0 0 5px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.chat .item > .attachment > p, .chat .item > .attachment > .filename {\n  margin: 0;\n  font-size: 13px;\n  font-style: italic;\n  font-weight: 600;\n}\n\n.chat .item > .attachment:before, .chat .item > .attachment:after {\n  content: \" \";\n  display: table;\n}\n\n.chat .item > .attachment:after {\n  clear: both;\n}\n\n.box-input {\n  max-width: 200px;\n}\n\n.modal .panel-body {\n  color: #444;\n}\n\n.info-box {\n  background: #fff;\n  border-radius: 2px;\n  width: 100%;\n  min-height: 90px;\n  margin-bottom: 15px;\n  display: block;\n  box-shadow: 0 1px 1px #0000001a;\n}\n\n.info-box small {\n  font-size: 14px;\n}\n\n.info-box .progress {\n  background: #0003;\n  height: 2px;\n  margin: 5px -10px;\n}\n\n.info-box .progress, .info-box .progress .progress-bar {\n  border-radius: 0;\n}\n\n.info-box .progress .progress-bar {\n  background: #fff;\n}\n\n.info-box-icon {\n  float: left;\n  text-align: center;\n  background: #0003;\n  border-radius: 2px 0 0 2px;\n  width: 90px;\n  height: 90px;\n  font-size: 45px;\n  line-height: 90px;\n  display: block;\n}\n\n.info-box-icon > img {\n  max-width: 100%;\n}\n\n.info-box-content {\n  margin-left: 90px;\n  padding: 5px 10px;\n}\n\n.info-box-number {\n  font-size: 18px;\n  font-weight: 700;\n  display: block;\n}\n\n.progress-description, .info-box-text {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  display: block;\n  overflow: hidden;\n}\n\n.info-box-text {\n  text-transform: uppercase;\n}\n\n.info-box-more {\n  display: block;\n}\n\n.progress-description {\n  margin: 0;\n}\n\n.timeline {\n  margin: 0 0 30px;\n  padding: 0;\n  list-style: none;\n  position: relative;\n}\n\n.timeline:before {\n  content: \"\";\n  background: #ddd;\n  border-radius: 2px;\n  width: 4px;\n  margin: 0;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 31px;\n}\n\n.timeline > li {\n  margin-bottom: 15px;\n  margin-right: 10px;\n  position: relative;\n}\n\n.timeline > li:before, .timeline > li:after {\n  content: \" \";\n  display: table;\n}\n\n.timeline > li:after {\n  clear: both;\n}\n\n.timeline > li > .timeline-item {\n  color: #444;\n  background: #fff;\n  border-radius: 3px;\n  margin-top: 0;\n  margin-left: 60px;\n  margin-right: 15px;\n  padding: 0;\n  position: relative;\n  box-shadow: 0 1px 1px #0000001a;\n}\n\n.timeline > li > .timeline-item > .time {\n  color: #999;\n  float: right;\n  padding: 10px;\n  font-size: 12px;\n}\n\n.timeline > li > .timeline-item > .timeline-header {\n  color: #555;\n  border-bottom: 1px solid #f4f4f4;\n  margin: 0;\n  padding: 10px;\n  font-size: 16px;\n  line-height: 1.1;\n}\n\n.timeline > li > .timeline-item > .timeline-header > a {\n  font-weight: 600;\n}\n\n.timeline > li > .timeline-item > .timeline-body, .timeline > li > .timeline-item > .timeline-footer {\n  padding: 10px;\n}\n\n.timeline > li > .fa, .timeline > li > .glyphicon, .timeline > li > .ion {\n  color: #666;\n  text-align: center;\n  background: #d2d6de;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  font-size: 15px;\n  line-height: 30px;\n  position: absolute;\n  top: 0;\n  left: 18px;\n}\n\n.timeline > .time-label > span {\n  background-color: #fff;\n  border-radius: 4px;\n  padding: 5px;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.timeline-inverse > li > .timeline-item {\n  box-shadow: none;\n  background: #f0f0f0;\n  border: 1px solid #ddd;\n}\n\n.timeline-inverse > li > .timeline-item > .timeline-header {\n  border-bottom-color: #ddd;\n}\n\n.btn {\n  box-shadow: none;\n  border: 1px solid #fff0;\n  border-radius: 3px;\n}\n\n.btn.uppercase {\n  text-transform: uppercase;\n}\n\n.btn.btn-flat {\n  box-shadow: none;\n  border-width: 1px;\n  border-radius: 0;\n}\n\n.btn:active {\n  box-shadow: inset 0 3px 5px #00000020;\n}\n\n.btn:focus {\n  outline: none;\n}\n\n.btn.btn-file {\n  position: relative;\n  overflow: hidden;\n}\n\n.btn.btn-file > input[type=\"file\"] {\n  text-align: right;\n  opacity: 0;\n  min-width: 100%;\n  min-height: 100%;\n  filter: alpha(opacity= 0);\n  cursor: inherit;\n  background: #fff;\n  outline: none;\n  font-size: 100px;\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.btn-default {\n  color: #444;\n  background-color: #f4f4f4;\n  border-color: #ddd;\n}\n\n.btn-default:hover, .btn-default:active, .btn-default.hover {\n  background-color: #e7e7e7;\n}\n\n.btn-primary {\n  background-color: #3c8dbc;\n  border-color: #367fa9;\n}\n\n.btn-primary:hover, .btn-primary:active, .btn-primary.hover {\n  background-color: #367fa9;\n}\n\n.btn-success {\n  background-color: #00a65a;\n  border-color: #008d4c;\n}\n\n.btn-success:hover, .btn-success:active, .btn-success.hover {\n  background-color: #008d4c;\n}\n\n.btn-info {\n  background-color: #00c0ef;\n  border-color: #00acd6;\n}\n\n.btn-info:hover, .btn-info:active, .btn-info.hover {\n  background-color: #00acd6;\n}\n\n.btn-danger {\n  background-color: #dd4b39;\n  border-color: #d73925;\n}\n\n.btn-danger:hover, .btn-danger:active, .btn-danger.hover {\n  background-color: #d73925;\n}\n\n.btn-warning {\n  background-color: #f39c12;\n  border-color: #e08e0b;\n}\n\n.btn-warning:hover, .btn-warning:active, .btn-warning.hover {\n  background-color: #e08e0b;\n}\n\n.btn-outline {\n  color: #fff;\n  background: #fff0;\n  border: 1px solid #fff;\n}\n\n.btn-outline:hover, .btn-outline:focus, .btn-outline:active {\n  color: #ffffffb3;\n  border-color: #ffffffb3;\n}\n\n.btn-link {\n  box-shadow: none;\n}\n\n.btn[class*=\"bg-\"]:hover {\n  box-shadow: inset 0 0 100px #0003;\n}\n\n.btn-app {\n  text-align: center;\n  color: #666;\n  background-color: #f4f4f4;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  min-width: 80px;\n  height: 60px;\n  margin: 0 0 10px 10px;\n  padding: 15px 5px;\n  font-size: 12px;\n  position: relative;\n}\n\n.btn-app > .fa, .btn-app > .glyphicon, .btn-app > .ion {\n  font-size: 20px;\n  display: block;\n}\n\n.btn-app:hover {\n  color: #444;\n  background: #f4f4f4;\n  border-color: #aaa;\n}\n\n.btn-app:active, .btn-app:focus {\n  box-shadow: inset 0 3px 5px #00000020;\n}\n\n.btn-app > .badge {\n  font-size: 10px;\n  font-weight: 400;\n  position: absolute;\n  top: -3px;\n  right: -10px;\n}\n\n.callout {\n  border-left: 5px solid #eee;\n  border-radius: 3px;\n  margin: 0 0 20px;\n  padding: 15px 30px 15px 15px;\n}\n\n.callout a {\n  color: #fff;\n  text-decoration: underline;\n}\n\n.callout a:hover {\n  color: #eee;\n}\n\n.callout h4 {\n  margin-top: 0;\n  font-weight: 600;\n}\n\n.callout p:last-child {\n  margin-bottom: 0;\n}\n\n.callout code, .callout .highlight {\n  background-color: #fff;\n}\n\n.callout.callout-danger {\n  border-color: #c23321;\n}\n\n.callout.callout-warning {\n  border-color: #c87f0a;\n}\n\n.callout.callout-info {\n  border-color: #0097bc;\n}\n\n.callout.callout-success {\n  border-color: #00733e;\n}\n\n.alert {\n  border-radius: 3px;\n}\n\n.alert h4 {\n  font-weight: 600;\n}\n\n.alert .icon {\n  margin-right: 10px;\n}\n\n.alert .close {\n  color: #000;\n  opacity: .2;\n  filter: alpha(opacity= 20);\n}\n\n.alert .close:hover {\n  opacity: .5;\n  filter: alpha(opacity= 50);\n}\n\n.alert a {\n  color: #fff;\n  text-decoration: underline;\n}\n\n.alert-success {\n  border-color: #008d4c;\n}\n\n.alert-danger, .alert-error {\n  border-color: #d73925;\n}\n\n.alert-warning {\n  border-color: #e08e0b;\n}\n\n.alert-info {\n  border-color: #00acd6;\n}\n\n.nav > li > a:hover, .nav > li > a:active, .nav > li > a:focus {\n  color: #444;\n  background: #f7f7f7;\n}\n\n.nav-pills > li > a {\n  color: #444;\n  border-top: 3px solid #fff0;\n  border-radius: 0;\n}\n\n.nav-pills > li > a > .fa, .nav-pills > li > a > .glyphicon, .nav-pills > li > a > .ion {\n  margin-right: 5px;\n}\n\n.nav-pills > li.active > a, .nav-pills > li.active > a:hover, .nav-pills > li.active > a:focus {\n  border-top-color: #3c8dbc;\n}\n\n.nav-pills > li.active > a {\n  font-weight: 600;\n}\n\n.nav-stacked > li > a {\n  color: #444;\n  border-top: 0;\n  border-left: 3px solid #fff0;\n  border-radius: 0;\n}\n\n.nav-stacked > li.active > a, .nav-stacked > li.active > a:hover {\n  color: #444;\n  background: #fff0;\n  border-top: 0;\n  border-left-color: #3c8dbc;\n}\n\n.nav-stacked > li.header {\n  color: #777;\n  text-transform: uppercase;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 10px;\n  padding: 5px 10px;\n}\n\n.nav-tabs-custom {\n  background: #fff;\n  border-radius: 3px;\n  margin-bottom: 20px;\n  box-shadow: 0 1px 1px #0000001a;\n}\n\n.nav-tabs-custom > .nav-tabs {\n  border-bottom-color: #f4f4f4;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  margin: 0;\n}\n\n.nav-tabs-custom > .nav-tabs > li {\n  border-top: 3px solid #fff0;\n  margin-bottom: -2px;\n  margin-right: 5px;\n}\n\n.nav-tabs-custom > .nav-tabs > li > a {\n  color: #444;\n  border-radius: 0;\n}\n\n.nav-tabs-custom > .nav-tabs > li > a.text-muted {\n  color: #999;\n}\n\n.nav-tabs-custom > .nav-tabs > li > a, .nav-tabs-custom > .nav-tabs > li > a:hover {\n  background: #fff0;\n  margin: 0;\n}\n\n.nav-tabs-custom > .nav-tabs > li > a:hover {\n  color: #999;\n}\n\n.nav-tabs-custom > .nav-tabs > li:not(.active) > a:hover, .nav-tabs-custom > .nav-tabs > li:not(.active) > a:focus, .nav-tabs-custom > .nav-tabs > li:not(.active) > a:active {\n  border-color: #fff0;\n}\n\n.nav-tabs-custom > .nav-tabs > li.active {\n  border-top-color: #3c8dbc;\n}\n\n.nav-tabs-custom > .nav-tabs > li.active > a, .nav-tabs-custom > .nav-tabs > li.active:hover > a {\n  color: #444;\n  background-color: #fff;\n}\n\n.nav-tabs-custom > .nav-tabs > li.active > a {\n  border-top-color: #fff0;\n  border-left-color: #f4f4f4;\n  border-right-color: #f4f4f4;\n}\n\n.nav-tabs-custom > .nav-tabs > li:first-of-type {\n  margin-left: 0;\n}\n\n.nav-tabs-custom > .nav-tabs > li:first-of-type.active > a {\n  border-left-color: #fff0;\n}\n\n.nav-tabs-custom > .nav-tabs.pull-right {\n  float: none !important;\n}\n\n.nav-tabs-custom > .nav-tabs.pull-right > li {\n  float: right;\n}\n\n.nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type {\n  margin-right: 0;\n}\n\n.nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type > a {\n  border-left-width: 1px;\n}\n\n.nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type.active > a {\n  border-left-color: #f4f4f4;\n  border-right-color: #fff0;\n}\n\n.nav-tabs-custom > .nav-tabs > li.header {\n  color: #444;\n  padding: 0 10px;\n  font-size: 20px;\n  line-height: 35px;\n}\n\n.nav-tabs-custom > .nav-tabs > li.header > .fa, .nav-tabs-custom > .nav-tabs > li.header > .glyphicon, .nav-tabs-custom > .nav-tabs > li.header > .ion {\n  margin-right: 5px;\n}\n\n.nav-tabs-custom > .tab-content {\n  background: #fff;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n  padding: 10px;\n}\n\n.nav-tabs-custom .dropdown.open > a:active, .nav-tabs-custom .dropdown.open > a:focus {\n  color: #999;\n  background: #fff0;\n}\n\n.nav-tabs-custom.tab-primary > .nav-tabs > li.active {\n  border-top-color: #3c8dbc;\n}\n\n.nav-tabs-custom.tab-info > .nav-tabs > li.active {\n  border-top-color: #00c0ef;\n}\n\n.nav-tabs-custom.tab-danger > .nav-tabs > li.active {\n  border-top-color: #dd4b39;\n}\n\n.nav-tabs-custom.tab-warning > .nav-tabs > li.active {\n  border-top-color: #f39c12;\n}\n\n.nav-tabs-custom.tab-success > .nav-tabs > li.active {\n  border-top-color: #00a65a;\n}\n\n.nav-tabs-custom.tab-default > .nav-tabs > li.active {\n  border-top-color: #d2d6de;\n}\n\n.pagination > li > a {\n  color: #666;\n  background: #fafafa;\n}\n\n.pagination.pagination-flat > li > a {\n  border-radius: 0 !important;\n}\n\n.products-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.products-list > .item {\n  background: #fff;\n  border-radius: 3px;\n  padding: 10px 0;\n  box-shadow: 0 1px 1px #0000001a;\n}\n\n.products-list > .item:before, .products-list > .item:after {\n  content: \" \";\n  display: table;\n}\n\n.products-list > .item:after {\n  clear: both;\n}\n\n.products-list .product-img {\n  float: left;\n}\n\n.products-list .product-img img {\n  width: 50px;\n  height: 50px;\n}\n\n.products-list .product-info {\n  margin-left: 60px;\n}\n\n.products-list .product-title {\n  font-weight: 600;\n}\n\n.products-list .product-description {\n  color: #999;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  display: block;\n  overflow: hidden;\n}\n\n.product-list-in-box > .item {\n  box-shadow: none;\n  border-bottom: 1px solid #f4f4f4;\n  border-radius: 0;\n}\n\n.product-list-in-box > .item:last-of-type {\n  border-bottom-width: 0;\n}\n\n.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {\n  border-top: 1px solid #f4f4f4;\n}\n\n.table > thead > tr > th {\n  border-bottom: 2px solid #f4f4f4;\n}\n\n.table tr td .progress {\n  margin-top: 5px;\n}\n\n.table-bordered, .table-bordered > thead > tr > th, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > tbody > tr > td, .table-bordered > tfoot > tr > td {\n  border: 1px solid #f4f4f4;\n}\n\n.table-bordered > thead > tr > th, .table-bordered > thead > tr > td {\n  border-bottom-width: 2px;\n}\n\n.table.no-border, .table.no-border td, .table.no-border th {\n  border: 0;\n}\n\ntable.text-center, table.text-center td, table.text-center th {\n  text-align: center;\n}\n\n.table.align th {\n  text-align: left;\n}\n\n.table.align td {\n  text-align: right;\n}\n\n.label-default {\n  color: #444;\n  background-color: #d2d6de;\n}\n\n.direct-chat .box-body {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  padding: 0;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.direct-chat.chat-pane-open .direct-chat-contacts {\n  transform: translate(0);\n}\n\n.direct-chat-messages {\n  height: 250px;\n  padding: 10px;\n  overflow: auto;\n  transform: translate(0);\n}\n\n.direct-chat-msg, .direct-chat-text {\n  display: block;\n}\n\n.direct-chat-msg {\n  margin-bottom: 10px;\n}\n\n.direct-chat-msg:before, .direct-chat-msg:after {\n  content: \" \";\n  display: table;\n}\n\n.direct-chat-msg:after {\n  clear: both;\n}\n\n.direct-chat-messages, .direct-chat-contacts {\n  transition: transform .5s ease-in-out;\n}\n\n.direct-chat-text {\n  color: #444;\n  background: #d2d6de;\n  border: 1px solid #d2d6de;\n  border-radius: 5px;\n  margin: 5px 0 0 50px;\n  padding: 5px 10px;\n  position: relative;\n}\n\n.direct-chat-text:after, .direct-chat-text:before {\n  content: \" \";\n  pointer-events: none;\n  border: solid #fff0;\n  border-right-color: #d2d6de;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 15px;\n  right: 100%;\n}\n\n.direct-chat-text:after {\n  border-width: 5px;\n  margin-top: -5px;\n}\n\n.direct-chat-text:before {\n  border-width: 6px;\n  margin-top: -6px;\n}\n\n.right .direct-chat-text {\n  margin-left: 0;\n  margin-right: 50px;\n}\n\n.right .direct-chat-text:after, .right .direct-chat-text:before {\n  border-left-color: #d2d6de;\n  border-right-color: #fff0;\n  left: 100%;\n  right: auto;\n}\n\n.direct-chat-img {\n  float: left;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n}\n\n.right .direct-chat-img {\n  float: right;\n}\n\n.direct-chat-info {\n  margin-bottom: 2px;\n  font-size: 12px;\n  display: block;\n}\n\n.direct-chat-name {\n  font-weight: 600;\n}\n\n.direct-chat-timestamp {\n  color: #999;\n}\n\n.direct-chat-contacts-open .direct-chat-contacts {\n  transform: translate(0);\n}\n\n.direct-chat-contacts {\n  color: #fff;\n  background: #222d32;\n  width: 100%;\n  height: 250px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  overflow: auto;\n  transform: translate(101%);\n}\n\n.contacts-list > li {\n  border-bottom: 1px solid #0003;\n  margin: 0;\n  padding: 10px;\n}\n\n.contacts-list > li:before, .contacts-list > li:after {\n  content: \" \";\n  display: table;\n}\n\n.contacts-list > li:after {\n  clear: both;\n}\n\n.contacts-list > li:last-of-type {\n  border-bottom: none;\n}\n\n.contacts-list-img {\n  float: left;\n  border-radius: 50%;\n  width: 40px;\n}\n\n.contacts-list-info {\n  color: #fff;\n  margin-left: 45px;\n}\n\n.contacts-list-name, .contacts-list-status {\n  display: block;\n}\n\n.contacts-list-name {\n  font-weight: 600;\n}\n\n.contacts-list-status {\n  font-size: 12px;\n}\n\n.contacts-list-date {\n  color: #aaa;\n  font-weight: 400;\n}\n\n.contacts-list-msg {\n  color: #999;\n}\n\n.direct-chat-danger .right > .direct-chat-text {\n  color: #fff;\n  background: #dd4b39;\n  border-color: #dd4b39;\n}\n\n.direct-chat-danger .right > .direct-chat-text:after, .direct-chat-danger .right > .direct-chat-text:before {\n  border-left-color: #dd4b39;\n}\n\n.direct-chat-primary .right > .direct-chat-text {\n  color: #fff;\n  background: #3c8dbc;\n  border-color: #3c8dbc;\n}\n\n.direct-chat-primary .right > .direct-chat-text:after, .direct-chat-primary .right > .direct-chat-text:before {\n  border-left-color: #3c8dbc;\n}\n\n.direct-chat-warning .right > .direct-chat-text {\n  color: #fff;\n  background: #f39c12;\n  border-color: #f39c12;\n}\n\n.direct-chat-warning .right > .direct-chat-text:after, .direct-chat-warning .right > .direct-chat-text:before {\n  border-left-color: #f39c12;\n}\n\n.direct-chat-info .right > .direct-chat-text {\n  color: #fff;\n  background: #00c0ef;\n  border-color: #00c0ef;\n}\n\n.direct-chat-info .right > .direct-chat-text:after, .direct-chat-info .right > .direct-chat-text:before {\n  border-left-color: #00c0ef;\n}\n\n.direct-chat-success .right > .direct-chat-text {\n  color: #fff;\n  background: #00a65a;\n  border-color: #00a65a;\n}\n\n.direct-chat-success .right > .direct-chat-text:after, .direct-chat-success .right > .direct-chat-text:before {\n  border-left-color: #00a65a;\n}\n\n.users-list > li {\n  float: left;\n  text-align: center;\n  width: 25%;\n  padding: 10px;\n}\n\n.users-list > li img {\n  border-radius: 50%;\n  max-width: 100%;\n  height: auto;\n}\n\n.users-list > li > a:hover, .users-list > li > a:hover .users-list-name {\n  color: #999;\n}\n\n.users-list-name, .users-list-date {\n  display: block;\n}\n\n.users-list-name {\n  color: #444;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-weight: 600;\n  overflow: hidden;\n}\n\n.users-list-date {\n  color: #999;\n  font-size: 12px;\n}\n\n.carousel-control.left, .carousel-control.right {\n  background-image: none;\n}\n\n.carousel-control > .fa {\n  z-index: 5;\n  margin-top: -20px;\n  font-size: 40px;\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n}\n\n.modal {\n  background: #0000004d;\n}\n\n.modal-content {\n  border: 0;\n  border-radius: 0;\n  box-shadow: 0 2px 3px #00000020;\n}\n\n@media (width >= 768px) {\n  .modal-content {\n    box-shadow: 0 2px 3px #00000020;\n  }\n}\n\n.modal-header {\n  border-bottom-color: #f4f4f4;\n}\n\n.modal-footer {\n  border-top-color: #f4f4f4;\n}\n\n.modal-primary .modal-header, .modal-primary .modal-footer {\n  border-color: #307095;\n}\n\n.modal-warning .modal-header, .modal-warning .modal-footer {\n  border-color: #c87f0a;\n}\n\n.modal-info .modal-header, .modal-info .modal-footer {\n  border-color: #0097bc;\n}\n\n.modal-success .modal-header, .modal-success .modal-footer {\n  border-color: #00733e;\n}\n\n.modal-danger .modal-header, .modal-danger .modal-footer {\n  border-color: #c23321;\n}\n\n.box-widget {\n  border: none;\n  position: relative;\n}\n\n.widget-user .widget-user-header {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  height: 120px;\n  padding: 20px;\n}\n\n.widget-user .widget-user-username {\n  text-shadow: 0 1px 1px #0003;\n  margin-top: 0;\n  margin-bottom: 5px;\n  font-size: 25px;\n  font-weight: 300;\n}\n\n.widget-user .widget-user-desc {\n  margin-top: 0;\n}\n\n.widget-user .widget-user-image {\n  margin-left: -45px;\n  position: absolute;\n  top: 65px;\n  left: 50%;\n}\n\n.widget-user .widget-user-image > img {\n  border: 3px solid #fff;\n  width: 90px;\n  height: auto;\n}\n\n.widget-user .box-footer {\n  padding-top: 30px;\n}\n\n.widget-user-2 .widget-user-header {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  padding: 20px;\n}\n\n.widget-user-2 .widget-user-username {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  font-size: 25px;\n  font-weight: 300;\n}\n\n.widget-user-2 .widget-user-desc {\n  margin-top: 0;\n}\n\n.widget-user-2 .widget-user-username, .widget-user-2 .widget-user-desc {\n  margin-left: 75px;\n}\n\n.widget-user-2 .widget-user-image > img {\n  float: left;\n  width: 65px;\n  height: auto;\n}\n\n.mailbox-messages > .table {\n  margin: 0;\n}\n\n.mailbox-controls {\n  padding: 5px;\n}\n\n.mailbox-controls.with-border {\n  border-bottom: 1px solid #f4f4f4;\n}\n\n.mailbox-read-info {\n  border-bottom: 1px solid #f4f4f4;\n  padding: 10px;\n}\n\n.mailbox-read-info h3 {\n  margin: 0;\n  font-size: 20px;\n}\n\n.mailbox-read-info h5 {\n  margin: 0;\n  padding: 5px 0 0;\n}\n\n.mailbox-read-time {\n  color: #999;\n  font-size: 13px;\n}\n\n.mailbox-read-message {\n  padding: 10px;\n}\n\n.mailbox-attachments li {\n  float: left;\n  border: 1px solid #eee;\n  width: 200px;\n  margin-bottom: 10px;\n  margin-right: 10px;\n}\n\n.mailbox-attachment-name {\n  color: #666;\n  font-weight: 700;\n}\n\n.mailbox-attachment-icon, .mailbox-attachment-info, .mailbox-attachment-size {\n  display: block;\n}\n\n.mailbox-attachment-info {\n  background: #f4f4f4;\n  padding: 10px;\n}\n\n.mailbox-attachment-size {\n  color: #999;\n  font-size: 12px;\n}\n\n.mailbox-attachment-icon {\n  text-align: center;\n  color: #666;\n  padding: 20px 10px;\n  font-size: 65px;\n}\n\n.mailbox-attachment-icon.has-img {\n  padding: 0;\n}\n\n.mailbox-attachment-icon.has-img > img {\n  max-width: 100%;\n  height: auto;\n}\n\n.lockscreen {\n  background: #d2d6de;\n}\n\n.lockscreen-logo {\n  text-align: center;\n  margin-bottom: 25px;\n  font-size: 35px;\n  font-weight: 300;\n}\n\n.lockscreen-logo a {\n  color: #444;\n}\n\n.lockscreen-wrapper {\n  max-width: 400px;\n  margin: 10% auto 0;\n}\n\n.lockscreen .lockscreen-name {\n  text-align: center;\n  font-weight: 600;\n}\n\n.lockscreen-item {\n  background: #fff;\n  border-radius: 4px;\n  width: 290px;\n  margin: 10px auto 30px;\n  padding: 0;\n  position: relative;\n}\n\n.lockscreen-image {\n  z-index: 10;\n  background: #fff;\n  border-radius: 50%;\n  padding: 5px;\n  position: absolute;\n  top: -25px;\n  left: -10px;\n}\n\n.lockscreen-image > img {\n  border-radius: 50%;\n  width: 70px;\n  height: 70px;\n}\n\n.lockscreen-credentials {\n  margin-left: 70px;\n}\n\n.lockscreen-credentials .form-control {\n  border: 0;\n}\n\n.lockscreen-credentials .btn {\n  background-color: #fff;\n  border: 0;\n  padding: 0 10px;\n}\n\n.lockscreen-footer {\n  margin-top: 10px;\n}\n\n.login-logo, .register-logo {\n  text-align: center;\n  margin-bottom: 25px;\n  font-size: 35px;\n  font-weight: 300;\n}\n\n.login-logo a, .register-logo a {\n  color: #444;\n}\n\n.login-page, .register-page {\n  background: #d2d6de;\n}\n\n.login-box, .register-box {\n  width: 360px;\n  margin: 7% auto;\n}\n\n@media (width <= 768px) {\n  .login-box, .register-box {\n    width: 90%;\n    margin-top: 20px;\n  }\n}\n\n.login-box-body, .register-box-body {\n  color: #666;\n  background: #fff;\n  border-top: 0;\n  padding: 20px;\n}\n\n.login-box-body .form-control-feedback, .register-box-body .form-control-feedback {\n  color: #777;\n}\n\n.login-box-msg, .register-box-msg {\n  text-align: center;\n  margin: 0;\n  padding: 0 20px 20px;\n}\n\n.social-auth-links {\n  margin: 10px 0;\n}\n\n.error-page {\n  width: 600px;\n  margin: 20px auto 0;\n}\n\n@media (width <= 991px) {\n  .error-page {\n    width: 100%;\n  }\n}\n\n.error-page > .headline {\n  float: left;\n  font-size: 100px;\n  font-weight: 300;\n}\n\n@media (width <= 991px) {\n  .error-page > .headline {\n    float: none;\n    text-align: center;\n  }\n}\n\n.error-page > .error-content {\n  margin-left: 190px;\n  display: block;\n}\n\n@media (width <= 991px) {\n  .error-page > .error-content {\n    margin-left: 0;\n  }\n}\n\n.error-page > .error-content > h3 {\n  font-size: 25px;\n  font-weight: 300;\n}\n\n@media (width <= 991px) {\n  .error-page > .error-content > h3 {\n    text-align: center;\n  }\n}\n\n.invoice {\n  background: #fff;\n  border: 1px solid #f4f4f4;\n  margin: 10px 25px;\n  padding: 20px;\n  position: relative;\n}\n\n.invoice-title {\n  margin-top: 0;\n}\n\n.profile-user-img {\n  border: 3px solid #d2d6de;\n  width: 100px;\n  margin: 0 auto;\n  padding: 3px;\n}\n\n.profile-username {\n  margin-top: 5px;\n  font-size: 21px;\n}\n\n.post {\n  color: #666;\n  border-bottom: 1px solid #d2d6de;\n  margin-bottom: 15px;\n  padding-bottom: 15px;\n}\n\n.post:last-of-type {\n  border-bottom: 0;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.post .user-block {\n  margin-bottom: 15px;\n}\n\n.btn-social {\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding-left: 44px;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-social > :first-child {\n  text-align: center;\n  border-right: 1px solid #0003;\n  width: 32px;\n  font-size: 1.6em;\n  line-height: 34px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.btn-social.btn-lg {\n  padding-left: 61px;\n}\n\n.btn-social.btn-lg > :first-child {\n  width: 45px;\n  font-size: 1.8em;\n  line-height: 45px;\n}\n\n.btn-social.btn-sm {\n  padding-left: 38px;\n}\n\n.btn-social.btn-sm > :first-child {\n  width: 28px;\n  font-size: 1.4em;\n  line-height: 28px;\n}\n\n.btn-social.btn-xs {\n  padding-left: 30px;\n}\n\n.btn-social.btn-xs > :first-child {\n  width: 20px;\n  font-size: 1.2em;\n  line-height: 20px;\n}\n\n.btn-social-icon {\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-social-icon > :first-child {\n  text-align: center;\n  border-right: 1px solid #0003;\n  width: 32px;\n  font-size: 1.6em;\n  line-height: 34px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.btn-social-icon.btn-lg {\n  padding-left: 61px;\n}\n\n.btn-social-icon.btn-lg > :first-child {\n  width: 45px;\n  font-size: 1.8em;\n  line-height: 45px;\n}\n\n.btn-social-icon.btn-sm {\n  padding-left: 38px;\n}\n\n.btn-social-icon.btn-sm > :first-child {\n  width: 28px;\n  font-size: 1.4em;\n  line-height: 28px;\n}\n\n.btn-social-icon.btn-xs {\n  padding-left: 30px;\n}\n\n.btn-social-icon.btn-xs > :first-child {\n  width: 20px;\n  font-size: 1.2em;\n  line-height: 20px;\n}\n\n.btn-social-icon > :first-child {\n  text-align: center;\n  border: none;\n  width: 100%;\n}\n\n.btn-social-icon.btn-lg {\n  width: 45px;\n  height: 45px;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.btn-social-icon.btn-sm {\n  width: 30px;\n  height: 30px;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.btn-social-icon.btn-xs {\n  width: 22px;\n  height: 22px;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.btn-adn {\n  color: #fff;\n  background-color: #d87a68;\n  border-color: #0003;\n}\n\n.btn-adn:focus, .btn-adn.focus, .btn-adn:hover {\n  color: #fff;\n  background-color: #ce563f;\n  border-color: #0003;\n}\n\n.btn-adn:active, .btn-adn.active, .open > .dropdown-toggle.btn-adn {\n  color: #fff;\n  background-color: #ce563f;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-adn .badge {\n  color: #d87a68;\n  background-color: #fff;\n}\n\n.btn-bitbucket {\n  color: #fff;\n  background-color: #205081;\n  border-color: #0003;\n}\n\n.btn-bitbucket:focus, .btn-bitbucket.focus, .btn-bitbucket:hover {\n  color: #fff;\n  background-color: #163758;\n  border-color: #0003;\n}\n\n.btn-bitbucket:active, .btn-bitbucket.active, .open > .dropdown-toggle.btn-bitbucket {\n  color: #fff;\n  background-color: #163758;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-bitbucket .badge {\n  color: #205081;\n  background-color: #fff;\n}\n\n.btn-dropbox {\n  color: #fff;\n  background-color: #1087dd;\n  border-color: #0003;\n}\n\n.btn-dropbox:focus, .btn-dropbox.focus, .btn-dropbox:hover {\n  color: #fff;\n  background-color: #0d6aad;\n  border-color: #0003;\n}\n\n.btn-dropbox:active, .btn-dropbox.active, .open > .dropdown-toggle.btn-dropbox {\n  color: #fff;\n  background-color: #0d6aad;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-dropbox .badge {\n  color: #1087dd;\n  background-color: #fff;\n}\n\n.btn-facebook {\n  color: #fff;\n  background-color: #3b5998;\n  border-color: #0003;\n}\n\n.btn-facebook:focus, .btn-facebook.focus, .btn-facebook:hover {\n  color: #fff;\n  background-color: #2d4373;\n  border-color: #0003;\n}\n\n.btn-facebook:active, .btn-facebook.active, .open > .dropdown-toggle.btn-facebook {\n  color: #fff;\n  background-color: #2d4373;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-facebook .badge {\n  color: #3b5998;\n  background-color: #fff;\n}\n\n.btn-flickr {\n  color: #fff;\n  background-color: #ff0084;\n  border-color: #0003;\n}\n\n.btn-flickr:focus, .btn-flickr.focus, .btn-flickr:hover {\n  color: #fff;\n  background-color: #cc006a;\n  border-color: #0003;\n}\n\n.btn-flickr:active, .btn-flickr.active, .open > .dropdown-toggle.btn-flickr {\n  color: #fff;\n  background-color: #cc006a;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-flickr .badge {\n  color: #ff0084;\n  background-color: #fff;\n}\n\n.btn-foursquare {\n  color: #fff;\n  background-color: #f94877;\n  border-color: #0003;\n}\n\n.btn-foursquare:focus, .btn-foursquare.focus, .btn-foursquare:hover {\n  color: #fff;\n  background-color: #f71752;\n  border-color: #0003;\n}\n\n.btn-foursquare:active, .btn-foursquare.active, .open > .dropdown-toggle.btn-foursquare {\n  color: #fff;\n  background-color: #f71752;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-foursquare .badge {\n  color: #f94877;\n  background-color: #fff;\n}\n\n.btn-github {\n  color: #fff;\n  background-color: #444;\n  border-color: #0003;\n}\n\n.btn-github:focus, .btn-github.focus, .btn-github:hover {\n  color: #fff;\n  background-color: #2b2b2b;\n  border-color: #0003;\n}\n\n.btn-github:active, .btn-github.active, .open > .dropdown-toggle.btn-github {\n  color: #fff;\n  background-color: #2b2b2b;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-github .badge {\n  color: #444;\n  background-color: #fff;\n}\n\n.btn-google {\n  color: #fff;\n  background-color: #dd4b39;\n  border-color: #0003;\n}\n\n.btn-google:focus, .btn-google.focus, .btn-google:hover {\n  color: #fff;\n  background-color: #c23321;\n  border-color: #0003;\n}\n\n.btn-google:active, .btn-google.active, .open > .dropdown-toggle.btn-google {\n  color: #fff;\n  background-color: #c23321;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-google .badge {\n  color: #dd4b39;\n  background-color: #fff;\n}\n\n.btn-instagram {\n  color: #fff;\n  background-color: #3f729b;\n  border-color: #0003;\n}\n\n.btn-instagram:focus, .btn-instagram.focus, .btn-instagram:hover {\n  color: #fff;\n  background-color: #305777;\n  border-color: #0003;\n}\n\n.btn-instagram:active, .btn-instagram.active, .open > .dropdown-toggle.btn-instagram {\n  color: #fff;\n  background-color: #305777;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-instagram .badge {\n  color: #3f729b;\n  background-color: #fff;\n}\n\n.btn-linkedin {\n  color: #fff;\n  background-color: #007bb6;\n  border-color: #0003;\n}\n\n.btn-linkedin:focus, .btn-linkedin.focus, .btn-linkedin:hover {\n  color: #fff;\n  background-color: #005983;\n  border-color: #0003;\n}\n\n.btn-linkedin:active, .btn-linkedin.active, .open > .dropdown-toggle.btn-linkedin {\n  color: #fff;\n  background-color: #005983;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-linkedin .badge {\n  color: #007bb6;\n  background-color: #fff;\n}\n\n.btn-microsoft {\n  color: #fff;\n  background-color: #2672ec;\n  border-color: #0003;\n}\n\n.btn-microsoft:focus, .btn-microsoft.focus, .btn-microsoft:hover {\n  color: #fff;\n  background-color: #125acd;\n  border-color: #0003;\n}\n\n.btn-microsoft:active, .btn-microsoft.active, .open > .dropdown-toggle.btn-microsoft {\n  color: #fff;\n  background-color: #125acd;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-microsoft .badge {\n  color: #2672ec;\n  background-color: #fff;\n}\n\n.btn-openid {\n  color: #fff;\n  background-color: #f7931e;\n  border-color: #0003;\n}\n\n.btn-openid:focus, .btn-openid.focus, .btn-openid:hover {\n  color: #fff;\n  background-color: #da7908;\n  border-color: #0003;\n}\n\n.btn-openid:active, .btn-openid.active, .open > .dropdown-toggle.btn-openid {\n  color: #fff;\n  background-color: #da7908;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-openid .badge {\n  color: #f7931e;\n  background-color: #fff;\n}\n\n.btn-pinterest {\n  color: #fff;\n  background-color: #cb2027;\n  border-color: #0003;\n}\n\n.btn-pinterest:focus, .btn-pinterest.focus, .btn-pinterest:hover {\n  color: #fff;\n  background-color: #9f191f;\n  border-color: #0003;\n}\n\n.btn-pinterest:active, .btn-pinterest.active, .open > .dropdown-toggle.btn-pinterest {\n  color: #fff;\n  background-color: #9f191f;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-pinterest .badge {\n  color: #cb2027;\n  background-color: #fff;\n}\n\n.btn-reddit {\n  color: #000;\n  background-color: #eff7ff;\n  border-color: #0003;\n}\n\n.btn-reddit:focus, .btn-reddit.focus, .btn-reddit:hover {\n  color: #000;\n  background-color: #bcddff;\n  border-color: #0003;\n}\n\n.btn-reddit:active, .btn-reddit.active, .open > .dropdown-toggle.btn-reddit {\n  color: #000;\n  background-color: #bcddff;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-reddit .badge {\n  color: #eff7ff;\n  background-color: #000;\n}\n\n.btn-soundcloud {\n  color: #fff;\n  background-color: #f50;\n  border-color: #0003;\n}\n\n.btn-soundcloud:focus, .btn-soundcloud.focus, .btn-soundcloud:hover {\n  color: #fff;\n  background-color: #c40;\n  border-color: #0003;\n}\n\n.btn-soundcloud:active, .btn-soundcloud.active, .open > .dropdown-toggle.btn-soundcloud {\n  color: #fff;\n  background-color: #c40;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-soundcloud .badge {\n  color: #f50;\n  background-color: #fff;\n}\n\n.btn-tumblr {\n  color: #fff;\n  background-color: #2c4762;\n  border-color: #0003;\n}\n\n.btn-tumblr:focus, .btn-tumblr.focus, .btn-tumblr:hover {\n  color: #fff;\n  background-color: #1c2d3f;\n  border-color: #0003;\n}\n\n.btn-tumblr:active, .btn-tumblr.active, .open > .dropdown-toggle.btn-tumblr {\n  color: #fff;\n  background-color: #1c2d3f;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-tumblr .badge {\n  color: #2c4762;\n  background-color: #fff;\n}\n\n.btn-twitter {\n  color: #fff;\n  background-color: #55acee;\n  border-color: #0003;\n}\n\n.btn-twitter:focus, .btn-twitter.focus, .btn-twitter:hover {\n  color: #fff;\n  background-color: #2795e9;\n  border-color: #0003;\n}\n\n.btn-twitter:active, .btn-twitter.active, .open > .dropdown-toggle.btn-twitter {\n  color: #fff;\n  background-color: #2795e9;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-twitter .badge {\n  color: #55acee;\n  background-color: #fff;\n}\n\n.btn-vimeo {\n  color: #fff;\n  background-color: #1ab7ea;\n  border-color: #0003;\n}\n\n.btn-vimeo:focus, .btn-vimeo.focus, .btn-vimeo:hover {\n  color: #fff;\n  background-color: #1295bf;\n  border-color: #0003;\n}\n\n.btn-vimeo:active, .btn-vimeo.active, .open > .dropdown-toggle.btn-vimeo {\n  color: #fff;\n  background-color: #1295bf;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-vimeo .badge {\n  color: #1ab7ea;\n  background-color: #fff;\n}\n\n.btn-vk {\n  color: #fff;\n  background-color: #587ea3;\n  border-color: #0003;\n}\n\n.btn-vk:focus, .btn-vk.focus, .btn-vk:hover {\n  color: #fff;\n  background-color: #466482;\n  border-color: #0003;\n}\n\n.btn-vk:active, .btn-vk.active, .open > .dropdown-toggle.btn-vk {\n  color: #fff;\n  background-color: #466482;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-vk .badge {\n  color: #587ea3;\n  background-color: #fff;\n}\n\n.btn-yahoo {\n  color: #fff;\n  background-color: #720e9e;\n  border-color: #0003;\n}\n\n.btn-yahoo:focus, .btn-yahoo.focus, .btn-yahoo:hover {\n  color: #fff;\n  background-color: #500a6f;\n  border-color: #0003;\n}\n\n.btn-yahoo:active, .btn-yahoo.active, .open > .dropdown-toggle.btn-yahoo {\n  color: #fff;\n  background-color: #500a6f;\n  background-image: none;\n  border-color: #0003;\n}\n\n.btn-yahoo .badge {\n  color: #720e9e;\n  background-color: #fff;\n}\n\n.fc-button {\n  color: #444;\n  background: #f4f4f4;\n  border-color: #ddd;\n}\n\n.fc-button:hover, .fc-button:active, .fc-button.hover {\n  background-color: #e9e9e9;\n}\n\n.fc-header-title h2 {\n  color: #666;\n  margin-left: 10px;\n  font-size: 15px;\n  line-height: 1.6em;\n}\n\n.fc-header-right {\n  padding-right: 10px;\n}\n\n.fc-header-left {\n  padding-left: 10px;\n}\n\n.fc-widget-header {\n  background: #fafafa;\n}\n\n.fc-grid {\n  border: 0;\n  width: 100%;\n}\n\n.fc-widget-header:first-of-type, .fc-widget-content:first-of-type {\n  border-left: 0;\n  border-right: 0;\n}\n\n.fc-widget-header:last-of-type, .fc-widget-content:last-of-type {\n  border-right: 0;\n}\n\n.fc-toolbar {\n  margin: 0;\n  padding: 10px;\n}\n\n.fc-day-number {\n  padding-right: 10px;\n  font-size: 20px;\n  font-weight: 300;\n}\n\n.fc-color-picker {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.fc-color-picker > li {\n  float: left;\n  margin-right: 5px;\n  font-size: 30px;\n  line-height: 30px;\n}\n\n.fc-color-picker > li .fa {\n  transition: transform .3s linear;\n}\n\n.fc-color-picker > li .fa:hover {\n  transform: rotate(30deg);\n}\n\n#add-new-event {\n  transition: all .3s linear;\n}\n\n.external-event {\n  text-shadow: 0 1px 1px #0000001a;\n  cursor: move;\n  border-radius: 3px;\n  margin-bottom: 4px;\n  padding: 5px 10px;\n  font-weight: 700;\n  box-shadow: 0 1px 1px #0000001a;\n}\n\n.external-event:hover {\n  box-shadow: inset 0 0 90px #0003;\n}\n\n.select2-container--default.select2-container--focus, .select2-selection.select2-container--focus, .select2-container--default:focus, .select2-selection:focus, .select2-container--default:active, .select2-selection:active {\n  outline: none;\n}\n\n.select2-container--default .select2-selection--single, .select2-selection .select2-selection--single {\n  border: 1px solid #d2d6de;\n  border-radius: 0;\n  height: 34px;\n  padding: 6px 12px;\n}\n\n.select2-container--default.select2-container--open {\n  border-color: #3c8dbc;\n}\n\n.select2-dropdown {\n  border: 1px solid #d2d6de;\n  border-radius: 0;\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  color: #fff;\n  background-color: #3c8dbc;\n}\n\n.select2-results__option {\n  -webkit-user-select: none;\n  user-select: none;\n  padding: 6px 12px;\n}\n\n.select2-container .select2-selection--single .select2-selection__rendered {\n  height: auto;\n  margin-top: -4px;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.select2-container[dir=\"rtl\"] .select2-selection--single .select2-selection__rendered {\n  padding-left: 20px;\n  padding-right: 6px;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n  height: 28px;\n  right: 3px;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n  margin-top: 0;\n}\n\n.select2-dropdown .select2-search__field, .select2-search--inline .select2-search__field {\n  border: 1px solid #d2d6de;\n}\n\n.select2-dropdown .select2-search__field:focus, .select2-search--inline .select2-search__field:focus {\n  border: 1px solid #3c8dbc;\n  outline: none;\n}\n\n.select2-container--default .select2-results__option[aria-disabled=\"true\"] {\n  color: #999;\n}\n\n.select2-container--default .select2-results__option[aria-selected=\"true\"] {\n  background-color: #ddd;\n}\n\n.select2-container--default .select2-results__option[aria-selected=\"true\"], .select2-container--default .select2-results__option[aria-selected=\"true\"]:hover {\n  color: #444;\n}\n\n.select2-container--default .select2-selection--multiple {\n  border: 1px solid #d2d6de;\n  border-radius: 0;\n}\n\n.select2-container--default .select2-selection--multiple:focus {\n  border-color: #3c8dbc;\n}\n\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n  border-color: #d2d6de;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n  color: #fff;\n  background-color: #3c8dbc;\n  border-color: #367fa9;\n  padding: 1px 10px;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n  color: #ffffffb3;\n  margin-right: 5px;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover {\n  color: #fff;\n}\n\n.select2-container .select2-selection--single .select2-selection__rendered {\n  padding-right: 10px;\n}\n\n.pad {\n  padding: 10px;\n}\n\n.margin {\n  margin: 10px;\n}\n\n.margin-bottom {\n  margin-bottom: 20px;\n}\n\n.margin-bottom-none {\n  margin-bottom: 0;\n}\n\n.margin-r-5 {\n  margin-right: 5px;\n}\n\n.inline {\n  display: inline;\n}\n\n.description-block {\n  text-align: center;\n  margin: 10px 0;\n  display: block;\n}\n\n.description-block.margin-bottom {\n  margin-bottom: 25px;\n}\n\n.description-block > .description-header {\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.description-block > .description-text {\n  text-transform: uppercase;\n}\n\n.bg-red, .bg-yellow, .bg-aqua, .bg-blue, .bg-light-blue, .bg-green, .bg-navy, .bg-teal, .bg-olive, .bg-lime, .bg-orange, .bg-fuchsia, .bg-purple, .bg-maroon, .bg-black, .bg-red-active, .bg-yellow-active, .bg-aqua-active, .bg-blue-active, .bg-light-blue-active, .bg-green-active, .bg-navy-active, .bg-teal-active, .bg-olive-active, .bg-lime-active, .bg-orange-active, .bg-fuchsia-active, .bg-purple-active, .bg-maroon-active, .bg-black-active, .callout.callout-danger, .callout.callout-warning, .callout.callout-info, .callout.callout-success, .alert-success, .alert-danger, .alert-error, .alert-warning, .alert-info, .label-danger, .label-info, .label-warning, .label-primary, .label-success, .modal-primary .modal-body, .modal-primary .modal-header, .modal-primary .modal-footer, .modal-warning .modal-body, .modal-warning .modal-header, .modal-warning .modal-footer, .modal-info .modal-body, .modal-info .modal-header, .modal-info .modal-footer, .modal-success .modal-body, .modal-success .modal-header, .modal-success .modal-footer, .modal-danger .modal-body, .modal-danger .modal-header, .modal-danger .modal-footer {\n  color: #fff !important;\n}\n\n.bg-gray {\n  color: #000;\n  background-color: #d2d6de !important;\n}\n\n.bg-gray-light {\n  background-color: #f7f7f7;\n}\n\n.bg-black {\n  background-color: #111 !important;\n}\n\n.bg-red, .callout.callout-danger, .alert-danger, .alert-error, .label-danger, .modal-danger .modal-body {\n  background-color: #dd4b39 !important;\n}\n\n.bg-yellow, .callout.callout-warning, .alert-warning, .label-warning, .modal-warning .modal-body {\n  background-color: #f39c12 !important;\n}\n\n.bg-aqua, .callout.callout-info, .alert-info, .label-info, .modal-info .modal-body {\n  background-color: #00c0ef !important;\n}\n\n.bg-blue {\n  background-color: #0073b7 !important;\n}\n\n.bg-light-blue, .label-primary, .modal-primary .modal-body {\n  background-color: #3c8dbc !important;\n}\n\n.bg-green, .callout.callout-success, .alert-success, .label-success, .modal-success .modal-body {\n  background-color: #00a65a !important;\n}\n\n.bg-navy {\n  background-color: #001f3f !important;\n}\n\n.bg-teal {\n  background-color: #39cccc !important;\n}\n\n.bg-olive {\n  background-color: #3d9970 !important;\n}\n\n.bg-lime {\n  background-color: #01ff70 !important;\n}\n\n.bg-orange {\n  background-color: #ff851b !important;\n}\n\n.bg-fuchsia {\n  background-color: #f012be !important;\n}\n\n.bg-purple {\n  background-color: #6c7e9d !important;\n}\n\n.bg-maroon {\n  background-color: #d81b60 !important;\n}\n\n.bg-gray-active {\n  color: #000;\n  background-color: #b5bbc8 !important;\n}\n\n.bg-black-active {\n  background-color: #000 !important;\n}\n\n.bg-red-active, .modal-danger .modal-header, .modal-danger .modal-footer {\n  background-color: #d33724 !important;\n}\n\n.bg-yellow-active, .modal-warning .modal-header, .modal-warning .modal-footer {\n  background-color: #db8b0b !important;\n}\n\n.bg-aqua-active, .modal-info .modal-header, .modal-info .modal-footer {\n  background-color: #00a7d0 !important;\n}\n\n.bg-blue-active {\n  background-color: #005384 !important;\n}\n\n.bg-light-blue-active, .modal-primary .modal-header, .modal-primary .modal-footer {\n  background-color: #357ca5 !important;\n}\n\n.bg-green-active, .modal-success .modal-header, .modal-success .modal-footer {\n  background-color: #008d4c !important;\n}\n\n.bg-navy-active {\n  background-color: #001a35 !important;\n}\n\n.bg-teal-active {\n  background-color: #30bbbb !important;\n}\n\n.bg-olive-active {\n  background-color: #368763 !important;\n}\n\n.bg-lime-active {\n  background-color: #00e765 !important;\n}\n\n.bg-orange-active {\n  background-color: #ff7701 !important;\n}\n\n.bg-fuchsia-active {\n  background-color: #db0ead !important;\n}\n\n.bg-purple-active {\n  background-color: #536584 !important;\n}\n\n.bg-maroon-active {\n  background-color: #ca195a !important;\n}\n\n[class^=\"bg-\"].disabled {\n  opacity: .65;\n  filter: alpha(opacity= 65);\n}\n\n.text-red {\n  color: #dd4b39 !important;\n}\n\n.text-yellow {\n  color: #f39c12 !important;\n}\n\n.text-aqua {\n  color: #00c0ef !important;\n}\n\n.text-black {\n  color: #111 !important;\n}\n\n.text-light-blue {\n  color: #3c8dbc !important;\n}\n\n.text-green {\n  color: #00a65a !important;\n}\n\n.text-gray {\n  color: #d2d6de !important;\n}\n\n.text-navy {\n  color: #001f3f !important;\n}\n\n.text-teal {\n  color: #39cccc !important;\n}\n\n.text-olive {\n  color: #3d9970 !important;\n}\n\n.text-lime {\n  color: #01ff70 !important;\n}\n\n.text-orange {\n  color: #ff851b !important;\n}\n\n.text-fuchsia {\n  color: #f012be !important;\n}\n\n.text-purple {\n  color: #6c7e9d !important;\n}\n\n.text-maroon {\n  color: #d81b60 !important;\n}\n\n.link-muted {\n  color: #7a869d;\n}\n\n.link-muted:hover, .link-muted:focus {\n  color: #606c84;\n}\n\n.link-black {\n  color: #666;\n}\n\n.link-black:hover, .link-black:focus {\n  color: #999;\n}\n\n.hide {\n  display: none !important;\n}\n\n.no-border {\n  border: 0 !important;\n}\n\n.no-padding {\n  padding: 0 !important;\n}\n\n.no-margin {\n  margin: 0 !important;\n}\n\n.no-shadow {\n  box-shadow: none !important;\n}\n\n.list-unstyled, .chart-legend, .contacts-list, .users-list, .mailbox-attachments {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.list-group-unbordered > .list-group-item {\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.flat {\n  border-radius: 0 !important;\n}\n\n.text-bold, .text-bold.table td, .text-bold.table th {\n  font-weight: 700;\n}\n\n.text-sm {\n  font-size: 12px;\n}\n\n.jqstooltip {\n  width: auto !important;\n  height: auto !important;\n  padding: 5px !important;\n}\n\n.bg-teal-gradient {\n  color: #fff;\n  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= \"#7adddd\", endColorstr= \"#39cccc\", GradientType= 0) !important;\n  background: -o-linear-gradient(#7adddd, #39cccc) !important;\n}\n\n.bg-light-blue-gradient {\n  color: #fff;\n  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= \"#67a8ce\", endColorstr= \"#3c8dbc\", GradientType= 0) !important;\n  background: -o-linear-gradient(#67a8ce, #3c8dbc) !important;\n}\n\n.bg-blue-gradient {\n  color: #fff;\n  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= \"#0089db\", endColorstr= \"#0073b7\", GradientType= 0) !important;\n  background: -o-linear-gradient(#0089db, #0073b7) !important;\n}\n\n.bg-aqua-gradient {\n  color: #fff;\n  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= \"#14d1ff\", endColorstr= \"#00c0ef\", GradientType= 0) !important;\n  background: -o-linear-gradient(#14d1ff, #00c0ef) !important;\n}\n\n.bg-yellow-gradient {\n  color: #fff;\n  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= \"#f7bc60\", endColorstr= \"#f39c12\", GradientType= 0) !important;\n  background: -o-linear-gradient(#f7bc60, #f39c12) !important;\n}\n\n.bg-purple-gradient {\n  color: #fff;\n  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= \"#9491c4\", endColorstr= \"#6c7e9d\", GradientType= 0) !important;\n  background: -o-linear-gradient(#9491c4, #6c7e9d) !important;\n}\n\n.bg-green-gradient {\n  color: #fff;\n  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= \"#00ca6d\", endColorstr= \"#00a65a\", GradientType= 0) !important;\n  background: -o-linear-gradient(#00ca6d, #00a65a) !important;\n}\n\n.bg-red-gradient {\n  color: #fff;\n  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= \"#e47365\", endColorstr= \"#dd4b39\", GradientType= 0) !important;\n  background: -o-linear-gradient(#e47365, #dd4b39) !important;\n}\n\n.bg-black-gradient {\n  color: #fff;\n  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= \"#2b2b2b\", endColorstr= \"#111111\", GradientType= 0) !important;\n  background: -o-linear-gradient(#2b2b2b, #111) !important;\n}\n\n.bg-maroon-gradient {\n  color: #fff;\n  filter: progid:DXImageTransform. Microsoft. gradient(startColorstr= \"#e73f7c\", endColorstr= \"#d81b60\", GradientType= 0) !important;\n  background: -o-linear-gradient(#e73f7c, #d81b60) !important;\n}\n\n.description-block .description-icon {\n  font-size: 16px;\n}\n\n.no-pad-top {\n  padding-top: 0;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.list-header {\n  color: #666;\n  padding: 10px 4px;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.list-seperator {\n  background: #f4f4f4;\n  height: 1px;\n  margin: 15px 0 9px;\n}\n\n.list-link > a {\n  color: #777;\n  padding: 4px;\n}\n\n.list-link > a:hover {\n  color: #222;\n}\n\n.font-light {\n  font-weight: 300;\n}\n\n.user-block:before, .user-block:after {\n  content: \" \";\n  display: table;\n}\n\n.user-block:after {\n  clear: both;\n}\n\n.user-block img {\n  float: left;\n  width: 40px;\n  height: 40px;\n}\n\n.user-block .username, .user-block .description, .user-block .comment {\n  margin-left: 50px;\n  display: block;\n}\n\n.user-block .username {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.user-block .description {\n  color: #999;\n  font-size: 13px;\n}\n\n.user-block.user-block-sm .username, .user-block.user-block-sm .description, .user-block.user-block-sm .comment {\n  margin-left: 40px;\n}\n\n.user-block.user-block-sm .username {\n  font-size: 14px;\n}\n\n.img-sm, .img-md, .img-lg, .box-comments .box-comment img, .user-block.user-block-sm img {\n  float: left;\n}\n\n.img-sm, .box-comments .box-comment img, .user-block.user-block-sm img {\n  width: 30px !important;\n  height: 30px !important;\n}\n\n.img-sm + .img-push {\n  margin-left: 40px;\n}\n\n.img-md {\n  width: 60px;\n  height: 60px;\n}\n\n.img-md + .img-push {\n  margin-left: 70px;\n}\n\n.img-lg {\n  width: 100px;\n  height: 100px;\n}\n\n.img-lg + .img-push {\n  margin-left: 110px;\n}\n\n.img-bordered {\n  border: 3px solid #d2d6de;\n  padding: 3px;\n}\n\n.img-bordered-sm {\n  border: 2px solid #d2d6de;\n  padding: 2px;\n}\n\n.attachment-block {\n  background: #f7f7f7;\n  border: 1px solid #f4f4f4;\n  margin-bottom: 10px;\n  padding: 5px;\n}\n\n.attachment-block .attachment-img {\n  float: left;\n  max-width: 100px;\n  height: auto;\n  max-height: 100px;\n}\n\n.attachment-block .attachment-pushed {\n  margin-left: 110px;\n}\n\n.attachment-block .attachment-heading {\n  margin: 0;\n}\n\n.attachment-block .attachment-text {\n  color: #555;\n}\n\n.connectedSortable {\n  min-height: 100px;\n}\n\n.ui-helper-hidden-accessible {\n  clip: rect(0 0 0 0);\n  border: 0;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  position: absolute;\n  overflow: hidden;\n}\n\n.sort-highlight {\n  background: #f4f4f4;\n  border: 1px dashed #ddd;\n  margin-bottom: 10px;\n}\n\n.full-opacity-hover {\n  opacity: .65;\n  filter: alpha(opacity= 65);\n}\n\n.full-opacity-hover:hover {\n  opacity: 1;\n  filter: alpha(opacity= 100);\n}\n\n.chart {\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.chart svg, .chart canvas {\n  width: 100% !important;\n}\n\n@media print {\n  .no-print, .left-side, .main-header, .content-header {\n    display: none !important;\n  }\n\n  .content-wrapper, .right-side, .main-footer {\n    min-height: 0 !important;\n    margin-left: 0 !important;\n    transform: translate(0) !important;\n  }\n\n  .fixed .content-wrapper, .fixed .right-side {\n    padding-top: 0 !important;\n  }\n\n  .invoice {\n    border: 0;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n  }\n\n  .invoice-col {\n    float: left;\n    width: 33.3333%;\n  }\n\n  .table-responsive {\n    overflow: auto;\n  }\n\n  .table-responsive > .table tr th, .table-responsive > .table tr td {\n    white-space: normal !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
